
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ivbvd", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("5H6ys")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("g5Fvc")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("f3Ila")).LitElement);
$parcel$export(module.exports, "nothing", () => (parcelRequire("g5Fvc")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("g5Fvc")).render);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("5H6ys")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("5H6ys")).unsafeCSS);
parcelRequire("AKSXg");
parcelRequire("g5Fvc");
parcelRequire("f3Ila");
parcelRequire("7aGil");

});
parcelRegister("AKSXg", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $06e7bb5d8e366a40$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("5H6ys")).css);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("5H6ys")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("5H6ys")).unsafeCSS);

var $5H6ys = parcelRequire("5H6ys");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $06e7bb5d8e366a40$var$s;
const $06e7bb5d8e366a40$var$e = window, $06e7bb5d8e366a40$var$r = $06e7bb5d8e366a40$var$e.trustedTypes, $06e7bb5d8e366a40$var$h = $06e7bb5d8e366a40$var$r ? $06e7bb5d8e366a40$var$r.emptyScript : "", $06e7bb5d8e366a40$var$o = $06e7bb5d8e366a40$var$e.reactiveElementPolyfillSupport, $06e7bb5d8e366a40$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $06e7bb5d8e366a40$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $06e7bb5d8e366a40$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $06e7bb5d8e366a40$var$l = {
    attribute: !0,
    type: String,
    converter: $06e7bb5d8e366a40$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $06e7bb5d8e366a40$export$53a6892c50694894
};
class $06e7bb5d8e366a40$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $06e7bb5d8e366a40$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $06e7bb5d8e366a40$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $5H6ys.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $5H6ys.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $5H6ys.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $06e7bb5d8e366a40$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $06e7bb5d8e366a40$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $06e7bb5d8e366a40$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $06e7bb5d8e366a40$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
}
$06e7bb5d8e366a40$export$c7c07a37856565d.finalized = !0, $06e7bb5d8e366a40$export$c7c07a37856565d.elementProperties = new Map, $06e7bb5d8e366a40$export$c7c07a37856565d.elementStyles = [], $06e7bb5d8e366a40$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $06e7bb5d8e366a40$var$o || $06e7bb5d8e366a40$var$o({
    ReactiveElement: $06e7bb5d8e366a40$export$c7c07a37856565d
}), (null !== ($06e7bb5d8e366a40$var$s = $06e7bb5d8e366a40$var$e.reactiveElementVersions) && void 0 !== $06e7bb5d8e366a40$var$s ? $06e7bb5d8e366a40$var$s : $06e7bb5d8e366a40$var$e.reactiveElementVersions = []).push("1.6.1");

});
parcelRegister("5H6ys", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $42560d8bc082fbf7$export$b4d10f6001c083c2);
$parcel$export(module.exports, "unsafeCSS", () => $42560d8bc082fbf7$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $42560d8bc082fbf7$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $42560d8bc082fbf7$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $42560d8bc082fbf7$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $42560d8bc082fbf7$var$t = window, $42560d8bc082fbf7$export$b4d10f6001c083c2 = $42560d8bc082fbf7$var$t.ShadowRoot && (void 0 === $42560d8bc082fbf7$var$t.ShadyCSS || $42560d8bc082fbf7$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $42560d8bc082fbf7$var$s = Symbol(), $42560d8bc082fbf7$var$n = new WeakMap;
class $42560d8bc082fbf7$export$505d1e8739bad805 {
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($42560d8bc082fbf7$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $42560d8bc082fbf7$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $42560d8bc082fbf7$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $42560d8bc082fbf7$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
}
const $42560d8bc082fbf7$export$8d80f9cac07cdb3 = (t)=>new $42560d8bc082fbf7$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $42560d8bc082fbf7$var$s), $42560d8bc082fbf7$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $42560d8bc082fbf7$export$505d1e8739bad805(n, t, $42560d8bc082fbf7$var$s);
}, $42560d8bc082fbf7$export$2ca4a66ec4cecb90 = (s, n)=>{
    $42560d8bc082fbf7$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $42560d8bc082fbf7$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $42560d8bc082fbf7$export$ee69dfd951e24778 = $42560d8bc082fbf7$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $42560d8bc082fbf7$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("g5Fvc", function(module, exports) {

$parcel$export(module.exports, "html", () => $bb6d4e6d0376d66c$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $bb6d4e6d0376d66c$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $bb6d4e6d0376d66c$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $bb6d4e6d0376d66c$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $bb6d4e6d0376d66c$var$t;
const $bb6d4e6d0376d66c$var$i = window, $bb6d4e6d0376d66c$var$s = $bb6d4e6d0376d66c$var$i.trustedTypes, $bb6d4e6d0376d66c$var$e = $bb6d4e6d0376d66c$var$s ? $bb6d4e6d0376d66c$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $bb6d4e6d0376d66c$var$o = "$lit$", $bb6d4e6d0376d66c$var$n = `lit$${(Math.random() + "").slice(9)}$`, $bb6d4e6d0376d66c$var$l = "?" + $bb6d4e6d0376d66c$var$n, $bb6d4e6d0376d66c$var$h = `<${$bb6d4e6d0376d66c$var$l}>`, $bb6d4e6d0376d66c$var$r = document, $bb6d4e6d0376d66c$var$d = ()=>$bb6d4e6d0376d66c$var$r.createComment(""), $bb6d4e6d0376d66c$var$u = (t)=>null === t || "object" != typeof t && "function" != typeof t, $bb6d4e6d0376d66c$var$c = Array.isArray, $bb6d4e6d0376d66c$var$v = (t)=>$bb6d4e6d0376d66c$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $bb6d4e6d0376d66c$var$a = "[ 	\n\f\r]", $bb6d4e6d0376d66c$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $bb6d4e6d0376d66c$var$_ = /-->/g, $bb6d4e6d0376d66c$var$m = />/g, $bb6d4e6d0376d66c$var$p = RegExp(`>|${$bb6d4e6d0376d66c$var$a}(?:([^\\s"'>=/]+)(${$bb6d4e6d0376d66c$var$a}*=${$bb6d4e6d0376d66c$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $bb6d4e6d0376d66c$var$g = /'/g, $bb6d4e6d0376d66c$var$$ = /"/g, $bb6d4e6d0376d66c$var$y = /^(?:script|style|textarea|title)$/i, $bb6d4e6d0376d66c$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $bb6d4e6d0376d66c$export$c0bb0b647f701bb5 = $bb6d4e6d0376d66c$var$w(1), $bb6d4e6d0376d66c$export$7ed1367e7fa1ad68 = $bb6d4e6d0376d66c$var$w(2), $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $bb6d4e6d0376d66c$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $bb6d4e6d0376d66c$var$E = new WeakMap, $bb6d4e6d0376d66c$var$C = $bb6d4e6d0376d66c$var$r.createTreeWalker($bb6d4e6d0376d66c$var$r, 129, null, !1), $bb6d4e6d0376d66c$var$P = (t, i)=>{
    const s = t.length - 1, l = [];
    let r, d = 2 === i ? "<svg>" : "", u = $bb6d4e6d0376d66c$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let e, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $bb6d4e6d0376d66c$var$f ? "!--" === c[1] ? u = $bb6d4e6d0376d66c$var$_ : void 0 !== c[1] ? u = $bb6d4e6d0376d66c$var$m : void 0 !== c[2] ? ($bb6d4e6d0376d66c$var$y.test(c[2]) && (r = RegExp("</" + c[2], "g")), u = $bb6d4e6d0376d66c$var$p) : void 0 !== c[3] && (u = $bb6d4e6d0376d66c$var$p) : u === $bb6d4e6d0376d66c$var$p ? ">" === c[0] ? (u = null != r ? r : $bb6d4e6d0376d66c$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, e = c[1], u = void 0 === c[3] ? $bb6d4e6d0376d66c$var$p : '"' === c[3] ? $bb6d4e6d0376d66c$var$$ : $bb6d4e6d0376d66c$var$g) : u === $bb6d4e6d0376d66c$var$$ || u === $bb6d4e6d0376d66c$var$g ? u = $bb6d4e6d0376d66c$var$p : u === $bb6d4e6d0376d66c$var$_ || u === $bb6d4e6d0376d66c$var$m ? u = $bb6d4e6d0376d66c$var$f : (u = $bb6d4e6d0376d66c$var$p, r = void 0);
        const w = u === $bb6d4e6d0376d66c$var$p && t[i + 1].startsWith("/>") ? " " : "";
        d += u === $bb6d4e6d0376d66c$var$f ? s + $bb6d4e6d0376d66c$var$h : v >= 0 ? (l.push(e), s.slice(0, v) + $bb6d4e6d0376d66c$var$o + s.slice(v) + $bb6d4e6d0376d66c$var$n + w) : s + $bb6d4e6d0376d66c$var$n + (-2 === v ? (l.push(void 0), i) : w);
    }
    const c = d + (t[s] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $bb6d4e6d0376d66c$var$e ? $bb6d4e6d0376d66c$var$e.createHTML(c) : c,
        l
    ];
};
class $bb6d4e6d0376d66c$var$V {
    static createElement(t, i) {
        const s = $bb6d4e6d0376d66c$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, u = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $bb6d4e6d0376d66c$var$P(t, i);
        if (this.el = $bb6d4e6d0376d66c$var$V.createElement(a, e), $bb6d4e6d0376d66c$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $bb6d4e6d0376d66c$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($bb6d4e6d0376d66c$var$o) || i.startsWith($bb6d4e6d0376d66c$var$n)) {
                        const s = f[u++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $bb6d4e6d0376d66c$var$o).split($bb6d4e6d0376d66c$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $bb6d4e6d0376d66c$var$k : "?" === i[1] ? $bb6d4e6d0376d66c$var$I : "@" === i[1] ? $bb6d4e6d0376d66c$var$L : $bb6d4e6d0376d66c$var$R
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($bb6d4e6d0376d66c$var$y.test(h.tagName)) {
                    const t = h.textContent.split($bb6d4e6d0376d66c$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $bb6d4e6d0376d66c$var$s ? $bb6d4e6d0376d66c$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $bb6d4e6d0376d66c$var$d()), $bb6d4e6d0376d66c$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $bb6d4e6d0376d66c$var$d());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $bb6d4e6d0376d66c$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($bb6d4e6d0376d66c$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $bb6d4e6d0376d66c$var$n.length - 1;
                }
            }
            r++;
        }
    }
}
function $bb6d4e6d0376d66c$var$N(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const d = $bb6d4e6d0376d66c$var$u(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== d && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === d ? r = void 0 : (r = new d(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $bb6d4e6d0376d66c$var$N(t, r._$AS(t, i.values), r, e)), i;
}
class $bb6d4e6d0376d66c$var$S {
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $bb6d4e6d0376d66c$var$r).importNode(s, !0);
        $bb6d4e6d0376d66c$var$C.currentNode = o;
        let n = $bb6d4e6d0376d66c$var$C.nextNode(), l = 0, h = 0, d = e[0];
        for(; void 0 !== d;){
            if (l === d.index) {
                let i;
                2 === d.type ? i = new $bb6d4e6d0376d66c$var$M(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new $bb6d4e6d0376d66c$var$z(n, this, t)), this._$AV.push(i), d = e[++h];
            }
            l !== (null == d ? void 0 : d.index) && (n = $bb6d4e6d0376d66c$var$C.nextNode(), l++);
        }
        return o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
}
class $bb6d4e6d0376d66c$var$M {
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $bb6d4e6d0376d66c$var$N(this, t, i), $bb6d4e6d0376d66c$var$u(t) ? t === $bb6d4e6d0376d66c$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $bb6d4e6d0376d66c$export$45b790e32b2810ee && this._$AR(), this._$AH = $bb6d4e6d0376d66c$export$45b790e32b2810ee) : t !== this._$AH && t !== $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $bb6d4e6d0376d66c$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $bb6d4e6d0376d66c$export$45b790e32b2810ee && $bb6d4e6d0376d66c$var$u(this._$AH) ? this._$AA.nextSibling.data = t : this.$($bb6d4e6d0376d66c$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $bb6d4e6d0376d66c$var$V.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $bb6d4e6d0376d66c$var$S(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $bb6d4e6d0376d66c$var$E.get(t.strings);
        return void 0 === i && $bb6d4e6d0376d66c$var$E.set(t.strings, i = new $bb6d4e6d0376d66c$var$V(t)), i;
    }
    T(t) {
        $bb6d4e6d0376d66c$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $bb6d4e6d0376d66c$var$M(this.k($bb6d4e6d0376d66c$var$d()), this.k($bb6d4e6d0376d66c$var$d()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $bb6d4e6d0376d66c$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
}
class $bb6d4e6d0376d66c$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $bb6d4e6d0376d66c$var$N(this, t, i, 0), n = !$bb6d4e6d0376d66c$var$u(t) || t !== this._$AH && t !== $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $bb6d4e6d0376d66c$var$N(this, e[s + l], i, l), h === $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$bb6d4e6d0376d66c$var$u(h) || h !== this._$AH[l]), h === $bb6d4e6d0376d66c$export$45b790e32b2810ee ? t = $bb6d4e6d0376d66c$export$45b790e32b2810ee : t !== $bb6d4e6d0376d66c$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $bb6d4e6d0376d66c$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $bb6d4e6d0376d66c$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $bb6d4e6d0376d66c$export$45b790e32b2810ee;
    }
}
class $bb6d4e6d0376d66c$var$k extends $bb6d4e6d0376d66c$var$R {
    j(t) {
        this.element[this.name] = t === $bb6d4e6d0376d66c$export$45b790e32b2810ee ? void 0 : t;
    }
    constructor(){
        super(...arguments), this.type = 3;
    }
}
const $bb6d4e6d0376d66c$var$H = $bb6d4e6d0376d66c$var$s ? $bb6d4e6d0376d66c$var$s.emptyScript : "";
class $bb6d4e6d0376d66c$var$I extends $bb6d4e6d0376d66c$var$R {
    j(t) {
        t && t !== $bb6d4e6d0376d66c$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $bb6d4e6d0376d66c$var$H) : this.element.removeAttribute(this.name);
    }
    constructor(){
        super(...arguments), this.type = 4;
    }
}
class $bb6d4e6d0376d66c$var$L extends $bb6d4e6d0376d66c$var$R {
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $bb6d4e6d0376d66c$var$N(this, t, i, 0)) && void 0 !== s ? s : $bb6d4e6d0376d66c$export$45b790e32b2810ee) === $bb6d4e6d0376d66c$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $bb6d4e6d0376d66c$export$45b790e32b2810ee && e !== $bb6d4e6d0376d66c$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $bb6d4e6d0376d66c$export$45b790e32b2810ee && (e === $bb6d4e6d0376d66c$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
}
class $bb6d4e6d0376d66c$var$z {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $bb6d4e6d0376d66c$var$N(this, t);
    }
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
}
const $bb6d4e6d0376d66c$export$8613d1ca9052b22e = {
    O: $bb6d4e6d0376d66c$var$o,
    P: $bb6d4e6d0376d66c$var$n,
    A: $bb6d4e6d0376d66c$var$l,
    C: 1,
    M: $bb6d4e6d0376d66c$var$P,
    L: $bb6d4e6d0376d66c$var$S,
    D: $bb6d4e6d0376d66c$var$v,
    R: $bb6d4e6d0376d66c$var$N,
    I: $bb6d4e6d0376d66c$var$M,
    V: $bb6d4e6d0376d66c$var$R,
    H: $bb6d4e6d0376d66c$var$I,
    N: $bb6d4e6d0376d66c$var$L,
    U: $bb6d4e6d0376d66c$var$k,
    F: $bb6d4e6d0376d66c$var$z
}, $bb6d4e6d0376d66c$var$j = $bb6d4e6d0376d66c$var$i.litHtmlPolyfillSupport;
null == $bb6d4e6d0376d66c$var$j || $bb6d4e6d0376d66c$var$j($bb6d4e6d0376d66c$var$V, $bb6d4e6d0376d66c$var$M), (null !== ($bb6d4e6d0376d66c$var$t = $bb6d4e6d0376d66c$var$i.litHtmlVersions) && void 0 !== $bb6d4e6d0376d66c$var$t ? $bb6d4e6d0376d66c$var$t : $bb6d4e6d0376d66c$var$i.litHtmlVersions = []).push("2.7.3");
const $bb6d4e6d0376d66c$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $bb6d4e6d0376d66c$var$M(i.insertBefore($bb6d4e6d0376d66c$var$d(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("f3Ila", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("5H6ys")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("AKSXg")).ReactiveElement);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("5H6ys")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("5H6ys")).unsafeCSS);
$parcel$export(module.exports, "html", () => (parcelRequire("g5Fvc")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("g5Fvc")).noChange);
$parcel$export(module.exports, "nothing", () => (parcelRequire("g5Fvc")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("g5Fvc")).render);

$parcel$export(module.exports, "LitElement", () => $af6987e46571486a$export$3f2f9f5909897157);

var $AKSXg = parcelRequire("AKSXg");

var $g5Fvc = parcelRequire("g5Fvc");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $af6987e46571486a$var$l, $af6987e46571486a$var$o;
const $af6987e46571486a$export$8bf27daf9e8907c9 = (0, $AKSXg.ReactiveElement);
class $af6987e46571486a$export$3f2f9f5909897157 extends (0, $AKSXg.ReactiveElement) {
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $g5Fvc.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $g5Fvc.noChange;
    }
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
}
$af6987e46571486a$export$3f2f9f5909897157.finalized = !0, $af6987e46571486a$export$3f2f9f5909897157._$litElement$ = !0, null === ($af6987e46571486a$var$l = globalThis.litElementHydrateSupport) || void 0 === $af6987e46571486a$var$l || $af6987e46571486a$var$l.call(globalThis, {
    LitElement: $af6987e46571486a$export$3f2f9f5909897157
});
const $af6987e46571486a$var$n = globalThis.litElementPolyfillSupport;
null == $af6987e46571486a$var$n || $af6987e46571486a$var$n({
    LitElement: $af6987e46571486a$export$3f2f9f5909897157
});
const $af6987e46571486a$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($af6987e46571486a$var$o = globalThis.litElementVersions) && void 0 !== $af6987e46571486a$var$o ? $af6987e46571486a$var$o : globalThis.litElementVersions = []).push("3.3.2");

});

parcelRegister("7aGil", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $538a46744530b237$export$6acf61af03e62db = !1;

});


parcelRegister("5va4w", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $08fdd2f13742be0c$export$19342e026b58ebb7);

var $4ZCEJ = parcelRequire("4ZCEJ");

var $8L18p = parcelRequire("8L18p");
const $08fdd2f13742be0c$export$19342e026b58ebb7 = (0, $8L18p.default).object({
    skippable: (0, $8L18p.default).boolean().default(false),
    passkeysEnabled: (0, $8L18p.default).boolean().default(false),
    allowedSocialProviders: (0, $8L18p.default).array((0, $8L18p.default).enum(Object.values((0, $4ZCEJ.PROVIDERS)))).optional(),
    background: (0, $8L18p.default).literal("transparent").optional()
});

});
parcelRegister("4ZCEJ", function(module, exports) {

$parcel$export(module.exports, "SOCIAL_PROVIDERS", () => $bcb5382faae2fed2$export$aecc6f24c8772b27);
$parcel$export(module.exports, "isSocialProvider", () => $bcb5382faae2fed2$export$9c7590cb1144d2f8);
$parcel$export(module.exports, "DEEPLINK_SOCIAL_PROVIDERS", () => $bcb5382faae2fed2$export$fc461f45d10ea6a7);
$parcel$export(module.exports, "PROVIDERS", () => $bcb5382faae2fed2$export$b35c40687956bf9e);
$parcel$export(module.exports, "BACKUP_PROVIDERS", () => $bcb5382faae2fed2$export$9e491fd84abbe939);
$parcel$export(module.exports, "GOOGLE_SIGN_IN_CLIENT_ID", () => $bcb5382faae2fed2$export$ce771693ff3551c8);
$parcel$export(module.exports, "GOOGLE_MOCK_PROVIDER", () => $bcb5382faae2fed2$export$7d5576b60584f066);
const $bcb5382faae2fed2$export$aecc6f24c8772b27 = {
    google: "google",
    facebook: "facebook",
    apple: "apple",
    microsoft: "microsoft",
    line: "line"
};
const $bcb5382faae2fed2$export$9c7590cb1144d2f8 = (provider)=>{
    return Object.values($bcb5382faae2fed2$export$aecc6f24c8772b27).includes(provider);
};
const $bcb5382faae2fed2$export$fc461f45d10ea6a7 = [
    $bcb5382faae2fed2$export$aecc6f24c8772b27.microsoft,
    $bcb5382faae2fed2$export$aecc6f24c8772b27.line
];
const $bcb5382faae2fed2$export$b35c40687956bf9e = {
    adobe: "adobe",
    passkey: "passkey",
    ...$bcb5382faae2fed2$export$aecc6f24c8772b27
};
const $bcb5382faae2fed2$export$9e491fd84abbe939 = [
    $bcb5382faae2fed2$export$b35c40687956bf9e.google,
    $bcb5382faae2fed2$export$b35c40687956bf9e.facebook,
    $bcb5382faae2fed2$export$b35c40687956bf9e.apple
];
const $bcb5382faae2fed2$export$ce771693ff3551c8 = "sentry-test-swd-google";
const $bcb5382faae2fed2$export$bfeb688ba2ef7312 = "sentry-test-swd-google-pac";
const $bcb5382faae2fed2$export$7d5576b60584f066 = "google-mock";

});


parcelRegister("d48Mi", function(module, exports) {

$parcel$export(module.exports, "AUTH_FAILED_REASON", () => $b64a92e5cbb110a8$export$ba6721447fb9bd7);
const $b64a92e5cbb110a8$export$ba6721447fb9bd7 = {
    unknown: "unknown",
    popupBlocked: "popup-blocked",
    rideError: "ride-error",
    originInvalid: "origin-invalid"
};

});

parcelRegister("ermYl", function(module, exports) {

$parcel$export(module.exports, "Outcome", () => $9ece5e328311bed2$export$524cbb9c5a897bf8);
$parcel$export(module.exports, "CriticalOutcome", () => $9ece5e328311bed2$export$49097ee403718812);
class $9ece5e328311bed2$export$524cbb9c5a897bf8 {
    getValue() {
        return this.value;
    }
    setHandled() {
        this.isHandled = true;
    }
    of(base) {
        return this instanceof base;
    }
    constructor(value, isHandled = false){
        this.value = value;
        this.isHandled = isHandled;
        this.value = value;
    }
}
class $9ece5e328311bed2$export$49097ee403718812 extends $9ece5e328311bed2$export$524cbb9c5a897bf8 {
}

});

parcelRegister("4AFyb", function(module, exports) {

$parcel$export(module.exports, "queryState", () => $c21338d89638b97a$export$8069d817115baadd);
$parcel$export(module.exports, "qsModifier", () => $c21338d89638b97a$export$4f4528366ea29007);

var $8L18p = parcelRequire("8L18p");

var $dQqBy = parcelRequire("dQqBy");

var $5keRt = parcelRequire("5keRt");
// TODO: Decide if we want to support ALL authorize parameters
const $c21338d89638b97a$var$QueryStateExtraSchema = (0, $8L18p.default).object({
    client_redirect: (0, $8L18p.default).string().optional(),
    dc: (0, $8L18p.default).boolean().optional(),
    device_id: (0, $8L18p.default).string().optional(),
    hashed_device_id: (0, $8L18p.default).string().optional(),
    device_name: (0, $8L18p.default).string().optional(),
    el: (0, $8L18p.default).boolean().optional(),
    eu: (0, $8L18p.default).boolean().optional(),
    enforce_country: (0, $8L18p.default).boolean().optional(),
    idp_flow: (0, $8L18p.default).enum([
        "login",
        "create_account",
        "login_t2",
        "login_t2_only"
    ]).optional(),
    invite_code: (0, $8L18p.default).string().optional(),
    outvite_code: (0, $8L18p.default).string().optional(),
    puser: (0, $8L18p.default).string().optional(),
    fnuser: (0, $8L18p.default).string().optional(),
    lnuser: (0, $8L18p.default).string().optional(),
    pcountry: (0, $8L18p.default).string().optional(),
    response_type: (0, $8L18p.default).string().optional(),
    ctx_id: (0, $8L18p.default).string().optional(),
    dctx_id: (0, $8L18p.default).string().optional(),
    s_account: (0, $8L18p.default).string().optional(),
    reauth: (0, $8L18p.default).boolean().optional(),
    prompt: (0, $8L18p.default).enum([
        "none",
        "login"
    ]).optional(),
    max_age: (0, $8L18p.default).number().int().optional(),
    target_profile: (0, $8L18p.default).string().optional(),
    sign_up_sso: (0, $8L18p.default).boolean().optional(),
    filter: (0, $8L18p.default).string().optional(),
    user_assertion_type: (0, $8L18p.default).string().optional(),
    user_assertion: (0, $8L18p.default).string().optional(),
    //response_mode: z.enum(["query", "fragment"]).optional(),
    enforce_user_assertion: (0, $8L18p.default).boolean().optional(),
    code_challenge: (0, $8L18p.default).string().optional(),
    code_challenge_method: (0, $8L18p.default).enum([
        "S256",
        "plain"
    ]).optional(),
    force_complete_account: (0, $8L18p.default).boolean().optional(),
    pba_policy: (0, $8L18p.default).string().optional(),
    hints: (0, $8L18p.default).string().optional(),
    profile_filter: (0, $8L18p.default).string().optional()
});
/**
 * This module serves as a schema validation between the application and external integrations by
 * parsing the URL Search Parameters, ensuring a clear contract between the two parties.
 *
 * There are currently two modes: "wrapper" and "wrapperless". The "wrapper" mode is
 * used when the application is included using the wrapper main component, while the "wrapperless" mode
 * is specifically for when the application is included directly as an iframe in the context of
 * UME (Unified Mobile Engineering).
 *
 * An additional "popup" mode is available when using the "wrapper" mode.
 *
 * Throught Zod schema validation this module prevents the passingof incorrect or unnecessary parameters
 * and provides TypeScript with a clear understanding of what the developer can access within the parsed queryState variable
 * depending the data passed.
 *
 * - QueryStateExtraSchema handles optional authorize search parameters
 * - BaseQueryStateSchema handles minimal required authorize search parameters needed for the application to function.
 *
 * The exported QueryState type is derived from the QueryStateSchema.
 *
 * Example of data access in different modes using this technique:
 * - In "wrapperless" mode (wrapper=false):
 *   queryState.platform // can be accessed
 * - In "wrapper" mode with 'popup' set to true (wrapper=true, popup=true):
 *   queryState.redirect_uri // can be accessed
 */ const $c21338d89638b97a$var$BaseQueryStateSchema = (0, $8L18p.default).object({
    client_id: (0, $8L18p.default).string().min(1),
    locale: (0, $8L18p.default).string().transform((0, $5keRt.sanitizeLocale)),
    pba_policy: (0, $8L18p.default).string().optional(),
    scope: (0, $8L18p.default).string().min(1),
    state: (0, $8L18p.default).string().max(4096).optional(),
    ac: (0, $8L18p.default).string().default("IMS"),
    relay: (0, $8L18p.default).string().default((0, $dQqBy.getRelay)()),
    dt: (0, $8L18p.default).boolean().default(false),
    response_type: (0, $8L18p.default).enum([
        "code",
        "token"
    ]).default("code")
});
const $c21338d89638b97a$var$ServiceParametersSchema = (0, $8L18p.default).object({
    disable_local_msw: (0, $8L18p.default).boolean().optional(),
    sl_version: (0, $8L18p.default).string().default("1.0.0"),
    sl_build: (0, $8L18p.default).string().default(""),
    sl_buildtime: (0, $8L18p.default).number().default(0),
    st_valid_origin: (0, $8L18p.default).boolean().default(false),
    st_use_federated: (0, $8L18p.default).boolean().default(false),
    st_force_ab_test: (0, $8L18p.default).string().optional(),
    st_mock_fedtoken: (0, $8L18p.default).boolean().default(false),
    st_exchange_failed: (0, $8L18p.default).boolean().default(false)
});
const $c21338d89638b97a$var$WrapperSchema = (0, $8L18p.default).object({
    wrapper: (0, $8L18p.default).literal(true),
    popup: (0, $8L18p.default).boolean(),
    redirect_uri: (0, $8L18p.default).string(),
    asserted_origin: (0, $8L18p.default).string().min(1)
});
const $c21338d89638b97a$var$WrapperLessSchema = (0, $8L18p.default).object({
    wrapper: (0, $8L18p.default).literal(false),
    platform: (0, $8L18p.default).enum([
        "ios",
        "android"
    ]),
    popup: (0, $8L18p.default).undefined(),
    config: (0, $8L18p.default).string().min(1)
});
const $c21338d89638b97a$var$CombinedWrapperSchema = (0, $8L18p.default).discriminatedUnion("wrapper", [
    $c21338d89638b97a$var$WrapperSchema,
    $c21338d89638b97a$var$WrapperLessSchema
]);
const $c21338d89638b97a$var$QueryStateSchema = $c21338d89638b97a$var$BaseQueryStateSchema.and($c21338d89638b97a$var$CombinedWrapperSchema).and($c21338d89638b97a$var$ServiceParametersSchema);
const $c21338d89638b97a$export$3117eb617dc636b6 = (searchParams)=>{
    return Object.fromEntries(searchParams);
};
function $c21338d89638b97a$var$isValidNumberFormat(s) {
    const regex = /^-?(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/;
    return regex.test(s);
}
const $c21338d89638b97a$export$4307ce62e107afb3 = (obj)=>{
    return Object.fromEntries(Object.entries(obj).map(([k, v])=>{
        if (typeof v === "object" && (v === null || v === void 0 ? void 0 : v.constructor) === Object) return [
            k,
            $c21338d89638b97a$export$4307ce62e107afb3(v)
        ];
        if ($c21338d89638b97a$var$isValidNumberFormat(v) && !isNaN(parseFloat(v))) return [
            k,
            parseFloat(v)
        ];
        if (v === "true") return [
            k,
            true
        ];
        if (v === "false") return [
            k,
            false
        ];
        if (typeof v === "string") return [
            k,
            v
        ];
        return [
            k,
            v
        ];
    }));
};
const $c21338d89638b97a$export$8ee33fdb5e138629 = (obj)=>{
    return Object.fromEntries(Object.entries(obj).map(([k, v])=>[
            k,
            v.toString()
        ]));
};
const $c21338d89638b97a$export$9a9a4ec1b3864074 = (searchParams)=>{
    const parsed = $c21338d89638b97a$export$4307ce62e107afb3(searchParams);
    const state = $c21338d89638b97a$var$QueryStateSchema.safeParse({
        ...parsed
    });
    if (!state.success) throw new (0, $8L18p.default).ZodError(state.error.issues);
    return state.data;
};
const $c21338d89638b97a$export$8069d817115baadd = {
    fromQueryString (qs) {
        const searchParams = new URLSearchParams(qs);
        const obj = $c21338d89638b97a$export$3117eb617dc636b6(searchParams);
        return $c21338d89638b97a$export$9a9a4ec1b3864074(obj);
    },
    fromSearchParams (searchParams) {
        const obj = $c21338d89638b97a$export$3117eb617dc636b6(searchParams);
        return $c21338d89638b97a$export$9a9a4ec1b3864074(obj);
    },
    fromObject (obj) {
        return $c21338d89638b97a$export$9a9a4ec1b3864074(obj);
    },
    toObject (obj) {
        return $c21338d89638b97a$export$8ee33fdb5e138629(obj);
    },
    toString (obj) {
        const searchParams = $c21338d89638b97a$export$8ee33fdb5e138629(obj);
        return new URLSearchParams(searchParams).toString();
    }
};
const $c21338d89638b97a$export$4f4528366ea29007 = {
    omit (obj, omitKeys) {
        const entries = Object.entries(obj);
        return Object.fromEntries(entries.filter(([key])=>!omitKeys.includes(key)));
    }
};

});

parcelRegister("jsjcF", function(module, exports) {

$parcel$export(module.exports, "criticalErrorFlow", () => $2419a26e4089ee07$export$702a0eabf362e45d);
$parcel$export(module.exports, "unrecoverableErrorFlow", () => $2419a26e4089ee07$export$358cd10a4594550a);

var $fQrtG = parcelRequire("fQrtG");

var $ermYl = parcelRequire("ermYl");

var $dQqBy = parcelRequire("dQqBy");

var $1VxQB = parcelRequire("1VxQB");

var $743Bh = parcelRequire("743Bh");

var $8Mzka = parcelRequire("8Mzka");

var $akUfC = parcelRequire("akUfC");
async function $2419a26e4089ee07$export$702a0eabf362e45d(events, passedOutcome) {
    const { config: { variant: variant }, queryState: queryState } = await (0, $1VxQB.getApplicationState)();
    // UME Exception - We don't have critical errors in UME, only unrecoverable.
    if (variant === "unified-mobile") {
        const error = passedOutcome.getValue();
        return $2419a26e4089ee07$export$358cd10a4594550a(events, new (0, $ermYl.CriticalOutcome)((0, $8Mzka.SentryError).unrecoverable(error.message)));
    }
    events.sendError(passedOutcome.getValue());
    (0, $dQqBy.logCritical)(passedOutcome.getValue());
    const outcome = await (0, $fQrtG.criticalErrorPage).create({
        shouldAllowSignIn: true,
        debugId: queryState.relay
    });
    if (outcome.of((0, $743Bh.TokenOutcome))) {
        const { token: token } = outcome.getValue();
        await events.sendToken(token);
        return outcome;
    }
    if (outcome.of((0, $743Bh.AuthCodeOutcome))) {
        const { code: code } = outcome.getValue();
        await events.sendAuthCode(code);
        return outcome;
    }
    if (outcome.of((0, $ermYl.CriticalOutcome))) return $2419a26e4089ee07$export$358cd10a4594550a(events, outcome);
    return (0, $akUfC.unhandledEndOfFlow)(outcome);
}
async function $2419a26e4089ee07$export$358cd10a4594550a(events, passedOutcome) {
    try {
        if (events && events.sendError) {
            (0, $dQqBy.logError)(passedOutcome.getValue());
            events.sendError(passedOutcome.getValue());
        } else (0, $dQqBy.broadcastLastResortError)(passedOutcome.getValue());
        await (0, $fQrtG.unrecoverableErrorPage).create({
            shouldAllowSignIn: false,
            debugId: (0, $dQqBy.getRelay)()
        });
    } catch (e) {
        (0, $dQqBy.broadcastLastResortError)(e);
    }
    return;
}

});
parcelRegister("fQrtG", function(module, exports) {

$parcel$export(module.exports, "criticalErrorPage", () => $14abe557aa3cc758$export$f162d6252f03cadf);
$parcel$export(module.exports, "unrecoverableErrorPage", () => $14abe557aa3cc758$export$976c3c8ea3c25662);

var $7UF8Z = parcelRequire("7UF8Z");

var $iqkw9 = parcelRequire("iqkw9");

var $4vDzg = parcelRequire("4vDzg");
const $14abe557aa3cc758$var$dimensions = (0, $7UF8Z.MIN_CARD_DIMENSIONS);

const $14abe557aa3cc758$export$f162d6252f03cadf = {
    load: ()=>(parcelRequire("gtK3D")),
    create (initialState) {
        return (0, $iqkw9.createPage)(this.load, {
            initialState: initialState,
            dimensions: $14abe557aa3cc758$var$dimensions,
            forceModal: false
        });
    }
};

const $14abe557aa3cc758$export$976c3c8ea3c25662 = {
    load: ()=>(parcelRequire("gtK3D")),
    create (initialState) {
        return (0, $iqkw9.createPage)(this.load, {
            initialState: initialState,
            dimensions: $14abe557aa3cc758$var$dimensions,
            forceModal: false
        });
    }
};

});
parcelRegister("7UF8Z", function(module, exports) {

$parcel$export(module.exports, "MIN_CARD_DIMENSIONS", () => $42731c6db5bad998$export$30770aff587bebc6);
const $42731c6db5bad998$export$30770aff587bebc6 = {
    width: 384,
    height: 482
};

});

parcelRegister("iqkw9", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsState", () => (parcelRequire("6sKhd")).getAnalyticsState);
$parcel$export(module.exports, "getAnalyticsStore", () => (parcelRequire("6sKhd")).getAnalyticsStore);
$parcel$export(module.exports, "getApplicationState", () => (parcelRequire("1VxQB")).getApplicationState);
$parcel$export(module.exports, "getApplicationStore", () => (parcelRequire("1VxQB")).getApplicationStore);
$parcel$export(module.exports, "getConfigurationsState", () => (parcelRequire("nRbZ5")).getConfigurationsState);
$parcel$export(module.exports, "getConfigurationsStore", () => (parcelRequire("nRbZ5")).getConfigurationsStore);

$parcel$export(module.exports, "initializeApplication", () => $a771e33bf26e3511$export$a29f0f28e670b85a);
$parcel$export(module.exports, "createPage", () => $a771e33bf26e3511$export$eea1b38e4aaafc7d);

var $6sKhd = parcelRequire("6sKhd");

var $1VxQB = parcelRequire("1VxQB");

var $nRbZ5 = parcelRequire("nRbZ5");

var $lTNnI = parcelRequire("lTNnI");

var $dQqBy = parcelRequire("dQqBy");

var $eKTtn = parcelRequire("eKTtn");
const $a771e33bf26e3511$export$a29f0f28e670b85a = (slice)=>{
    var _document_getElementById;
    const { logInfo: logInfo } = (0, $eKTtn.getLoggers)();
    if (slice.config.variant === "unified-mobile") (_document_getElementById = document.getElementById("app")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("class", "unified-mobile");
    if (slice.config.variant === "large-buttons") try {
        const shouldEnableCompleteAccount = "enableCompleteAccount" in slice.config ? slice.config.enableCompleteAccount : false;
        const shouldUseFederated = slice.queryState.st_use_federated || shouldEnableCompleteAccount || sessionStorage.getItem("sentry_use_federated") === "true";
        logInfo(`[initialize-application] Should use federated: ${shouldUseFederated}`);
    } catch (error) {
        logInfo(`[initialize-application] Error: ${error}`);
    }
    (0, $dQqBy.setSentry)(slice);
    (0, $1VxQB.getApplicationStore)().setState({
        loading: false,
        ...slice
    });
    (0, $nRbZ5.getConfigurationsStore)().setState({
        locale: slice.locale
    });
};
const $a771e33bf26e3511$export$eea1b38e4aaafc7d = (0, $lTNnI.pageCreator)(document.getElementById("app"), {
    getAnalytics: (0, $6sKhd.getAnalyticsState),
    getConfigurationsState: $nRbZ5.getConfigurationsState,
    getApplicationState: $1VxQB.getApplicationState
});

});
parcelRegister("6sKhd", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsStore", () => $6435d7e9c435663d$export$f560d16ac5a52bc1);
$parcel$export(module.exports, "getAnalyticsState", () => $6435d7e9c435663d$export$4c31e036f8a4d471);

var $8T4Wx = parcelRequire("8T4Wx");

var $8tQlD = parcelRequire("8tQlD");
const $6435d7e9c435663d$var$takeEvents = (set, get)=>{
    const { events: events } = get();
    if (events.length > 0) set({
        events: []
    });
    return events;
};
const $6435d7e9c435663d$export$b1d71bc1d9cf6a38 = (set, get, ...rest)=>({
        takeEvents: ()=>$6435d7e9c435663d$var$takeEvents(set, get, ...rest),
        unshift: (event)=>set({
                events: (0, $8tQlD.unshift)(get().events, event)
            }),
        push: (event)=>set({
                events: (0, $8tQlD.push)(get().events, event)
            }),
        pop: ()=>set({
                events: (0, $8tQlD.pop)(get().events)
            }),
        shift: ()=>set({
                events: (0, $8tQlD.shift)(get().events)
            }),
        setIsAnalyticsLoading: (loading)=>set({
                isAnalyticsLoading: loading
            }),
        events: [],
        isAnalyticsLoading: true
    });
const $6435d7e9c435663d$var$store = (0, (/*@__PURE__*/$parcel$interopDefault($8T4Wx)))($6435d7e9c435663d$export$b1d71bc1d9cf6a38);
const $6435d7e9c435663d$export$f560d16ac5a52bc1 = ()=>$6435d7e9c435663d$var$store;
const $6435d7e9c435663d$export$4c31e036f8a4d471 = ()=>$6435d7e9c435663d$export$f560d16ac5a52bc1().getState();

});
parcelRegister("8tQlD", function(module, exports) {

$parcel$export(module.exports, "asyncStoreHelper", () => $6e9f9caa386b999a$export$d69a5d7411befb42);
$parcel$export(module.exports, "methodCreator", () => $6e9f9caa386b999a$export$a4a4ef0133b885d5);
$parcel$export(module.exports, "push", () => $6e9f9caa386b999a$export$4cbf152802aa238);
$parcel$export(module.exports, "unshift", () => $6e9f9caa386b999a$export$37cdb546b806ae87);
$parcel$export(module.exports, "pop", () => $6e9f9caa386b999a$export$3e41007ebfff0e64);
$parcel$export(module.exports, "shift", () => $6e9f9caa386b999a$export$fba63a578e423eb);
$parcel$export(module.exports, "getBirthDateFromMonthAndYear", () => $6e9f9caa386b999a$export$4d66835c58717cee);
$parcel$export(module.exports, "calculateAge", () => $6e9f9caa386b999a$export$8ada184d5eef4694);
const $6e9f9caa386b999a$export$417857010dc9287f = (state)=>{
    const { loading: loading, ...restState } = state;
    return [
        loading,
        restState
    ];
};
function $6e9f9caa386b999a$export$d69a5d7411befb42(slice) {
    return new Promise((resolve)=>{
        function doneLoading(state) {
            const [loading, restState] = $6e9f9caa386b999a$export$417857010dc9287f(state);
            if (!loading) resolve(restState);
            return !loading;
        }
        if (!doneLoading(slice.getState())) slice.subscribe(doneLoading);
    });
}
function $6e9f9caa386b999a$export$a4a4ef0133b885d5(set, get) {
    return function(fn) {
        return function(...args) {
            const state = get();
            const value = fn(state, ...args);
            set(value);
            return value;
        };
    };
}
const $6e9f9caa386b999a$export$4cbf152802aa238 = (arr, item)=>[
        ...arr,
        item
    ];
const $6e9f9caa386b999a$export$37cdb546b806ae87 = (arr, item)=>[
        item,
        ...arr
    ];
const $6e9f9caa386b999a$export$3e41007ebfff0e64 = (arr)=>arr.slice(0, -1);
const $6e9f9caa386b999a$export$fba63a578e423eb = (arr)=>arr.slice(1);
function $6e9f9caa386b999a$export$4d66835c58717cee(month, year) {
    return new Date(year, month, $6e9f9caa386b999a$export$c35e65bab552d6a1({
        month: month,
        year: year
    }));
}
function $6e9f9caa386b999a$export$8ada184d5eef4694(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || monthDifference === 0 && today.getDate() < birthDate.getDate()) age--;
    return age;
}
const $6e9f9caa386b999a$export$c35e65bab552d6a1 = ({ year: year, month: month })=>{
    const februaryIndex = 1;
    const lastFebruaryDay = 28;
    const leapFebruaryDay = 29;
    const currentDay = new Date().getUTCDate();
    const day = $6e9f9caa386b999a$var$isMaxDay({
        year: year,
        month: month,
        day: currentDay
    }) ? 30 : currentDay;
    if (year && month && month === februaryIndex) {
        const maxDay = $6e9f9caa386b999a$var$isLeapYear(year) ? leapFebruaryDay : lastFebruaryDay;
        return currentDay >= maxDay ? maxDay : day;
    }
    return day;
};
const $6e9f9caa386b999a$var$isLeapYear = (year)=>year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
const $6e9f9caa386b999a$var$isMaxDay = ({ year: year, month: month, day: day })=>new Date(year, month, day).getDate() !== day;

});


parcelRegister("1VxQB", function(module, exports) {

$parcel$export(module.exports, "getApplicationStore", () => $4742671c719c8b5d$export$708e0e8ee2dd957b);
$parcel$export(module.exports, "getApplicationState", () => $4742671c719c8b5d$export$bf10bf336857385a);

var $8T4Wx = parcelRequire("8T4Wx");

var $8tQlD = parcelRequire("8tQlD");
const $4742671c719c8b5d$export$85e7e17070b2cc2f = ()=>({
        loading: true,
        events: undefined,
        eventListener: undefined,
        config: undefined,
        port: undefined,
        queryState: undefined
    });
const $4742671c719c8b5d$var$store = (0, (/*@__PURE__*/$parcel$interopDefault($8T4Wx)))($4742671c719c8b5d$export$85e7e17070b2cc2f);
const $4742671c719c8b5d$export$708e0e8ee2dd957b = ()=>$4742671c719c8b5d$var$store;
const $4742671c719c8b5d$export$bf10bf336857385a = async ()=>{
    const state = $4742671c719c8b5d$export$708e0e8ee2dd957b();
    const slice = await (0, $8tQlD.asyncStoreHelper)(state);
    return slice;
};

});

parcelRegister("nRbZ5", function(module, exports) {

$parcel$export(module.exports, "getConfigurationsStore", () => $662910e3568839b7$export$c6c7434bf7597fd7);
$parcel$export(module.exports, "getConfigurationsState", () => $662910e3568839b7$export$9a7d76d2a0c27e23);

var $1rFrX = parcelRequire("1rFrX");

var $8T4Wx = parcelRequire("8T4Wx");
const $662910e3568839b7$export$ae207763caad5673 = (set, get)=>({
        socialProviders: [],
        isLocaleLoading: false,
        hasSentLoadEvent: false,
        locale: null,
        setIsLocaleLoading: (loading)=>set({
                isLocaleLoading: loading
            }),
        setLocale: (locale)=>set({
                isLocaleLoading: false,
                locale: locale
            }),
        fetchAndCacheSocialProviders: async ()=>{
            let socialProviders = get().socialProviders;
            if (!socialProviders.length) {
                // TODO: Call failure error handling
                socialProviders = await (0, $1rFrX.fetchSocialProviders)();
                set({
                    socialProviders: socialProviders
                });
            }
            return socialProviders;
        },
        fetchAndCacheSocialProvidersNoBackup: async ()=>{
            let socialProviders = get().socialProviders;
            if (!socialProviders.length) {
                // TODO: Call failure error handling
                socialProviders = await (0, $1rFrX.fetchSocialProviders)(false);
                set({
                    socialProviders: socialProviders
                });
            }
            return socialProviders;
        }
    });
const $662910e3568839b7$var$store = (0, (/*@__PURE__*/$parcel$interopDefault($8T4Wx)))($662910e3568839b7$export$ae207763caad5673);
const $662910e3568839b7$export$c6c7434bf7597fd7 = ()=>$662910e3568839b7$var$store;
const $662910e3568839b7$export$9a7d76d2a0c27e23 = ()=>$662910e3568839b7$export$c6c7434bf7597fd7().getState();

});
parcelRegister("1rFrX", function(module, exports) {

$parcel$export(module.exports, "fetchSocialProviders", () => $a324ab6b521af02f$export$aab3a03400dd79b);

var $8L18p = parcelRequire("8L18p");

var $4ZCEJ = parcelRequire("4ZCEJ");

var $1VxQB = parcelRequire("1VxQB");

var $dQqBy = parcelRequire("dQqBy");

var $5AgzP = parcelRequire("5AgzP");

var $89Db5 = parcelRequire("89Db5");
const $a324ab6b521af02f$var$SocialProviderSchema = (0, $8L18p.default).object({
    providerName: (0, $8L18p.default).enum(Object.values((0, $4ZCEJ.SOCIAL_PROVIDERS)))
}).transform((socialProvider)=>socialProvider.providerName);
const $a324ab6b521af02f$var$FetchSocialProvidersResponse = (0, $8L18p.default).array($a324ab6b521af02f$var$SocialProviderSchema);
const $a324ab6b521af02f$var$filterParse = (providers)=>providers.filter((item)=>$a324ab6b521af02f$var$SocialProviderSchema.safeParse(item).success);
async function $a324ab6b521af02f$export$aab3a03400dd79b(hasFallbackProviders = true) {
    const imsEndpoint = await (0, $89Db5.getImsEndpoint)();
    const { queryState: { client_id: client_id } } = await (0, $1VxQB.getApplicationState)();
    const promise = imsEndpoint.url((0, $5AgzP.PATHNAMES).socialProviders).query({
        client_id: client_id
    }).get().json((r)=>$a324ab6b521af02f$var$FetchSocialProvidersResponse.parse($a324ab6b521af02f$var$filterParse(r)));
    return hasFallbackProviders ? promise.catch((e)=>{
        (0, $dQqBy.logInfo)("Failed to fetch social providers, using backup providers.", e.response && (0, $dQqBy.responseToInfo)(e.response));
        return 0, $4ZCEJ.BACKUP_PROVIDERS;
    }) : promise;
}
async function $a324ab6b521af02f$export$59e49238f318aba1(qs) {
    const imsEndpoint = await (0, $89Db5.getImsEndpoint)({
        client_id: qs.client_id,
        relay: qs.relay
    });
    const promise = imsEndpoint.url((0, $5AgzP.PATHNAMES).validateOrigin).query({
        client_id: qs.client_id,
        redirect_uri: qs.asserted_origin
    }).get().json((res)=>(0, $8L18p.default).object({
            valid: (0, $8L18p.default).boolean()
        }).transform((r)=>r.valid).parse(res));
    return promise.catch((e)=>{
        (0, $dQqBy.logInfo)("Validate origin call failed.", e.response && (0, $dQqBy.responseToInfo)(e.response));
        return false;
    });
}

});
parcelRegister("89Db5", function(module, exports) {

$parcel$export(module.exports, "getAuthServicesEndpoint", () => $d641ad47c75c1e2f$export$5576406e3d7de3);
$parcel$export(module.exports, "getImsEndpoint", () => $d641ad47c75c1e2f$export$d5bccc8afbe132c3);
$parcel$export(module.exports, "getAdobeidServicesEndpoint", () => $d641ad47c75c1e2f$export$8c28adff10b84ef0);

var $8Mzka = parcelRequire("8Mzka");

var $1s7Ba = parcelRequire("1s7Ba");

var $eMjWF = parcelRequire("eMjWF");

var $1VxQB = parcelRequire("1VxQB");

var $3HfdA = parcelRequire("3HfdA");
const { getApiUrl: $d641ad47c75c1e2f$var$getApiUrl, getAdobeidServicesUrl: $d641ad47c75c1e2f$var$getAdobeidServicesUrl, getAuthServicesUrl: $d641ad47c75c1e2f$var$getAuthServicesUrl } = (0, $8Mzka.urls).create((0, $8Mzka.envs).getAppEnv);
async function $d641ad47c75c1e2f$export$5576406e3d7de3() {
    const { queryState: { client_id: client_id, relay: relay } } = await (0, $1VxQB.getApplicationState)();
    const apiUrl = (0, $8Mzka.envs).getAppEnv() !== (0, $3HfdA.ENVIRONMENTS).prod ? "https://auth-stg1.services.adobe.com" : $d641ad47c75c1e2f$var$getAuthServicesUrl();
    return (0, $1s7Ba.default)(apiUrl).addon((0, $eMjWF.default)).headers({
        "x-ims-clientid": client_id,
        "X-Debug-Id": relay
    });
}
async function $d641ad47c75c1e2f$export$d5bccc8afbe132c3(qsOverride) {
    const apiUrl = $d641ad47c75c1e2f$var$getApiUrl();
    const { queryState: queryState } = qsOverride ? {
        queryState: qsOverride
    } : await (0, $1VxQB.getApplicationState)();
    const { client_id: client_id, relay: relay } = queryState;
    return (0, $1s7Ba.default)(apiUrl).addon((0, $eMjWF.default)).headers({
        "x-ims-clientid": client_id,
        "X-Debug-Id": relay
    });
}
async function $d641ad47c75c1e2f$export$8c28adff10b84ef0() {
    const { queryState: { client_id: client_id, relay: relay } } = await (0, $1VxQB.getApplicationState)();
    const apiUrl = (0, $8Mzka.envs).getAppEnv() !== (0, $3HfdA.ENVIRONMENTS).prod ? "https://adobeid-na1-stg1.services.adobe.com" : $d641ad47c75c1e2f$var$getAdobeidServicesUrl();
    return (0, $1s7Ba.default)(apiUrl).addon((0, $eMjWF.default)).headers({
        "x-ims-clientid": client_id,
        "X-Debug-Id": relay
    });
}

});
parcelRegister("1s7Ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ee4cdaac607cb8$export$2e2bcd8739ae039);

var $5yuK4 = parcelRequire("5yuK4");

var $grhTs = parcelRequire("grhTs");

var $f8Jt9 = parcelRequire("f8Jt9");
/**
 * Creates a new wretch instance with a base url and base
 * [fetch options](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch).
 *
 * ```ts
 * import wretch from "wretch"
 *
 * // Reusable instance
 * const w = wretch("https://domain.com", { mode: "cors" })
 * ```
 *
 * @param _url The base url
 * @param _options The base fetch options
 * @returns A fresh wretch instance
 */ function $10ee4cdaac607cb8$var$factory(_url = "", _options = {}) {
    return {
        ...(0, $grhTs.core),
        _url: _url,
        _options: _options
    };
}
$10ee4cdaac607cb8$var$factory["default"] = $10ee4cdaac607cb8$var$factory;
/** {@inheritDoc setOptions} */ $10ee4cdaac607cb8$var$factory.options = (0, $5yuK4.setOptions);
/** {@inheritDoc setErrorType} */ $10ee4cdaac607cb8$var$factory.errorType = (0, $5yuK4.setErrorType);
/** {@inheritDoc setPolyfills} */ $10ee4cdaac607cb8$var$factory.polyfills = (0, $5yuK4.setPolyfills);
$10ee4cdaac607cb8$var$factory.WretchError = (0, $f8Jt9.WretchError);
var $10ee4cdaac607cb8$export$2e2bcd8739ae039 = $10ee4cdaac607cb8$var$factory;

});
parcelRegister("5yuK4", function(module, exports) {

$parcel$export(module.exports, "setOptions", () => $40b7f974394c0523$export$add91eafeaeab287);
$parcel$export(module.exports, "setPolyfills", () => $40b7f974394c0523$export$e7b525096036746b);
$parcel$export(module.exports, "setErrorType", () => $40b7f974394c0523$export$bf3df2a01e7984c3);
$parcel$export(module.exports, "default", () => $40b7f974394c0523$export$2e2bcd8739ae039);

var $4z08M = parcelRequire("4z08M");
const $40b7f974394c0523$var$config = {
    // Default options
    options: {},
    // Error type
    errorType: "text",
    // Polyfills
    polyfills: {
    },
    polyfill (p, doThrow = true, instance = false, ...args) {
        const res = this.polyfills[p] || (typeof self !== "undefined" ? self[p] : null) || (typeof $parcel$global !== "undefined" ? $parcel$global[p] : null);
        if (doThrow && !res) throw new Error(p + " is not defined");
        return instance && res ? new res(...args) : res;
    }
};
function $40b7f974394c0523$export$add91eafeaeab287(options, replace = false) {
    $40b7f974394c0523$var$config.options = replace ? options : (0, $4z08M.mix)($40b7f974394c0523$var$config.options, options);
}
function $40b7f974394c0523$export$e7b525096036746b(polyfills, replace = false) {
    $40b7f974394c0523$var$config.polyfills = replace ? polyfills : (0, $4z08M.mix)($40b7f974394c0523$var$config.polyfills, polyfills);
}
function $40b7f974394c0523$export$bf3df2a01e7984c3(errorType) {
    $40b7f974394c0523$var$config.errorType = errorType;
}
var $40b7f974394c0523$export$2e2bcd8739ae039 = $40b7f974394c0523$var$config;

});
parcelRegister("4z08M", function(module, exports) {

$parcel$export(module.exports, "extractContentType", () => $352a8a38ef63331a$export$2b9b51eb2e7a33e6);
$parcel$export(module.exports, "isLikelyJsonMime", () => $352a8a38ef63331a$export$986f6039e68070e3);
$parcel$export(module.exports, "mix", () => $352a8a38ef63331a$export$2c9e8a9632a706b2);

var $ipabu = parcelRequire("ipabu");
function $352a8a38ef63331a$export$2b9b51eb2e7a33e6(headers = {}) {
    var _a;
    return (_a = Object.entries(headers).find(([k])=>k.toLowerCase() === (0, $ipabu.CONTENT_TYPE_HEADER).toLowerCase())) === null || _a === void 0 ? void 0 : _a[1];
}
function $352a8a38ef63331a$export$986f6039e68070e3(value) {
    return /^application\/.*json.*/.test(value);
}
const $352a8a38ef63331a$export$2c9e8a9632a706b2 = function(one, two, mergeArrays = false) {
    return Object.entries(two).reduce((acc, [key, newValue])=>{
        const value = one[key];
        if (Array.isArray(value) && Array.isArray(newValue)) acc[key] = mergeArrays ? [
            ...value,
            ...newValue
        ] : newValue;
        else if (typeof value === "object" && typeof newValue === "object") acc[key] = $352a8a38ef63331a$export$2c9e8a9632a706b2(value, newValue, mergeArrays);
        else acc[key] = newValue;
        return acc;
    }, {
        ...one
    });
};

});
parcelRegister("ipabu", function(module, exports) {

$parcel$export(module.exports, "JSON_MIME", () => $d66276344ee921b7$export$a7024616b83d7949);
$parcel$export(module.exports, "CONTENT_TYPE_HEADER", () => $d66276344ee921b7$export$39c708a4bc085737);
$parcel$export(module.exports, "FETCH_ERROR", () => $d66276344ee921b7$export$a71624947af1f122);
const $d66276344ee921b7$export$a7024616b83d7949 = "application/json";
const $d66276344ee921b7$export$39c708a4bc085737 = "Content-Type";
const $d66276344ee921b7$export$a71624947af1f122 = Symbol();

});



parcelRegister("grhTs", function(module, exports) {

$parcel$export(module.exports, "core", () => $bf7d0c3ea25ab309$export$b75f8c4f8f3fbd14);

var $4z08M = parcelRequire("4z08M");

var $ipabu = parcelRequire("ipabu");

var $f8Jt9 = parcelRequire("f8Jt9");

var $5yuK4 = parcelRequire("5yuK4");
const $bf7d0c3ea25ab309$export$b75f8c4f8f3fbd14 = {
    _url: "",
    _options: {},
    _config: (0, $5yuK4.default),
    _catchers: new Map(),
    _resolvers: [],
    _deferred: [],
    _middlewares: [],
    _addons: [],
    addon (addon) {
        return {
            ...this,
            _addons: [
                ...this._addons,
                addon
            ],
            ...addon.wretch
        };
    },
    errorType (errorType) {
        return {
            ...this,
            _config: {
                ...this._config,
                errorType: errorType
            }
        };
    },
    polyfills (polyfills, replace = false) {
        return {
            ...this,
            _config: {
                ...this._config,
                polyfills: replace ? polyfills : (0, $4z08M.mix)(this._config.polyfills, polyfills)
            }
        };
    },
    url (_url, replace = false) {
        if (replace) return {
            ...this,
            _url: _url
        };
        const split = this._url.split("?");
        return {
            ...this,
            _url: split.length > 1 ? split[0] + _url + "?" + split[1] : this._url + _url
        };
    },
    options (options, replace = false) {
        return {
            ...this,
            _options: replace ? options : (0, $4z08M.mix)(this._options, options)
        };
    },
    headers (headerValues) {
        return {
            ...this,
            _options: (0, $4z08M.mix)(this._options, {
                headers: headerValues || {}
            })
        };
    },
    accept (headerValue) {
        return this.headers({
            Accept: headerValue
        });
    },
    content (headerValue) {
        return this.headers({
            [(0, $ipabu.CONTENT_TYPE_HEADER)]: headerValue
        });
    },
    auth (headerValue) {
        return this.headers({
            Authorization: headerValue
        });
    },
    catcher (errorId, catcher) {
        const newMap = new Map(this._catchers);
        newMap.set(errorId, catcher);
        return {
            ...this,
            _catchers: newMap
        };
    },
    resolve (resolver, clear = false) {
        return {
            ...this,
            _resolvers: clear ? [
                resolver
            ] : [
                ...this._resolvers,
                resolver
            ]
        };
    },
    defer (callback, clear = false) {
        return {
            ...this,
            _deferred: clear ? [
                callback
            ] : [
                ...this._deferred,
                callback
            ]
        };
    },
    middlewares (middlewares, clear = false) {
        return {
            ...this,
            _middlewares: clear ? middlewares : [
                ...this._middlewares,
                ...middlewares
            ]
        };
    },
    fetch (method = this._options.method, url = "", body = null) {
        let base = this.url(url).options({
            method: method
        });
        // "Jsonify" the body if it is an object and if it is likely that the content type targets json.
        const contentType = (0, $4z08M.extractContentType)(base._options.headers);
        const jsonify = typeof body === "object" && (!base._options.headers || !contentType || (0, $4z08M.isLikelyJsonMime)(contentType));
        base = !body ? base : jsonify ? base.json(body, contentType) : base.body(body);
        return (0, $f8Jt9.resolver)(base._deferred.reduce((acc, curr)=>curr(acc, acc._url, acc._options), base));
    },
    get (url = "") {
        return this.fetch("GET", url);
    },
    delete (url = "") {
        return this.fetch("DELETE", url);
    },
    put (body, url = "") {
        return this.fetch("PUT", url, body);
    },
    post (body, url = "") {
        return this.fetch("POST", url, body);
    },
    patch (body, url = "") {
        return this.fetch("PATCH", url, body);
    },
    head (url = "") {
        return this.fetch("HEAD", url);
    },
    opts (url = "") {
        return this.fetch("OPTIONS", url);
    },
    body (contents) {
        return {
            ...this,
            _options: {
                ...this._options,
                body: contents
            }
        };
    },
    json (jsObject, contentType) {
        const currentContentType = (0, $4z08M.extractContentType)(this._options.headers);
        return this.content(contentType || (0, $4z08M.isLikelyJsonMime)(currentContentType) && currentContentType || (0, $ipabu.JSON_MIME)).body(JSON.stringify(jsObject));
    }
};

});
parcelRegister("f8Jt9", function(module, exports) {

$parcel$export(module.exports, "WretchError", () => $b05adf9d4a9dfd43$export$8ced8b81234b99dd);
$parcel$export(module.exports, "resolver", () => $b05adf9d4a9dfd43$export$50397835cbfdbc24);

var $5AtpK = parcelRequire("5AtpK");

var $4z08M = parcelRequire("4z08M");

var $ipabu = parcelRequire("ipabu");
class $b05adf9d4a9dfd43$export$8ced8b81234b99dd extends Error {
}
const $b05adf9d4a9dfd43$export$50397835cbfdbc24 = (wretch)=>{
    const sharedState = Object.create(null);
    wretch = wretch._addons.reduce((w, addon)=>addon.beforeRequest && addon.beforeRequest(w, wretch._options, sharedState) || w, wretch);
    const { _url: url, _options: opts, _config: config, _catchers: _catchers, _resolvers: resolvers, _middlewares: middlewares, _addons: addons } = wretch;
    const catchers = new Map(_catchers);
    const finalOptions = (0, $4z08M.mix)(config.options, opts);
    // The generated fetch request
    let finalUrl = url;
    const _fetchReq = (0, $5AtpK.middlewareHelper)(middlewares)((url, options)=>{
        finalUrl = url;
        return config.polyfill("fetch")(url, options);
    })(url, finalOptions);
    // Throws on an http error
    const referenceError = new Error();
    const throwingPromise = _fetchReq.catch((error)=>{
        throw {
            __wrap: error
        };
    }).then((response)=>{
        if (!response.ok) {
            const err = new $b05adf9d4a9dfd43$export$8ced8b81234b99dd();
            // Enhance the error object
            err["cause"] = referenceError;
            err.stack = err.stack + "\nCAUSE: " + referenceError.stack;
            err.response = response;
            err.url = finalUrl;
            if (response.type === "opaque") throw err;
            return response.text().then((body)=>{
                var _a;
                err.message = body;
                if (config.errorType === "json" || ((_a = response.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.split(";")[0]) === "application/json") try {
                    err.json = JSON.parse(body);
                } catch (e) {}
                err.text = body;
                err["status"] = response.status;
                throw err;
            });
        }
        return response;
    });
    // Wraps the Promise in order to dispatch the error to a matching catcher
    const catchersWrapper = (promise)=>{
        return promise.catch((err)=>{
            const error = err.__wrap || err;
            const catcher = error.status && catchers.get(error.status) || catchers.get(error.name) || err.__wrap && catchers.has((0, $ipabu.FETCH_ERROR)) && catchers.get((0, $ipabu.FETCH_ERROR));
            if (catcher) return catcher(error, wretch);
            throw error;
        });
    };
    const bodyParser = (funName)=>(cb)=>funName ? // If a callback is provided, then callback with the body result otherwise return the parsed body itself.
            catchersWrapper(throwingPromise.then((_)=>_ && _[funName]()).then((_)=>cb ? cb(_) : _)) : // No body parsing method - return the response
            catchersWrapper(throwingPromise.then((_)=>cb ? cb(_) : _));
    const responseChain = {
        _wretchReq: wretch,
        _fetchReq: _fetchReq,
        _sharedState: sharedState,
        res: bodyParser(null),
        json: bodyParser("json"),
        blob: bodyParser("blob"),
        formData: bodyParser("formData"),
        arrayBuffer: bodyParser("arrayBuffer"),
        text: bodyParser("text"),
        error (errorId, cb) {
            catchers.set(errorId, cb);
            return this;
        },
        badRequest (cb) {
            return this.error(400, cb);
        },
        unauthorized (cb) {
            return this.error(401, cb);
        },
        forbidden (cb) {
            return this.error(403, cb);
        },
        notFound (cb) {
            return this.error(404, cb);
        },
        timeout (cb) {
            return this.error(408, cb);
        },
        internalError (cb) {
            return this.error(500, cb);
        },
        fetchError (cb) {
            return this.error((0, $ipabu.FETCH_ERROR), cb);
        }
    };
    const enhancedResponseChain = addons.reduce((chain, addon)=>({
            ...chain,
            ...addon.resolver
        }), responseChain);
    return resolvers.reduce((chain, r)=>r(chain, wretch), enhancedResponseChain);
};

});
parcelRegister("5AtpK", function(module, exports) {

$parcel$export(module.exports, "middlewareHelper", () => $4117219fb01ec455$export$7b5ade2cfae8da4f);
/**
 * @private @internal
 */ const $4117219fb01ec455$export$7b5ade2cfae8da4f = (middlewares)=>(fetchFunction)=>{
        return middlewares.reduceRight((acc, curr)=>curr(acc), fetchFunction) || fetchFunction;
    };

});




parcelRegister("eMjWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac25051410e690a5$export$2e2bcd8739ae039);
function $ac25051410e690a5$var$stringify(value) {
    return typeof value !== "undefined" ? value : "";
}
const $ac25051410e690a5$var$appendQueryParams = (url, qp, replace, config)=>{
    let queryString;
    if (typeof qp === "string") queryString = qp;
    else {
        const usp = config.polyfill("URLSearchParams", true, true);
        for(const key in qp){
            const value = qp[key];
            if (qp[key] instanceof Array) for (const val of value)usp.append(key, $ac25051410e690a5$var$stringify(val));
            else usp.append(key, $ac25051410e690a5$var$stringify(value));
        }
        queryString = usp.toString();
    }
    const split = url.split("?");
    if (!queryString) return replace ? split[0] : url;
    if (replace || split.length < 2) return split[0] + "?" + queryString;
    return url + "&" + queryString;
};
/**
 * Adds the ability to append query parameters from a javascript object.
 *
 * ```js
 * import QueryAddon from "wretch/addons/queryString"
 *
 * wretch().addon(QueryAddon)
 * ```
 */ const $ac25051410e690a5$var$queryString = {
    wretch: {
        query (qp, replace = false) {
            return {
                ...this,
                _url: $ac25051410e690a5$var$appendQueryParams(this._url, qp, replace, this._config)
            };
        }
    }
};
var $ac25051410e690a5$export$2e2bcd8739ae039 = $ac25051410e690a5$var$queryString;

});

parcelRegister("3HfdA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.byEnvironment = module.exports.environmentMapper = module.exports.ENVIRONMENTS = void 0;
module.exports.ENVIRONMENTS = {
    local: "local",
    stage: "stage",
    prestage: "prestage",
    preprod: "preprod",
    prod: "prod"
};
function $2b11314615f171c8$var$environmentMapper(map) {
    return (url = window.origin)=>{
        var _a;
        return (_a = map[url]) !== null && _a !== void 0 ? _a : module.exports.ENVIRONMENTS.prod;
    };
}
module.exports.environmentMapper = $2b11314615f171c8$var$environmentMapper;
const $2b11314615f171c8$var$isEnvironment = (getEnvironment)=>(env)=>{
        return getEnvironment() === env;
    };
function $2b11314615f171c8$var$byEnvironment(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
module.exports.byEnvironment = $2b11314615f171c8$var$byEnvironment;
function $2b11314615f171c8$var$default_1(getEnvironment) {
    return {
        isEnvironment: $2b11314615f171c8$var$isEnvironment(getEnvironment),
        byEnvironment: $2b11314615f171c8$var$byEnvironment(getEnvironment)
    };
}
module.exports.default = $2b11314615f171c8$var$default_1;

});




parcelRegister("lTNnI", function(module, exports) {

$parcel$export(module.exports, "pageCreator", () => $bc1c5971635775c5$export$194efd8a61d490d8);

var $5keRt = parcelRequire("5keRt");

var $nRbZ5 = parcelRequire("nRbZ5");

var $8Mzka = parcelRequire("8Mzka");

var $cUfK3 = parcelRequire("cUfK3");

var $8eTxL = parcelRequire("8eTxL");

var $aZiut = parcelRequire("aZiut");

var $j9pM9 = parcelRequire("j9pM9");

var $ermYl = parcelRequire("ermYl");
// Wait 150ms before showing the spinner, to avoid flickering
// If it takes more than 150ms to load the data, show a spinner for at least 500ms
const $bc1c5971635775c5$var$DELAY = 150;
const $bc1c5971635775c5$var$MINIMUM_DISPLAY_TIME = 500;
let $bc1c5971635775c5$var$spinnerTimeout = null;
let $bc1c5971635775c5$var$spinnerStartTime = 0;
// start showing the spinner if we don't receive data before ${DELAY} miliseconds
const $bc1c5971635775c5$var$startLoading = (elements, loading = true)=>{
    $bc1c5971635775c5$var$spinnerTimeout = setTimeout(()=>{
        for (const element of elements)element.classList.toggle("sentry-loading", loading);
        $bc1c5971635775c5$var$spinnerStartTime = Date.now();
    }, $bc1c5971635775c5$var$DELAY);
};
const $bc1c5971635775c5$var$stopLoading = (elements, loading = true)=>{
    // if we receive data before ${DELAY} miliseconds, don't show the spinner at all
    if (!$bc1c5971635775c5$var$spinnerStartTime) {
        if ($bc1c5971635775c5$var$spinnerTimeout !== null) {
            clearTimeout($bc1c5971635775c5$var$spinnerTimeout);
            $bc1c5971635775c5$var$spinnerTimeout = null;
        }
        return;
    }
    const elapsedTime = Date.now() - $bc1c5971635775c5$var$spinnerStartTime;
    const remainingTime = Math.max($bc1c5971635775c5$var$MINIMUM_DISPLAY_TIME - elapsedTime, 0);
    setTimeout(()=>{
        for (const element of elements)element.classList.toggle("sentry-loading", loading);
    }, remainingTime);
    $bc1c5971635775c5$var$spinnerStartTime = 0;
};
const $bc1c5971635775c5$var$setLoading = (elements, loading = true)=>loading ? $bc1c5971635775c5$var$startLoading(elements, loading) : $bc1c5971635775c5$var$stopLoading(elements, loading);
function $bc1c5971635775c5$export$194efd8a61d490d8(root, states) {
    return async function createPage(loader, { initialState: initialState, dimensions: dimensions, reason: reason, forceModal: forceModal }) {
        const { getAnalytics: getAnalytics, getConfigurationsState: getConfigurationsState, getApplicationState: getApplicationState } = states;
        try {
            if ((0, $j9pM9.features).hasModalMode()) {
                const app = document.getElementById("app");
                $bc1c5971635775c5$var$setLoading(document.querySelectorAll("body, #app"), true);
            }
            if (!root) throw (0, $8Mzka.SentryError).unrecoverable("No root element found.");
            if ((0, $j9pM9.features).hasModalMode()) {
                const { config: config, events: events, eventListener: eventListener, port: port } = await getApplicationState();
                if (dimensions && (config.modal || forceModal) && port instanceof MessagePort) {
                    var // Remove the current page to prevent a flash of content when the modal opens
                    _document_querySelector;
                    (_document_querySelector = document.querySelector("app-wrapper")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.remove();
                    await (0, $aZiut.openModalDispatcher)(port, events, eventListener(), dimensions, reason || "unknown");
                }
            }
            const { Controller: Controller, getPageStore: getPageStore, PAGE_TAGNAME: PAGE_TAGNAME, initializePageState: initializePageState } = await loader();
            const { push: push } = getAnalytics();
            const { events: events, queryState: queryState, config: config } = await getApplicationState();
            push((0, $cUfK3.createPageLoadEvent)({
                pageName: `Account:IMS-Light:${PAGE_TAGNAME}:OnLoad`
            }));
            const { isLocaleLoading: isLocaleLoading, localeLoadingPromise: localeLoadingPromise } = (0, $5keRt.i18nLoading)();
            const store = getPageStore();
            const controller = new Controller();
            controller.store = store;
            if (isLocaleLoading) await localeLoadingPromise;
            const pageElement = $bc1c5971635775c5$export$8d9a61051f198fa(root, PAGE_TAGNAME);
            pageElement.controller = controller;
            // Initialize page state using initializer if provided, otherwise set initial state.
            initializePageState ? initializePageState(store, initialState) : store.setState({
                ...initialState,
                loading: false
            });
            store.subscribe((state)=>pageElement.state = state);
            store.setState({
                loading: false
            });
            const getAsync = ()=>{
                var _store_getState;
                return (_store_getState = store.getState()) === null || _store_getState === void 0 ? void 0 : _store_getState.async;
            };
            const async = getAsync();
            if (async) Object.entries(async).forEach(([key, value])=>{
                if (value instanceof (0, $8eTxL.AsyncWrapper)) value.onFulfilled(()=>{
                    store.setState({
                        async: {
                            ...getAsync(),
                            [key]: (0, $8eTxL.AsyncWrapper).from(value)
                        }
                    });
                });
            });
            // Send web load event
            const { hasSentLoadEvent: hasSentLoadEvent } = getConfigurationsState();
            // const { events, queryState } = await getApplicationState();
            if (!hasSentLoadEvent) {
                if ((config === null || config === void 0 ? void 0 : config.isGuest) === true) push((0, $cUfK3.createInteractionEvent)({
                    eventName: "GuestSource"
                }));
                if (queryState.wrapper) events.sendLoad({
                    ready: true
                }); // SUSI Light
                else events.sendHello({
                    name: "hello"
                }); // UME
                (0, $nRbZ5.getConfigurationsStore)().setState({
                    hasSentLoadEvent: true
                });
            }
            if ((0, $j9pM9.features).hasModalMode()) {
                const app = document.getElementById("app");
                $bc1c5971635775c5$var$setLoading(document.querySelectorAll("body, #app"), false);
            }
            return controller.outcomePromise.promise;
        } catch (e) {
            return Promise.reject(new (0, $ermYl.CriticalOutcome)((0, $8Mzka.convertError)(e)));
        }
    };
}
function $bc1c5971635775c5$export$8d9a61051f198fa(root, pageIdentifier) {
    const appWrapper = document.createElement("app-wrapper");
    root.innerHTML = ""; // Clear the root element
    root.appendChild(appWrapper);
    const element = document.createElement(pageIdentifier);
    appWrapper.appendChild(element);
    return element;
}

});
parcelRegister("cUfK3", function(module, exports) {

$parcel$export(module.exports, "createPageLoadEvent", () => $792bc20cac09f36f$export$b1d96d5602436b32);
$parcel$export(module.exports, "createStateEvent", () => $792bc20cac09f36f$export$21b0b87ec2baf2c3);
$parcel$export(module.exports, "createInteractionEvent", () => $792bc20cac09f36f$export$5f71a898dc86d669);

var $eKTtn = parcelRequire("eKTtn");

var $6FAcS = parcelRequire("6FAcS");
class $792bc20cac09f36f$export$30b7662faa307ee {
    setup() {}
    track() {}
    cleanup() {}
    cycle() {
        this.setup();
        this.track();
        this.cleanup();
    }
    webInteraction(webInteraction) {
        return {
            xdm: {},
            data: {
                web: {
                    webInteraction: webInteraction
                }
            }
        };
    }
    send(type, event) {
        console.log("Sent event", {
            [type]: event
        });
        this.logger({
            [type]: event
        });
        window._satellite.track(type, event);
    }
    constructor(){
        const { logAnalytics: logAnalytics } = (0, $eKTtn.getLoggers)();
        this.logger = logAnalytics;
    }
}
class $792bc20cac09f36f$var$StateEvent extends $792bc20cac09f36f$export$30b7662faa307ee {
    track() {
        this.send("state", {});
    }
    setup() {
        window.alloy_all.set((0, $6FAcS.CUSTOM_PAGENAME_PROP), this.stateName);
    }
    constructor(stateName){
        super();
        this.stateName = stateName;
    }
}
class $792bc20cac09f36f$var$PageLoadEvent extends $792bc20cac09f36f$export$30b7662faa307ee {
    track() {
        this.send("pageload", {
            [(0, $6FAcS.CUSTOM_PAGENAME_PROP)]: this.pageName
        });
    }
    setup() {
        window.alloy_all.set((0, $6FAcS.CUSTOM_PAGENAME_PROP), this.pageName);
    }
    constructor(pageName){
        super();
        this.pageName = pageName;
    }
}
class $792bc20cac09f36f$var$InteractionEvent extends $792bc20cac09f36f$export$30b7662faa307ee {
    track() {
        this.send("event", this.webInteraction({
            name: `Account:IMS-Light:${this.eventName}`
        }));
    }
    constructor(eventName){
        super();
        this.eventName = eventName;
    }
}
const $792bc20cac09f36f$export$b1d96d5602436b32 = ({ pageName: pageName })=>new $792bc20cac09f36f$var$PageLoadEvent(pageName);
const $792bc20cac09f36f$export$21b0b87ec2baf2c3 = ({ stateName: stateName })=>new $792bc20cac09f36f$var$StateEvent(stateName);
const $792bc20cac09f36f$export$5f71a898dc86d669 = ({ eventName: eventName })=>new $792bc20cac09f36f$var$InteractionEvent(eventName);

});
parcelRegister("6FAcS", function(module, exports) {

$parcel$export(module.exports, "PAGE_INFO_PROP", () => $a89dccfbc98e85d1$export$405cd1d1e669c418);
$parcel$export(module.exports, "IMS_CLIENT_PROP", () => $a89dccfbc98e85d1$export$e2e76eb6250cece8);
$parcel$export(module.exports, "CUSTOM_PAGENAME_PROP", () => $a89dccfbc98e85d1$export$56f11bdc7f6ca7d4);
const $a89dccfbc98e85d1$export$405cd1d1e669c418 = "data._adobe_corpnew.digitalData.page.pageInfo";
const $a89dccfbc98e85d1$export$e2e76eb6250cece8 = "data._adobe_corpnew.digitalData.ims.client";
const $a89dccfbc98e85d1$export$56f11bdc7f6ca7d4 = `${$a89dccfbc98e85d1$export$405cd1d1e669c418}.customPageName`;

});


parcelRegister("8eTxL", function(module, exports) {

$parcel$export(module.exports, "AsyncWrapper", () => $d26afffc060bda10$export$91e508f993b0fdc);
class $d26afffc060bda10$export$91e508f993b0fdc {
    onFulfilled(onfulfilled) {
        this.promise.then.call(this.promise, onfulfilled);
        return this;
    }
    onError(onError) {
        this.promise.catch.call(this.promise, onError);
        return this;
    }
    getOrDefault(defaultValue) {
        if (this.loading || this.result === null) return defaultValue;
        return this.result;
    }
    get(shouldEnforceType = false) {
        return shouldEnforceType ? this.result : this.result;
    }
    static from(asyncable) {
        if (asyncable instanceof $d26afffc060bda10$export$91e508f993b0fdc) return new $d26afffc060bda10$export$91e508f993b0fdc(asyncable.promise, asyncable.result, !asyncable.result);
        if (asyncable instanceof Promise) return new $d26afffc060bda10$export$91e508f993b0fdc(asyncable);
        return new $d26afffc060bda10$export$91e508f993b0fdc(Promise.resolve(asyncable));
    }
    constructor(promise, result = null, loading = true){
        this.promise = promise;
        this.result = result;
        this.loading = loading;
        this.promise = promise;
        this.promise.then((res)=>{
            this.result = res;
        }).finally(()=>{
            this.loading = false;
        });
    }
}

});

parcelRegister("aZiut", function(module, exports) {

$parcel$export(module.exports, "PopupBlockedError", () => $a955f8e6520f22ff$export$ef3cca3d6fbf22f6);
$parcel$export(module.exports, "openPopupDispatcher", () => $a955f8e6520f22ff$export$cf5151a0ce0622ad);
$parcel$export(module.exports, "openModalDispatcher", () => $a955f8e6520f22ff$export$ff31d376ce7bb080);

var $8Mzka = parcelRequire("8Mzka");
class $a955f8e6520f22ff$export$ef3cca3d6fbf22f6 extends Error {
}
async function $a955f8e6520f22ff$export$cf5151a0ce0622ad(expectedEvent, url, events, eventScheduler) {
    const popupOpened = eventScheduler.listenFor((0, $8Mzka.OpenPopupCompleteEvent));
    const popupBlocked = eventScheduler.listenFor((0, $8Mzka.OpenPopupBlockedEvent));
    const resultPromise = Promise.race([
        popupOpened,
        popupBlocked
    ]);
    events.openPopup(url({
        state: expectedEvent.toString()
    })());
    const popupResult = await resultPromise;
    if ((0, $8Mzka.OpenPopupBlockedEvent).compareTo(popupResult)) return Promise.reject(new $a955f8e6520f22ff$export$ef3cca3d6fbf22f6());
    else {
        const expectedEventPromise = eventScheduler.listenFor(expectedEvent);
        const errorEventPromise = eventScheduler.listenFor((0, $8Mzka.OpenPopupErrorEvent));
        const result = Promise.race([
            expectedEventPromise,
            errorEventPromise.then((error)=>Promise.reject(error))
        ]);
        return result;
    }
}
async function $a955f8e6520f22ff$export$ff31d376ce7bb080(port, events, eventScheduler, dimensions, reason) {
    const returnEventPromise = eventScheduler.listenFor((0, $8Mzka.OpenModalCompleteEvent));
    events.openModal({
        dimensions: dimensions,
        reason: reason
    });
    return returnEventPromise;
}

});

parcelRegister("j9pM9", function(module, exports) {

$parcel$export(module.exports, "features", () => $9275c79d27ebdff4$export$606190e461fe9031);

var $4qQFI = parcelRequire("4qQFI");

var $4AFyb = parcelRequire("4AFyb");
function $9275c79d27ebdff4$export$c506eb22e615ba4a() {
    const qs = (0, $4AFyb.queryState).fromQueryString(document.location.search.substring(1));
    return qs.sl_version;
}
function $9275c79d27ebdff4$export$abe8d228baad9e53(getVersion) {
    return (version)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($4qQFI)))(getVersion(), version) >= 0;
}
function $9275c79d27ebdff4$export$5b5793e74f2c4e5(requirements) {
    return ()=>requirements.every((check)=>check());
}
const $9275c79d27ebdff4$export$14efdf93d70b7f9b = {
    "greaterThan1.0.1": $9275c79d27ebdff4$export$abe8d228baad9e53($9275c79d27ebdff4$export$c506eb22e615ba4a)("1.0.1"),
    disabled: ()=>false
};
const $9275c79d27ebdff4$export$606190e461fe9031 = {
    hasTestFeature: $9275c79d27ebdff4$export$5b5793e74f2c4e5([
        $9275c79d27ebdff4$export$14efdf93d70b7f9b["greaterThan1.0.1"]
    ]),
    hasModalMode: $9275c79d27ebdff4$export$5b5793e74f2c4e5([
        $9275c79d27ebdff4$export$14efdf93d70b7f9b["greaterThan1.0.1"]
    ])
};

});
parcelRegister("4qQFI", function(module, exports) {
module.exports = function cmp(a, b) {
    var pa = a.split(".");
    var pb = b.split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    return 0;
};

});




parcelRegister("4vDzg", function(module, exports) {

$parcel$export(module.exports, "Controller", () => $507072ffaa1cbf49$export$bd0bf19f25da8474);

var $9atrf = parcelRequire("9atrf");

var $54Kxt = parcelRequire("54Kxt");

var $ermYl = parcelRequire("ermYl");

var $quUqX = parcelRequire("quUqX");

var $1VxQB = parcelRequire("1VxQB");

var $743Bh = parcelRequire("743Bh");

var $8Mzka = parcelRequire("8Mzka");
class $507072ffaa1cbf49$export$bd0bf19f25da8474 extends (0, $54Kxt.PageController) {
    async onSignInClicked() {
        try {
            const { events: events, eventListener: eventListener, queryState: queryState } = await this.getApplicationState();
            if (queryState.response_type === "code") {
                const { data: { code: code } } = await (0, $quUqX.signInAdobePopup).withAuthCode(events, eventListener(), queryState);
                return new (0, $743Bh.AuthCodeOutcome)({
                    code: code
                });
            } else {
                const { data: { access_token: access_token } } = await (0, $quUqX.signInAdobePopup).withAccessToken(events, eventListener(), queryState);
                return new (0, $743Bh.TokenOutcome)({
                    token: access_token
                });
            }
        } catch (e) {
            const message = e instanceof Error ? e.message : e;
            return new (0, $ermYl.CriticalOutcome)((0, $8Mzka.SentryError).unrecoverable(message));
        }
    }
    constructor(...args){
        super(...args);
        this.getApplicationState = (0, $1VxQB.getApplicationState);
    }
}
(0, $9atrf.__decorate)([
    (0, $54Kxt.OutcomeListener)()
], $507072ffaa1cbf49$export$bd0bf19f25da8474.prototype, "onSignInClicked", null);

});
parcelRegister("54Kxt", function(module, exports) {

$parcel$export(module.exports, "OutcomeListener", () => $6767d35e913d3dec$export$814905fad295fdfb);
$parcel$export(module.exports, "PageController", () => $6767d35e913d3dec$export$e56066534e81419d);
function $6767d35e913d3dec$export$814905fad295fdfb() {
    return (target, propertyKey, descriptor)=>{
        const originalMethod = descriptor.value;
        descriptor.value = async function(...args) {
            const outcome = await originalMethod.apply(this, args);
            this.outcomePromise.resolve(outcome);
        };
        return descriptor;
    };
}
class $6767d35e913d3dec$export$af4d857c5c37e45f {
    constructor(){
        this.resolve = ()=>{};
        this.promise = new Promise((resolve)=>this.resolve = resolve);
    }
}
class $6767d35e913d3dec$export$e56066534e81419d {
    get state() {
        return this.store.getState();
    }
    constructor(store){
        this.store = store;
        this.outcomePromise = new $6767d35e913d3dec$export$af4d857c5c37e45f();
        this.store = store;
    }
}

});

parcelRegister("quUqX", function(module, exports) {

$parcel$export(module.exports, "signInPasskeyPopup", () => $c7a94188963c1d69$export$6f308aa80d772f7a);
$parcel$export(module.exports, "signInAdobePopup", () => $c7a94188963c1d69$export$4393aacbc0aeed64);
$parcel$export(module.exports, "createAccountAdobePopup", () => $c7a94188963c1d69$export$f3bed0f0fe5cb5aa);
$parcel$export(module.exports, "socialWebDeeplinkPopup", () => $c7a94188963c1d69$export$f979fe2a99469d61);
$parcel$export(module.exports, "socialFederatedPopup", () => $c7a94188963c1d69$export$74adf700892142a8);

var $aZiut = parcelRequire("aZiut");

var $4AFyb = parcelRequire("4AFyb");

var $8Mzka = parcelRequire("8Mzka");

var $gbPs2 = parcelRequire("gbPs2");
function $c7a94188963c1d69$var$popupHandler(returnedEvent, urlBuilder, queryStateModifiers = []) {
    return async (events, eventScheduler, queryState)=>{
        const query = (0, $4AFyb.qsModifier).omit(queryState, [
            "redirect_uri"
        ]);
        const url = urlBuilder((0, $4AFyb.queryState).toObject(queryStateModifiers.reduce((acc, modifier)=>modifier(acc), query)));
        try {
            sessionStorage.setItem("client_id", queryState.client_id);
            sessionStorage.setItem("relay", queryState.relay);
        } catch (e) {}
        const eventWithState = returnedEvent.setData({
            ...typeof returnedEvent.data === "object" && returnedEvent.data !== null ? returnedEvent.data : {},
            returnOrigin: window.location.origin,
            client_id: queryState.client_id,
            clientId: queryState.client_id,
            relay: queryState.relay,
            useMessageChannel: true
        });
        // @ts-expect-error
        returnedEvent.clientId = queryState.client_id;
        return (0, $aZiut.openPopupDispatcher)(eventWithState, url, events, eventScheduler);
    };
}
const $c7a94188963c1d69$var$addSUSILightOriginCheck = (queryState)=>({
        ...queryState,
        ...queryState.wrapper ? {
            sl: queryState.asserted_origin
        } : {}
    });
const $c7a94188963c1d69$export$fe632e24a2fc36d = (0, $8Mzka.Event).create({
    side: "popup",
    name: "AccessTokenFlow",
    data: {
        access_token: ""
    }
});
const $c7a94188963c1d69$export$696da0ca85903e14 = (0, $8Mzka.Event).create({
    side: "popup",
    name: "AuthCodeFlow",
    data: {
        code: ""
    }
});
const $c7a94188963c1d69$export$b667334236713110 = (0, $8Mzka.Event).create({
    side: "popup",
    name: "FederatedJWTFlow",
    data: {
        token: ""
    }
});
const $c7a94188963c1d69$export$9d135a68cd09a6d4 = (flow, urlBuilder)=>$c7a94188963c1d69$var$popupHandler(flow, urlBuilder, [
        $c7a94188963c1d69$var$addSUSILightOriginCheck
    ]);
const $c7a94188963c1d69$export$6f308aa80d772f7a = {
    withAccessToken: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$fe632e24a2fc36d, (0, $gbPs2.passkeyDeeplinkPopupUrl)),
    withAuthCode: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$696da0ca85903e14, (0, $gbPs2.passkeyDeeplinkPopupUrl))
};
const $c7a94188963c1d69$export$4393aacbc0aeed64 = {
    withAccessToken: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$fe632e24a2fc36d, (0, $gbPs2.signInAdobePopupUrl)),
    withAuthCode: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$696da0ca85903e14, (0, $gbPs2.signInAdobePopupUrl))
};
const $c7a94188963c1d69$export$f3bed0f0fe5cb5aa = {
    withAccessToken: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$fe632e24a2fc36d, (0, $gbPs2.createAccountAdobePopupUrl)),
    withAuthCode: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$696da0ca85903e14, (0, $gbPs2.createAccountAdobePopupUrl))
};
const $c7a94188963c1d69$export$f979fe2a99469d61 = (provider)=>({
        withAccessToken: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$fe632e24a2fc36d, (0, $gbPs2.socialWebDeeplinkPopupUrl)({
            provider_id: provider
        })),
        withAuthCode: $c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$696da0ca85903e14, (0, $gbPs2.socialWebDeeplinkPopupUrl)({
            provider_id: provider
        }))
    });
const $c7a94188963c1d69$export$74adf700892142a8 = (provider)=>$c7a94188963c1d69$export$9d135a68cd09a6d4($c7a94188963c1d69$export$b667334236713110, (0, $gbPs2.federatedPopupUrl)(provider));

});
parcelRegister("gbPs2", function(module, exports) {

$parcel$export(module.exports, "tempestRedirectUrl", () => $0c43d646612cb70f$export$5360be9ac7d53089);
$parcel$export(module.exports, "signInAdobeUrl", () => $0c43d646612cb70f$export$d33b266110370e44);
$parcel$export(module.exports, "signInAdobePopupUrl", () => $0c43d646612cb70f$export$91a4b2066045d28e);
$parcel$export(module.exports, "createAccountAdobeUrl", () => $0c43d646612cb70f$export$866858ab0abec8e6);
$parcel$export(module.exports, "createAccountAdobePopupUrl", () => $0c43d646612cb70f$export$cae1c90cf54ce58b);
$parcel$export(module.exports, "socialWebDeeplinkUrl", () => $0c43d646612cb70f$export$f7bcb7786cf7b854);
$parcel$export(module.exports, "socialWebDeeplinkPopupUrl", () => $0c43d646612cb70f$export$cddc5e8d19e2a90);
$parcel$export(module.exports, "federatedPopupUrl", () => $0c43d646612cb70f$export$2573d79569766cb1);
$parcel$export(module.exports, "passkeyDeeplinkUrl", () => $0c43d646612cb70f$export$fd04bb65b4e94307);
$parcel$export(module.exports, "passkeyDeeplinkPopupUrl", () => $0c43d646612cb70f$export$79db768d008e2c19);

var $8Mzka = parcelRequire("8Mzka");

var $kG7rf = parcelRequire("kG7rf");

var $1muu2 = parcelRequire("1muu2");

var $dQqBy = parcelRequire("dQqBy");
const { getPopupUrl: $0c43d646612cb70f$var$getPopupUrl, getApiUrl: $0c43d646612cb70f$var$getApiUrl, getFederatedUrl: $0c43d646612cb70f$var$getFederatedUrl, getAuthServicesUrl: $0c43d646612cb70f$var$getAuthServicesUrl } = (0, $8Mzka.urls).create((0, $8Mzka.envs).getAppEnv);
function $0c43d646612cb70f$var$transformLocale(locale) {
    // transforms en-us to en_US
    return locale.replace(/-(\w+)/, (_, countryCode)=>"_" + `${countryCode.toUpperCase()}`);
}
const $0c43d646612cb70f$var$ADOBE_AUTHORIZE = (0, $1muu2.urlBuilder)("/ims/authorize/v3", $0c43d646612cb70f$var$getApiUrl());
const $0c43d646612cb70f$var$FEDERATED_AUTHORIZE = (socialProvider)=>(0, $1muu2.urlBuilder)(`/federated/authorize/${socialProvider}`, $0c43d646612cb70f$var$getFederatedUrl());
const $0c43d646612cb70f$var$TEMPEST_DEEPLINK = (0, $1muu2.urlBuilder)(`/${$0c43d646612cb70f$var$transformLocale((0, $dQqBy.getLocale)())}/deeplink.html`, $0c43d646612cb70f$var$getAuthServicesUrl());
const $0c43d646612cb70f$export$5360be9ac7d53089 = $0c43d646612cb70f$var$TEMPEST_DEEPLINK({});
const $0c43d646612cb70f$var$GOOGLE_AUTHORIZE = (0, $1muu2.urlBuilder)("/o/oauth2/v2/auth/oauthchooseaccount", "https://accounts.google.com");
const $0c43d646612cb70f$var$googleSignInUrl = $0c43d646612cb70f$var$GOOGLE_AUTHORIZE((0, $kG7rf.googleQueryString));
const $0c43d646612cb70f$export$d33b266110370e44 = $0c43d646612cb70f$var$ADOBE_AUTHORIZE({});
const $0c43d646612cb70f$export$91a4b2066045d28e = $0c43d646612cb70f$var$ADOBE_AUTHORIZE({
    redirect_uri: $0c43d646612cb70f$var$getPopupUrl(),
    response_type: "token"
});
const $0c43d646612cb70f$export$866858ab0abec8e6 = $0c43d646612cb70f$var$ADOBE_AUTHORIZE({
    idp_flow: "create_account"
});
const $0c43d646612cb70f$export$cae1c90cf54ce58b = $0c43d646612cb70f$export$866858ab0abec8e6({
    redirect_uri: $0c43d646612cb70f$var$getPopupUrl(),
    response_type: "token"
});
const $0c43d646612cb70f$export$f7bcb7786cf7b854 = $0c43d646612cb70f$var$ADOBE_AUTHORIZE({
    idp_flow: "social.deep_link.web"
});
const $0c43d646612cb70f$export$cddc5e8d19e2a90 = $0c43d646612cb70f$export$f7bcb7786cf7b854({
    redirect_uri: $0c43d646612cb70f$var$getPopupUrl(),
    response_type: "token"
});
const $0c43d646612cb70f$export$2573d79569766cb1 = (socialProvider)=>$0c43d646612cb70f$var$FEDERATED_AUTHORIZE(socialProvider)({
        redirectUri: $0c43d646612cb70f$var$getPopupUrl(),
        response_mode: "fragment"
    });
const $0c43d646612cb70f$export$fd04bb65b4e94307 = $0c43d646612cb70f$var$ADOBE_AUTHORIZE({
    idp_flow: "passkeys.deep_link.web"
});
const $0c43d646612cb70f$export$79db768d008e2c19 = $0c43d646612cb70f$export$fd04bb65b4e94307({
    redirect_uri: $0c43d646612cb70f$var$getPopupUrl(),
    response_type: "token"
});

});
parcelRegister("kG7rf", function(module, exports) {

$parcel$export(module.exports, "googleQueryString", () => $01ed17984f5a757b$export$25d0f456a19825b0);

var $31b1g = parcelRequire("31b1g");

var $8Mzka = parcelRequire("8Mzka");

var $4ZCEJ = parcelRequire("4ZCEJ");
const { getPopupUrl: $01ed17984f5a757b$var$getPopupUrl } = (0, $8Mzka.urls).create((0, $8Mzka.envs).getAppEnv);
const $01ed17984f5a757b$export$25d0f456a19825b0 = {
    client_id: "60187432700-kuegfobnu2gras7jgo316k1h530t8v9t.apps.googleusercontent.com",
    redirect_uri: $01ed17984f5a757b$var$getPopupUrl() || "",
    scope: "email openid profile",
    response_type: "token id_token",
    nonce: (0, $31b1g.nanoid)(),
    state: JSON.stringify({
        provider: (0, $4ZCEJ.PROVIDERS).google
    })
};

});
parcelRegister("31b1g", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $232a034e0fdcb153$export$ac4959f4f1338dfc);

let $232a034e0fdcb153$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $232a034e0fdcb153$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $232a034e0fdcb153$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$232a034e0fdcb153$export$a5cee9e955a615e5(alphabet, size, $232a034e0fdcb153$export$4385e60b38654f68);
let $232a034e0fdcb153$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});


parcelRegister("1muu2", function(module, exports) {

$parcel$export(module.exports, "urlBuilder", () => $a74bf19ea6dd3726$export$895dc18a497d8dd8);
const $a74bf19ea6dd3726$var$PARAMETER_BLACKLIST = [
    "sl_build",
    "sl_buildtime"
];
const $a74bf19ea6dd3726$var$validateString = (input, inputName)=>{
    if (typeof input !== "string") throw new TypeError(`${inputName} must be a string`);
    if (input.length === 0) throw new Error(`${inputName} cannot be an empty string`);
};
const $a74bf19ea6dd3726$export$895dc18a497d8dd8 = (endpoint, baseUrl)=>{
    $a74bf19ea6dd3726$var$validateString(endpoint, "Endpoint");
    $a74bf19ea6dd3726$var$validateString(baseUrl, "Base URL");
    try {
        new URL(endpoint, baseUrl);
    } catch (error) {
        throw new Error("Invalid endpoint and/or base URL");
    }
    function urlBuild(url) {
        function addSearchParams(searchParams) {
            const urlProgress = new URL(url.toString());
            if (searchParams === undefined) return urlProgress.toString();
            Object.entries(searchParams).filter(([key])=>!$a74bf19ea6dd3726$var$PARAMETER_BLACKLIST.includes(key)).forEach(([key, value])=>{
                $a74bf19ea6dd3726$var$validateString(key, "Search parameter key");
                $a74bf19ea6dd3726$var$validateString(value, "Search parameter value");
                urlProgress.searchParams.set(key, value);
            });
            return urlBuild(urlProgress);
        }
        return addSearchParams;
    }
    return urlBuild(new URL(endpoint, baseUrl));
};

});



parcelRegister("743Bh", function(module, exports) {

$parcel$export(module.exports, "RedirectOutcome", () => $75cad5f364dfca5d$export$3d6a34a05baf40ab);
$parcel$export(module.exports, "TokenOutcome", () => $75cad5f364dfca5d$export$34e580c4dd62f715);
$parcel$export(module.exports, "AuthCodeOutcome", () => $75cad5f364dfca5d$export$e39d982398331a19);
$parcel$export(module.exports, "AuthFailedOutcome", () => $75cad5f364dfca5d$export$a4d74fdb0c68788a);
$parcel$export(module.exports, "CompleteAccountRequiredOutcome", () => $75cad5f364dfca5d$export$3069058f1247dacf);

var $ermYl = parcelRequire("ermYl");
class $75cad5f364dfca5d$export$3d6a34a05baf40ab extends (0, $ermYl.Outcome) {
}
class $75cad5f364dfca5d$export$34e580c4dd62f715 extends (0, $ermYl.Outcome) {
}
class $75cad5f364dfca5d$export$e39d982398331a19 extends (0, $ermYl.Outcome) {
}
class $75cad5f364dfca5d$export$a4d74fdb0c68788a extends (0, $ermYl.Outcome) {
}
class $75cad5f364dfca5d$export$3069058f1247dacf extends (0, $ermYl.Outcome) {
}

});


parcelRegister("gtK3D", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("7i0aA"))((parcelRequire("feccm")).resolve("9dnNp")),
    (parcelRequire("7i0aA"))((parcelRequire("feccm")).resolve("67vs0"))
]).then(()=>parcelRequire("4CsgZ"));

});


parcelRegister("akUfC", function(module, exports) {

$parcel$export(module.exports, "endOfFlow", () => $c9e7c18cfe45607c$export$d62e53e10f076c71);
$parcel$export(module.exports, "unhandledEndOfFlow", () => $c9e7c18cfe45607c$export$bd5518cf21983951);

var $ermYl = parcelRequire("ermYl");

var $jsjcF = parcelRequire("jsjcF");
async function $c9e7c18cfe45607c$export$d62e53e10f076c71(events, outcome) {
    if (outcome.isHandled) return;
    try {
        if (outcome.of((0, $ermYl.CriticalOutcome))) return (0, $jsjcF.criticalErrorFlow)(events, outcome);
    } catch (e) {
        return (0, $jsjcF.unrecoverableErrorFlow)(events, outcome);
    }
    throw new Error(`Unreachable code reached for value: ${JSON.stringify(outcome)}`);
}
function $c9e7c18cfe45607c$export$bd5518cf21983951(outcome) {
    throw new Error(`Unreachable code reached for value: ${JSON.stringify(outcome)}`);
}

});


parcelRegister("48dd2", function(module, exports) {

$parcel$export(module.exports, "CONSENT_VALUES", () => $f7868fc19d0f7f5b$export$f770d8392c66c713);
$parcel$export(module.exports, "CONSENT_PROFILES", () => $f7868fc19d0f7f5b$export$4c967d574830cab2);
$parcel$export(module.exports, "ConsentProfileSchema", () => $f7868fc19d0f7f5b$export$f2996b0b914cff6c);

var $8L18p = parcelRequire("8L18p");
const $f7868fc19d0f7f5b$export$f770d8392c66c713 = {
    implicit: "implicit",
    explicit: "explicit",
    soft: "soft"
};
const $f7868fc19d0f7f5b$export$4c967d574830cab2 = {
    adobeIdSignUp: "adobe-id-sign-up",
    purchase: "purchase",
    quoteRequest: "quote-request",
    trial: "trial",
    free: "free"
};
const $f7868fc19d0f7f5b$export$f2996b0b914cff6c = (0, $8L18p.default).nativeEnum($f7868fc19d0f7f5b$export$4c967d574830cab2);

});

parcelRegister("2iWIC", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $f1657d6d7ac010c8$export$19342e026b58ebb7);

var $8L18p = parcelRequire("8L18p");
const $f1657d6d7ac010c8$export$19342e026b58ebb7 = (0, $8L18p.default).object({});

});

parcelRegister("4ewU9", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $c3feb0e96a414f95$export$19342e026b58ebb7);

var $8L18p = parcelRequire("8L18p");
const $c3feb0e96a414f95$export$19342e026b58ebb7 = (0, $8L18p.default).object({
    variant: (0, $8L18p.default).literal("express-theme")
});

});


var $8Mzka = parcelRequire("8Mzka");

parcelRequire("ivbvd");
var $5H6ys = parcelRequire("5H6ys");
"use strict";
const $5184aaf250a298a2$var$t = (0, $5H6ys.css)`
:host,:root{--spectrum-global-dimension-scale-factor:1;--spectrum-global-dimension-size-0:0px;--spectrum-global-dimension-size-10:1px;--spectrum-global-dimension-size-25:2px;--spectrum-global-dimension-size-30:2px;--spectrum-global-dimension-size-40:3px;--spectrum-global-dimension-size-50:4px;--spectrum-global-dimension-size-65:5px;--spectrum-global-dimension-size-75:6px;--spectrum-global-dimension-size-85:7px;--spectrum-global-dimension-size-100:8px;--spectrum-global-dimension-size-115:9px;--spectrum-global-dimension-size-125:10px;--spectrum-global-dimension-size-130:11px;--spectrum-global-dimension-size-150:12px;--spectrum-global-dimension-size-160:13px;--spectrum-global-dimension-size-175:14px;--spectrum-global-dimension-size-185:15px;--spectrum-global-dimension-size-200:16px;--spectrum-global-dimension-size-225:18px;--spectrum-global-dimension-size-250:20px;--spectrum-global-dimension-size-275:22px;--spectrum-global-dimension-size-300:24px;--spectrum-global-dimension-size-325:26px;--spectrum-global-dimension-size-350:28px;--spectrum-global-dimension-size-400:32px;--spectrum-global-dimension-size-450:36px;--spectrum-global-dimension-size-500:40px;--spectrum-global-dimension-size-550:44px;--spectrum-global-dimension-size-600:48px;--spectrum-global-dimension-size-650:52px;--spectrum-global-dimension-size-675:54px;--spectrum-global-dimension-size-700:56px;--spectrum-global-dimension-size-750:60px;--spectrum-global-dimension-size-800:64px;--spectrum-global-dimension-size-900:72px;--spectrum-global-dimension-size-1000:80px;--spectrum-global-dimension-size-1125:90px;--spectrum-global-dimension-size-1200:96px;--spectrum-global-dimension-size-1250:100px;--spectrum-global-dimension-size-1600:128px;--spectrum-global-dimension-size-1700:136px;--spectrum-global-dimension-size-1800:144px;--spectrum-global-dimension-size-2000:160px;--spectrum-global-dimension-size-2400:192px;--spectrum-global-dimension-size-2500:200px;--spectrum-global-dimension-size-3000:240px;--spectrum-global-dimension-size-3400:272px;--spectrum-global-dimension-size-3600:288px;--spectrum-global-dimension-size-4600:368px;--spectrum-global-dimension-size-5000:400px;--spectrum-global-dimension-size-6000:480px;--spectrum-global-dimension-font-size-25:10px;--spectrum-global-dimension-font-size-50:11px;--spectrum-global-dimension-font-size-75:12px;--spectrum-global-dimension-font-size-100:14px;--spectrum-global-dimension-font-size-150:15px;--spectrum-global-dimension-font-size-200:16px;--spectrum-global-dimension-font-size-300:18px;--spectrum-global-dimension-font-size-400:20px;--spectrum-global-dimension-font-size-500:22px;--spectrum-global-dimension-font-size-600:25px;--spectrum-global-dimension-font-size-700:28px;--spectrum-global-dimension-font-size-800:32px;--spectrum-global-dimension-font-size-900:36px;--spectrum-global-dimension-font-size-1000:40px;--spectrum-global-dimension-font-size-1100:45px;--spectrum-global-dimension-font-size-1200:50px;--spectrum-global-dimension-font-size-1300:60px;--spectrum-alias-item-text-padding-top-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-text-padding-bottom-s:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-item-workflow-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-rounded-workflow-padding-left-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-item-rounded-workflow-padding-left-xl:21px;--spectrum-alias-item-mark-padding-top-m:var(
--spectrum-global-dimension-static-size-75
);--spectrum-alias-item-mark-padding-bottom-m:var(
--spectrum-global-dimension-static-size-75
);--spectrum-alias-item-mark-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-1-size-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-1-size-xl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-2-size-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-3-height-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-3-width-s:23px;--spectrum-alias-item-control-3-width-m:var(
--spectrum-global-dimension-static-size-325
);--spectrum-alias-item-control-3-width-l:29px;--spectrum-alias-item-control-3-width-xl:33px;--spectrum-alias-item-mark-size-m:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-component-focusring-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-control-two-size-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-control-three-height-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-control-three-width-s:23px;--spectrum-alias-control-three-width-m:var(
--spectrum-global-dimension-static-size-325
);--spectrum-alias-control-three-width-l:29px;--spectrum-alias-control-three-width-xl:33px;--spectrum-alias-search-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-focus-ring-border-radius-regular:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-focus-ring-radius-default:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-workflow-icon-size-l:var(
--spectrum-global-dimension-static-size-250
);--spectrum-alias-ui-icon-chevron-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-chevron-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-chevron-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-chevron-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-chevron-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-chevron-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-50:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-checkmark-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-checkmark-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-600:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-dash-size-50:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-dash-size-75:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-dash-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-dash-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-dash-size-300:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-dash-size-400:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-dash-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-dash-size-600:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-cross-size-75:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-cross-size-100:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-cross-size-200:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-cross-size-300:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-cross-size-400:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-cross-size-500:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-cross-size-600:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-arrow-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-arrow-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-arrow-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-arrow-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-arrow-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-arrow-size-500:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-arrow-size-600:var(
--spectrum-global-dimension-static-size-250
);--spectrum-alias-ui-icon-triplegripper-size-100-width:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-doublegripper-size-100-height:var(
--spectrum-global-dimension-static-size-50
);--spectrum-alias-ui-icon-singlegripper-size-100-height:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-ui-icon-cornertriangle-size-100:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-ui-icon-cornertriangle-size-300:var(
--spectrum-global-dimension-static-size-85
);--spectrum-alias-ui-icon-asterisk-size-200:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-asterisk-size-300:var(
--spectrum-global-dimension-static-size-125
);--spectrum-dialog-confirm-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-confirm-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-confirm-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-listitem-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-listitem-m-textthumbnail-padding-left:var(
--spectrum-global-dimension-size-125
)}:host,:root{--spectrum-global-alias-appframe-border-size:2px}:host,:root{--spectrum-field-label-text-to-asterisk-small:4px;--spectrum-field-label-text-to-asterisk-medium:4px;--spectrum-field-label-text-to-asterisk-large:5px;--spectrum-field-label-text-to-asterisk-extra-large:5px;--spectrum-field-label-top-to-asterisk-small:8px;--spectrum-field-label-top-to-asterisk-medium:12px;--spectrum-field-label-top-to-asterisk-large:15px;--spectrum-field-label-top-to-asterisk-extra-large:19px;--spectrum-field-label-top-margin-small:0px;--spectrum-field-label-top-margin-medium:4px;--spectrum-field-label-top-margin-large:5px;--spectrum-field-label-top-margin-extra-large:5px;--spectrum-field-label-to-component-quiet-small:-8px;--spectrum-field-label-to-component-quiet-medium:-8px;--spectrum-field-label-to-component-quiet-large:-12px;--spectrum-field-label-to-component-quiet-extra-large:-15px;--spectrum-help-text-top-to-workflow-icon-small:4px;--spectrum-help-text-top-to-workflow-icon-medium:3px;--spectrum-help-text-top-to-workflow-icon-large:6px;--spectrum-help-text-top-to-workflow-icon-extra-large:9px;--spectrum-status-light-dot-size-small:8px;--spectrum-status-light-dot-size-medium:8px;--spectrum-status-light-dot-size-large:10px;--spectrum-status-light-dot-size-extra-large:10px;--spectrum-status-light-top-to-dot-small:8px;--spectrum-status-light-top-to-dot-medium:12px;--spectrum-status-light-top-to-dot-large:15px;--spectrum-status-light-top-to-dot-extra-large:19px;--spectrum-action-button-edge-to-hold-icon-extra-small:3px;--spectrum-action-button-edge-to-hold-icon-small:3px;--spectrum-action-button-edge-to-hold-icon-medium:4px;--spectrum-action-button-edge-to-hold-icon-large:5px;--spectrum-action-button-edge-to-hold-icon-extra-large:6px;--spectrum-tooltip-tip-width:8px;--spectrum-tooltip-tip-height:4px;--spectrum-tooltip-maximum-width:160px;--spectrum-progress-circle-size-small:16px;--spectrum-progress-circle-size-medium:32px;--spectrum-progress-circle-size-large:64px;--spectrum-progress-circle-thickness-small:2px;--spectrum-progress-circle-thickness-medium:3px;--spectrum-progress-circle-thickness-large:4px;--spectrum-toast-height:48px;--spectrum-toast-maximum-width:336px;--spectrum-toast-top-to-workflow-icon:15px;--spectrum-toast-top-to-text:14px;--spectrum-toast-bottom-to-text:17px;--spectrum-action-bar-height:48px;--spectrum-action-bar-top-to-item-counter:14px;--spectrum-swatch-size-extra-small:16px;--spectrum-swatch-size-small:24px;--spectrum-swatch-size-medium:32px;--spectrum-swatch-size-large:40px;--spectrum-progress-bar-thickness-small:4px;--spectrum-progress-bar-thickness-medium:6px;--spectrum-progress-bar-thickness-large:8px;--spectrum-progress-bar-thickness-extra-large:10px;--spectrum-meter-default-width:192px;--spectrum-meter-thickness-small:4px;--spectrum-meter-thickness-large:6px;--spectrum-tag-top-to-avatar-small:4px;--spectrum-tag-top-to-avatar-medium:6px;--spectrum-tag-top-to-avatar-large:9px;--spectrum-tag-top-to-cross-icon-small:8px;--spectrum-tag-top-to-cross-icon-medium:12px;--spectrum-tag-top-to-cross-icon-large:15px;--spectrum-popover-top-to-content-area:4px;--spectrum-menu-item-edge-to-content-not-selected-small:28px;--spectrum-menu-item-edge-to-content-not-selected-medium:32px;--spectrum-menu-item-edge-to-content-not-selected-large:38px;--spectrum-menu-item-edge-to-content-not-selected-extra-large:45px;--spectrum-menu-item-top-to-disclosure-icon-small:7px;--spectrum-menu-item-top-to-disclosure-icon-medium:11px;--spectrum-menu-item-top-to-disclosure-icon-large:14px;--spectrum-menu-item-top-to-disclosure-icon-extra-large:17px;--spectrum-menu-item-top-to-selected-icon-small:7px;--spectrum-menu-item-top-to-selected-icon-medium:11px;--spectrum-menu-item-top-to-selected-icon-large:14px;--spectrum-menu-item-top-to-selected-icon-extra-large:17px;--spectrum-picker-visual-to-disclosure-icon-small:7px;--spectrum-picker-visual-to-disclosure-icon-medium:8px;--spectrum-picker-visual-to-disclosure-icon-large:9px;--spectrum-picker-visual-to-disclosure-icon-extra-large:10px;--spectrum-text-area-minimum-width:112px;--spectrum-text-area-minimum-height:56px;--spectrum-combo-box-visual-to-field-button-small:7px;--spectrum-combo-box-visual-to-field-button-medium:8px;--spectrum-combo-box-visual-to-field-button-large:9px;--spectrum-combo-box-visual-to-field-button-extra-large:10px;--spectrum-thumbnail-size-50:16px;--spectrum-thumbnail-size-75:18px;--spectrum-thumbnail-size-100:20px;--spectrum-thumbnail-size-200:22px;--spectrum-thumbnail-size-300:26px;--spectrum-thumbnail-size-400:28px;--spectrum-thumbnail-size-500:32px;--spectrum-thumbnail-size-600:36px;--spectrum-thumbnail-size-700:40px;--spectrum-thumbnail-size-800:44px;--spectrum-thumbnail-size-900:50px;--spectrum-thumbnail-size-1000:56px;--spectrum-alert-dialog-title-size:var(--spectrum-heading-size-s);--spectrum-alert-dialog-description-size:var(--spectrum-body-size-s);--spectrum-opacity-checkerboard-square-size:8px;--spectrum-breadcrumbs-height-multiline:72px;--spectrum-breadcrumbs-top-to-text:13px;--spectrum-breadcrumbs-top-to-text-compact:11px;--spectrum-breadcrumbs-top-to-text-multiline:12px;--spectrum-breadcrumbs-bottom-to-text:15px;--spectrum-breadcrumbs-bottom-to-text-compact:12px;--spectrum-breadcrumbs-bottom-to-text-multiline:9px;--spectrum-breadcrumbs-start-edge-to-text:8px;--spectrum-breadcrumbs-top-text-to-bottom-text:9px;--spectrum-breadcrumbs-top-to-separator-icon:19px;--spectrum-breadcrumbs-top-to-separator-icon-compact:15px;--spectrum-breadcrumbs-top-to-separator-icon-multiline:15px;--spectrum-breadcrumbs-separator-icon-to-bottom-text-multiline:11px;--spectrum-breadcrumbs-top-to-truncated-menu:8px;--spectrum-breadcrumbs-top-to-truncated-menu-compact:4px;--spectrum-avatar-size-50:16px;--spectrum-avatar-size-75:18px;--spectrum-avatar-size-100:20px;--spectrum-avatar-size-200:22px;--spectrum-avatar-size-300:26px;--spectrum-avatar-size-400:28px;--spectrum-avatar-size-500:32px;--spectrum-avatar-size-600:36px;--spectrum-avatar-size-700:40px;--spectrum-alert-banner-minimum-height:48px;--spectrum-alert-banner-width:832px;--spectrum-alert-banner-to-top-workflow-icon:15px;--spectrum-alert-banner-to-top-text:14px;--spectrum-alert-banner-to-bottom-text:17px;--spectrum-rating-indicator-width:18px;--spectrum-rating-indicator-to-icon:4px;--spectrum-color-area-width:192px;--spectrum-color-area-minimum-width:64px;--spectrum-color-area-height:192px;--spectrum-color-area-minimum-height:64px;--spectrum-color-wheel-width:192px;--spectrum-color-wheel-minimum-width:175px;--spectrum-color-slider-length:192px;--spectrum-color-slider-minimum-length:80px;--spectrum-illustrated-message-title-size:var(--spectrum-heading-size-m);--spectrum-illustrated-message-cjk-title-size:var(
--spectrum-heading-cjk-size-m
);--spectrum-illustrated-message-body-size:var(--spectrum-body-size-s);--spectrum-coach-mark-minimum-width:296px;--spectrum-coach-mark-edge-to-content:var(--spectrum-spacing-400);--spectrum-coach-mark-pagination-text-to-bottom-edge:33px;--spectrum-coach-mark-media-minimum-height:166px;--spectrum-accordion-top-to-text-compact-small:2px;--spectrum-accordion-top-to-text-regular-small:5px;--spectrum-accordion-small-top-to-text-spacious:9px;--spectrum-accordion-top-to-text-compact-medium:4px;--spectrum-accordion-top-to-text-regular-medium:8px;--spectrum-accordion-top-to-text-spacious-medium:12px;--spectrum-accordion-top-to-text-compact-large:4px;--spectrum-accordion-top-to-text-regular-large:9px;--spectrum-accordion-top-to-text-spacious-large:12px;--spectrum-accordion-top-to-text-compact-extra-large:5px;--spectrum-accordion-top-to-text-regular-extra-large:9px;--spectrum-accordion-top-to-text-spacious-extra-large:13px;--spectrum-accordion-bottom-to-text-compact-small:2px;--spectrum-accordion-bottom-to-text-regular-small:7px;--spectrum-accordion-bottom-to-text-spacious-small:11px;--spectrum-accordion-bottom-to-text-compact-medium:5px;--spectrum-accordion-bottom-to-text-regular-medium:9px;--spectrum-accordion-bottom-to-text-spacious-medium:13px;--spectrum-accordion-bottom-to-text-compact-large:8px;--spectrum-accordion-bottom-to-text-regular-large:11px;--spectrum-accordion-bottom-to-text-spacious-large:16px;--spectrum-accordion-bottom-to-text-compact-extra-large:8px;--spectrum-accordion-bottom-to-text-regular-extra-large:12px;--spectrum-accordion-bottom-to-text-spacious-extra-large:16px;--spectrum-accordion-minimum-width:200px;--spectrum-accordion-disclosure-indicator-to-text:0px;--spectrum-accordion-edge-to-disclosure-indicator:0px;--spectrum-accordion-edge-to-text:0px;--spectrum-accordion-focus-indicator-gap:0px;--spectrum-accordion-content-area-top-to-content:8px;--spectrum-accordion-content-area-bottom-to-content:16px;--spectrum-workflow-icon-size-50:14px;--spectrum-workflow-icon-size-75:16px;--spectrum-workflow-icon-size-100:18px;--spectrum-workflow-icon-size-200:20px;--spectrum-workflow-icon-size-300:22px;--spectrum-text-to-visual-50:6px;--spectrum-text-to-visual-75:7px;--spectrum-text-to-visual-100:8px;--spectrum-text-to-visual-200:9px;--spectrum-text-to-visual-300:10px;--spectrum-text-to-control-75:9px;--spectrum-text-to-control-100:10px;--spectrum-text-to-control-200:11px;--spectrum-text-to-control-300:13px;--spectrum-component-height-50:20px;--spectrum-component-height-75:24px;--spectrum-component-height-100:32px;--spectrum-component-height-200:40px;--spectrum-component-height-300:48px;--spectrum-component-height-400:56px;--spectrum-component-height-500:64px;--spectrum-component-pill-edge-to-visual-75:10px;--spectrum-component-pill-edge-to-visual-100:14px;--spectrum-component-pill-edge-to-visual-200:18px;--spectrum-component-pill-edge-to-visual-300:21px;--spectrum-component-pill-edge-to-visual-only-75:4px;--spectrum-component-pill-edge-to-visual-only-100:7px;--spectrum-component-pill-edge-to-visual-only-200:10px;--spectrum-component-pill-edge-to-visual-only-300:13px;--spectrum-component-pill-edge-to-text-75:12px;--spectrum-component-pill-edge-to-text-100:16px;--spectrum-component-pill-edge-to-text-200:20px;--spectrum-component-pill-edge-to-text-300:24px;--spectrum-component-edge-to-visual-50:6px;--spectrum-component-edge-to-visual-75:7px;--spectrum-component-edge-to-visual-100:10px;--spectrum-component-edge-to-visual-200:13px;--spectrum-component-edge-to-visual-300:15px;--spectrum-component-edge-to-visual-only-50:3px;--spectrum-component-edge-to-visual-only-75:4px;--spectrum-component-edge-to-visual-only-100:7px;--spectrum-component-edge-to-visual-only-200:10px;--spectrum-component-edge-to-visual-only-300:13px;--spectrum-component-edge-to-text-50:8px;--spectrum-component-edge-to-text-75:9px;--spectrum-component-edge-to-text-100:12px;--spectrum-component-edge-to-text-200:15px;--spectrum-component-edge-to-text-300:18px;--spectrum-component-top-to-workflow-icon-50:3px;--spectrum-component-top-to-workflow-icon-75:4px;--spectrum-component-top-to-workflow-icon-100:7px;--spectrum-component-top-to-workflow-icon-200:10px;--spectrum-component-top-to-workflow-icon-300:13px;--spectrum-component-top-to-text-50:3px;--spectrum-component-top-to-text-75:4px;--spectrum-component-top-to-text-100:6px;--spectrum-component-top-to-text-200:9px;--spectrum-component-top-to-text-300:12px;--spectrum-component-bottom-to-text-50:3px;--spectrum-component-bottom-to-text-75:5px;--spectrum-component-bottom-to-text-100:9px;--spectrum-component-bottom-to-text-200:11px;--spectrum-component-bottom-to-text-300:14px;--spectrum-component-to-menu-small:6px;--spectrum-component-to-menu-medium:6px;--spectrum-component-to-menu-large:7px;--spectrum-component-to-menu-extra-large:8px;--spectrum-field-edge-to-disclosure-icon-75:7px;--spectrum-field-edge-to-disclosure-icon-100:11px;--spectrum-field-edge-to-disclosure-icon-200:14px;--spectrum-field-edge-to-disclosure-icon-300:17px;--spectrum-field-top-to-alert-icon-small:4px;--spectrum-field-top-to-alert-icon-medium:7px;--spectrum-field-top-to-alert-icon-large:10px;--spectrum-field-top-to-alert-icon-extra-large:13px;--spectrum-field-top-to-validation-icon-small:7px;--spectrum-field-top-to-validation-icon-medium:11px;--spectrum-field-top-to-validation-icon-large:14px;--spectrum-field-top-to-validation-icon-extra-large:17px;--spectrum-field-top-to-progress-circle-small:4px;--spectrum-field-top-to-progress-circle-medium:8px;--spectrum-field-top-to-progress-circle-large:12px;--spectrum-field-top-to-progress-circle-extra-large:16px;--spectrum-field-edge-to-alert-icon-small:9px;--spectrum-field-edge-to-alert-icon-medium:12px;--spectrum-field-edge-to-alert-icon-large:15px;--spectrum-field-edge-to-alert-icon-extra-large:18px;--spectrum-field-edge-to-validation-icon-small:9px;--spectrum-field-edge-to-validation-icon-medium:12px;--spectrum-field-edge-to-validation-icon-large:15px;--spectrum-field-edge-to-validation-icon-extra-large:18px;--spectrum-field-text-to-alert-icon-small:8px;--spectrum-field-text-to-alert-icon-medium:12px;--spectrum-field-text-to-alert-icon-large:15px;--spectrum-field-text-to-alert-icon-extra-large:18px;--spectrum-field-text-to-validation-icon-small:8px;--spectrum-field-text-to-validation-icon-medium:12px;--spectrum-field-text-to-validation-icon-large:15px;--spectrum-field-text-to-validation-icon-extra-large:18px;--spectrum-field-width:192px;--spectrum-character-count-to-field-quiet-small:-3px;--spectrum-character-count-to-field-quiet-medium:-3px;--spectrum-character-count-to-field-quiet-large:-3px;--spectrum-character-count-to-field-quiet-extra-large:-4px;--spectrum-side-label-character-count-to-field:12px;--spectrum-side-label-character-count-top-margin-small:4px;--spectrum-side-label-character-count-top-margin-medium:8px;--spectrum-side-label-character-count-top-margin-large:11px;--spectrum-side-label-character-count-top-margin-extra-large:14px;--spectrum-disclosure-indicator-top-to-disclosure-icon-small:7px;--spectrum-disclosure-indicator-top-to-disclosure-icon-medium:11px;--spectrum-disclosure-indicator-top-to-disclosure-icon-large:14px;--spectrum-disclosure-indicator-top-to-disclosure-icon-extra-large:17px;--spectrum-navigational-indicator-top-to-back-icon-small:7px;--spectrum-navigational-indicator-top-to-back-icon-medium:11px;--spectrum-navigational-indicator-top-to-back-icon-large:14px;--spectrum-navigational-indicator-top-to-back-icon-extra-large:17px;--spectrum-color-control-track-width:24px;--spectrum-font-size-50:11px;--spectrum-font-size-75:12px;--spectrum-font-size-100:14px;--spectrum-font-size-200:16px;--spectrum-font-size-300:18px;--spectrum-font-size-400:20px;--spectrum-font-size-500:22px;--spectrum-font-size-600:25px;--spectrum-font-size-700:28px;--spectrum-font-size-800:32px;--spectrum-font-size-900:36px;--spectrum-font-size-1000:40px;--spectrum-font-size-1100:45px;--spectrum-font-size-1200:50px;--spectrum-font-size-1300:60px}:host,:root{--spectrum-edge-to-visual-only-75:4px;--spectrum-edge-to-visual-only-100:7px;--spectrum-edge-to-visual-only-200:10px;--spectrum-edge-to-visual-only-300:13px;--spectrum-slider-tick-mark-height:10px;--spectrum-slider-ramp-track-height:16px;--spectrum-colorwheel-path:"M 95 95 m -95 0 a 95 95 0 1 0 190 0 a 95 95 0 1 0 -190 0.2 M 95 95 m -73 0 a 73 73 0 1 0 146 0 a 73 73 0 1 0 -146 0";--spectrum-colorwheel-path-borders:"M 96 96 m -96 0 a 96 96 0 1 0 192 0 a 96 96 0 1 0 -192 0.2 M 96 96 m -72 0 a 72 72 0 1 0 144 0 a 72 72 0 1 0 -144 0";--spectrum-colorwheel-colorarea-container-size:144px;--spectrum-menu-item-selectable-edge-to-text-not-selected-small:28px;--spectrum-menu-item-selectable-edge-to-text-not-selected-medium:32px;--spectrum-menu-item-selectable-edge-to-text-not-selected-large:38px;--spectrum-menu-item-selectable-edge-to-text-not-selected-extra-large:45px;--spectrum-menu-item-checkmark-height-small:10px;--spectrum-menu-item-checkmark-height-medium:10px;--spectrum-menu-item-checkmark-height-large:12px;--spectrum-menu-item-checkmark-height-extra-large:14px;--spectrum-menu-item-checkmark-width-small:10px;--spectrum-menu-item-checkmark-width-medium:10px;--spectrum-menu-item-checkmark-width-large:12px;--spectrum-menu-item-checkmark-width-extra-large:14px;--spectrum-rating-icon-spacing:var(--spectrum-spacing-75)}:host,:root{--spectrum-checkbox-control-size-small:12px;--spectrum-checkbox-control-size-medium:14px;--spectrum-checkbox-control-size-large:16px;--spectrum-checkbox-control-size-extra-large:18px;--spectrum-checkbox-top-to-control-small:6px;--spectrum-checkbox-top-to-control-medium:9px;--spectrum-checkbox-top-to-control-large:12px;--spectrum-checkbox-top-to-control-extra-large:15px;--spectrum-switch-control-width-small:23px;--spectrum-switch-control-width-medium:26px;--spectrum-switch-control-width-large:29px;--spectrum-switch-control-width-extra-large:33px;--spectrum-switch-control-height-small:12px;--spectrum-switch-control-height-medium:14px;--spectrum-switch-control-height-large:16px;--spectrum-switch-control-height-extra-large:18px;--spectrum-switch-top-to-control-small:6px;--spectrum-switch-top-to-control-medium:9px;--spectrum-switch-top-to-control-large:12px;--spectrum-switch-top-to-control-extra-large:15px;--spectrum-radio-button-control-size-small:12px;--spectrum-radio-button-control-size-medium:14px;--spectrum-radio-button-control-size-large:16px;--spectrum-radio-button-control-size-extra-large:18px;--spectrum-radio-button-top-to-control-small:6px;--spectrum-radio-button-top-to-control-medium:9px;--spectrum-radio-button-top-to-control-large:12px;--spectrum-radio-button-top-to-control-extra-large:15px;--spectrum-slider-control-height-small:14px;--spectrum-slider-control-height-medium:16px;--spectrum-slider-control-height-large:18px;--spectrum-slider-control-height-extra-large:20px;--spectrum-slider-handle-size-small:14px;--spectrum-slider-handle-size-medium:16px;--spectrum-slider-handle-size-large:18px;--spectrum-slider-handle-size-extra-large:20px;--spectrum-slider-handle-border-width-down-small:5px;--spectrum-slider-handle-border-width-down-medium:6px;--spectrum-slider-handle-border-width-down-large:7px;--spectrum-slider-handle-border-width-down-extra-large:8px;--spectrum-slider-bottom-to-handle-small:5px;--spectrum-slider-bottom-to-handle-medium:8px;--spectrum-slider-bottom-to-handle-large:11px;--spectrum-slider-bottom-to-handle-extra-large:14px;--spectrum-color-handle-size:16px;--spectrum-color-handle-size-key-focus:32px;--spectrum-corner-radius-75:2px;--spectrum-corner-radius-100:4px;--spectrum-corner-radius-200:8px;--spectrum-drop-shadow-x:0px;--spectrum-drop-shadow-y:1px;--spectrum-drop-shadow-blur:4px}
`;
var $5184aaf250a298a2$export$2e2bcd8739ae039 = $5184aaf250a298a2$var$t;


parcelRequire("ivbvd");
var $5H6ys = parcelRequire("5H6ys");
"use strict";
const $e89f5cc053bf9b21$var$d = [
    "spectrum",
    "express"
], $e89f5cc053bf9b21$var$m = [
    "medium",
    "large",
    "medium-express",
    "large-express"
], $e89f5cc053bf9b21$var$c = [
    "light",
    "lightest",
    "dark",
    "darkest",
    "light-express",
    "lightest-express",
    "dark-express",
    "darkest-express"
], $e89f5cc053bf9b21$var$r = class extends HTMLElement {
    static get observedAttributes() {
        return [
            "color",
            "scale",
            "theme",
            "lang",
            "dir"
        ];
    }
    set dir(e) {
        if (e === this.dir) return;
        this.setAttribute("dir", e), this._dir = e;
        const t = e === "rtl" ? e : "ltr";
        this.trackedChildren.forEach((s)=>{
            s.setAttribute("dir", t);
        });
    }
    get dir() {
        return this._dir;
    }
    attributeChangedCallback(e, t, s) {
        t !== s && (e === "color" ? this.color = s : e === "scale" ? this.scale = s : e === "lang" && s ? (this.lang = s, this._provideContext()) : e === "theme" ? this.theme = s : e === "dir" && (this.dir = s));
    }
    requestUpdate() {
        window.ShadyCSS !== void 0 && !window.ShadyCSS.nativeShadow ? window.ShadyCSS.styleElement(this) : this.shouldAdoptStyles();
    }
    get theme() {
        const e = $e89f5cc053bf9b21$var$r.themeFragmentsByKind.get("theme"), { name: t } = e && e.get("default") || {};
        return this._theme || t || "";
    }
    set theme(e) {
        if (e === this._theme) return;
        const t = e && $e89f5cc053bf9b21$var$d.includes(e) ? e : this.theme;
        t !== this._theme && (this._theme = t, this.requestUpdate()), t ? this.setAttribute("theme", t) : this.removeAttribute("theme");
    }
    get color() {
        const e = $e89f5cc053bf9b21$var$r.themeFragmentsByKind.get("color"), { name: t } = e && e.get("default") || {};
        return this._color || t || "";
    }
    set color(e) {
        if (e === this._color) return;
        const t = e && $e89f5cc053bf9b21$var$c.includes(e) ? e : this.color;
        t !== this._color && (this._color = t, this.requestUpdate()), t ? this.setAttribute("color", t) : this.removeAttribute("color");
    }
    get scale() {
        const e = $e89f5cc053bf9b21$var$r.themeFragmentsByKind.get("scale"), { name: t } = e && e.get("default") || {};
        return this._scale || t || "";
    }
    set scale(e) {
        if (e === this._scale) return;
        const t = e && $e89f5cc053bf9b21$var$m.includes(e) ? e : this.scale;
        t !== this._scale && (this._scale = t, this.requestUpdate()), t ? this.setAttribute("scale", t) : this.removeAttribute("scale");
    }
    get styles() {
        const e = [
            ...$e89f5cc053bf9b21$var$r.themeFragmentsByKind.keys()
        ], t = (a, i, n)=>{
            const o = n && n !== "theme" && this.theme === "express" ? a.get(`${i}-express`) : a.get(i), l = i === "spectrum" || !n || this.hasAttribute(n);
            if (o && l) return o.styles;
        };
        return [
            ...e.reduce((a, i)=>{
                const n = $e89f5cc053bf9b21$var$r.themeFragmentsByKind.get(i);
                let o;
                if (i === "app" || i === "core") o = t(n, i);
                else {
                    const { [i]: l } = this;
                    o = t(n, l, i);
                }
                return o && a.push(o), a;
            }, [])
        ];
    }
    static get template() {
        return this.templateElement || (this.templateElement = document.createElement("template"), this.templateElement.innerHTML = "<slot></slot>"), this.templateElement;
    }
    __createDeferredPromise() {
        return new Promise((e)=>{
            this.__resolve = e;
        });
    }
    onQueryTheme(e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        const { detail: t } = e;
        t.color = this.color || void 0, t.scale = this.scale || void 0, t.lang = this.lang || document.documentElement.lang || navigator.language, t.theme = this.theme || void 0;
    }
    connectedCallback() {
        if (this.shouldAdoptStyles(), window.ShadyCSS !== void 0 && window.ShadyCSS.styleElement(this), $e89f5cc053bf9b21$var$r.instances.add(this), !this.hasAttribute("dir")) {
            let e = this.assignedSlot || this.parentNode;
            for(; e !== document.documentElement && !(e instanceof $e89f5cc053bf9b21$var$r);)e = e.assignedSlot || e.parentNode || e.host;
            this.dir = e.dir === "rtl" ? e.dir : "ltr";
        }
    }
    disconnectedCallback() {
        $e89f5cc053bf9b21$var$r.instances.delete(this);
    }
    startManagingContentDirection(e) {
        this.trackedChildren.add(e);
    }
    stopManagingContentDirection(e) {
        this.trackedChildren.delete(e);
    }
    async shouldAdoptStyles() {
        this._updateRequested || (this.updateComplete = this.__createDeferredPromise(), this._updateRequested = !0, this._updateRequested = await !1, this.adoptStyles(), this.__resolve(!0));
    }
    adoptStyles() {
        const e = this.styles;
        if (window.ShadyCSS !== void 0 && !window.ShadyCSS.nativeShadow && window.ShadyCSS.ScopingShim) {
            const t = [];
            for (const [s, a] of $e89f5cc053bf9b21$var$r.themeFragmentsByKind)for (const [i, { styles: n }] of a){
                if (i === "default") continue;
                let o = n.cssText;
                $e89f5cc053bf9b21$var$r.defaultFragments.has(i) || (o = o.replace(":host", `:host([${s}='${i}'])`)), t.push(o);
            }
            window.ShadyCSS.ScopingShim.prepareAdoptedCssText(t, this.localName), window.ShadyCSS.prepareTemplate($e89f5cc053bf9b21$var$r.template, this.localName);
        } else if (0, $5H6ys.supportsAdoptingStyleSheets) {
            const t = [];
            for (const s of e)t.push(s.styleSheet);
            this.shadowRoot.adoptedStyleSheets = t;
        } else this.shadowRoot.querySelectorAll("style").forEach((s)=>s.remove()), e.forEach((s)=>{
            const a = document.createElement("style");
            a.textContent = s.cssText, this.shadowRoot.appendChild(a);
        });
    }
    static registerThemeFragment(e, t, s) {
        const a = $e89f5cc053bf9b21$var$r.themeFragmentsByKind.get(t) || new Map;
        a.size === 0 && ($e89f5cc053bf9b21$var$r.themeFragmentsByKind.set(t, a), a.set("default", {
            name: e,
            styles: s
        }), $e89f5cc053bf9b21$var$r.defaultFragments.add(e)), a.set(e, {
            name: e,
            styles: s
        }), $e89f5cc053bf9b21$var$r.instances.forEach((i)=>i.shouldAdoptStyles());
    }
    _provideContext() {
        this._contextConsumers.forEach(([e, t])=>e(this.lang, t));
    }
    _handleContextPresence(e) {
        e.stopPropagation();
        const t = e.composedPath()[0];
        if (this._contextConsumers.has(t)) return;
        this._contextConsumers.set(t, [
            e.detail.callback,
            ()=>this._contextConsumers.delete(t)
        ]);
        const [s, a] = this._contextConsumers.get(t) || [];
        s && a && s(this.lang || document.documentElement.lang || navigator.language, a);
    }
    constructor(){
        super();
        this._dir = "";
        this._theme = "spectrum";
        this._color = "";
        this._scale = "";
        this.trackedChildren = new Set;
        this._updateRequested = !1;
        this._contextConsumers = new Map;
        this.attachShadow({
            mode: "open"
        });
        const e = document.importNode($e89f5cc053bf9b21$var$r.template.content, !0);
        this.shadowRoot.appendChild(e), this.shouldAdoptStyles(), this.addEventListener("sp-query-theme", this.onQueryTheme), this.addEventListener("sp-language-context", this._handleContextPresence), this.updateComplete = this.__createDeferredPromise();
    }
};
let $e89f5cc053bf9b21$export$14faa19a0f3bbeb2 = $e89f5cc053bf9b21$var$r;
$e89f5cc053bf9b21$export$14faa19a0f3bbeb2.themeFragmentsByKind = new Map, $e89f5cc053bf9b21$export$14faa19a0f3bbeb2.defaultFragments = new Set([
    "spectrum"
]), $e89f5cc053bf9b21$export$14faa19a0f3bbeb2.instances = new Set;



parcelRequire("ivbvd");
var $5H6ys = parcelRequire("5H6ys");
"use strict";
const $0c01a02246f1e6ee$var$e = (0, $5H6ys.css)`
:host,:root{--spectrum-global-animation-linear:cubic-bezier(0,0,1,1);--spectrum-global-animation-duration-0:0ms;--spectrum-global-animation-duration-100:130ms;--spectrum-global-animation-duration-200:160ms;--spectrum-global-animation-duration-300:190ms;--spectrum-global-animation-duration-400:220ms;--spectrum-global-animation-duration-500:250ms;--spectrum-global-animation-duration-600:300ms;--spectrum-global-animation-duration-700:350ms;--spectrum-global-animation-duration-800:400ms;--spectrum-global-animation-duration-900:450ms;--spectrum-global-animation-duration-1000:500ms;--spectrum-global-animation-duration-2000:1000ms;--spectrum-global-animation-duration-4000:2000ms;--spectrum-global-animation-ease-in-out:cubic-bezier(0.45,0,0.4,1);--spectrum-global-animation-ease-in:cubic-bezier(0.5,0,1,1);--spectrum-global-animation-ease-out:cubic-bezier(0,0,0.4,1);--spectrum-global-animation-ease-linear:cubic-bezier(0,0,1,1);--spectrum-global-color-status:Verified;--spectrum-global-color-version:5.1.0;--spectrum-global-color-static-black-rgb:0,0,0;--spectrum-global-color-static-black:rgb(var(--spectrum-global-color-static-black-rgb));--spectrum-global-color-static-white-rgb:255,255,255;--spectrum-global-color-static-white:rgb(var(--spectrum-global-color-static-white-rgb));--spectrum-global-color-static-blue-rgb:0,87,191;--spectrum-global-color-static-blue:rgb(var(--spectrum-global-color-static-blue-rgb));--spectrum-global-color-static-gray-50-rgb:255,255,255;--spectrum-global-color-static-gray-50:rgb(var(--spectrum-global-color-static-gray-50-rgb));--spectrum-global-color-static-gray-75-rgb:255,255,255;--spectrum-global-color-static-gray-75:rgb(var(--spectrum-global-color-static-gray-75-rgb));--spectrum-global-color-static-gray-100-rgb:255,255,255;--spectrum-global-color-static-gray-100:rgb(var(--spectrum-global-color-static-gray-100-rgb));--spectrum-global-color-static-gray-200-rgb:235,235,235;--spectrum-global-color-static-gray-200:rgb(var(--spectrum-global-color-static-gray-200-rgb));--spectrum-global-color-static-gray-300-rgb:217,217,217;--spectrum-global-color-static-gray-300:rgb(var(--spectrum-global-color-static-gray-300-rgb));--spectrum-global-color-static-gray-400-rgb:179,179,179;--spectrum-global-color-static-gray-400:rgb(var(--spectrum-global-color-static-gray-400-rgb));--spectrum-global-color-static-gray-500-rgb:146,146,146;--spectrum-global-color-static-gray-500:rgb(var(--spectrum-global-color-static-gray-500-rgb));--spectrum-global-color-static-gray-600-rgb:110,110,110;--spectrum-global-color-static-gray-600:rgb(var(--spectrum-global-color-static-gray-600-rgb));--spectrum-global-color-static-gray-700-rgb:71,71,71;--spectrum-global-color-static-gray-700:rgb(var(--spectrum-global-color-static-gray-700-rgb));--spectrum-global-color-static-gray-800-rgb:34,34,34;--spectrum-global-color-static-gray-800:rgb(var(--spectrum-global-color-static-gray-800-rgb));--spectrum-global-color-static-gray-900-rgb:0,0,0;--spectrum-global-color-static-gray-900:rgb(var(--spectrum-global-color-static-gray-900-rgb));--spectrum-global-color-static-red-400-rgb:237,64,48;--spectrum-global-color-static-red-400:rgb(var(--spectrum-global-color-static-red-400-rgb));--spectrum-global-color-static-red-500-rgb:217,28,21;--spectrum-global-color-static-red-500:rgb(var(--spectrum-global-color-static-red-500-rgb));--spectrum-global-color-static-red-600-rgb:187,2,2;--spectrum-global-color-static-red-600:rgb(var(--spectrum-global-color-static-red-600-rgb));--spectrum-global-color-static-red-700-rgb:154,0,0;--spectrum-global-color-static-red-700:rgb(var(--spectrum-global-color-static-red-700-rgb));--spectrum-global-color-static-red-800-rgb:124,0,0;--spectrum-global-color-static-red-800:rgb(var(--spectrum-global-color-static-red-800-rgb));--spectrum-global-color-static-orange-400-rgb:250,139,26;--spectrum-global-color-static-orange-400:rgb(var(--spectrum-global-color-static-orange-400-rgb));--spectrum-global-color-static-orange-500-rgb:233,117,0;--spectrum-global-color-static-orange-500:rgb(var(--spectrum-global-color-static-orange-500-rgb));--spectrum-global-color-static-orange-600-rgb:209,97,0;--spectrum-global-color-static-orange-600:rgb(var(--spectrum-global-color-static-orange-600-rgb));--spectrum-global-color-static-orange-700-rgb:182,80,0;--spectrum-global-color-static-orange-700:rgb(var(--spectrum-global-color-static-orange-700-rgb));--spectrum-global-color-static-orange-800-rgb:155,64,0;--spectrum-global-color-static-orange-800:rgb(var(--spectrum-global-color-static-orange-800-rgb));--spectrum-global-color-static-yellow-200-rgb:250,237,123;--spectrum-global-color-static-yellow-200:rgb(var(--spectrum-global-color-static-yellow-200-rgb));--spectrum-global-color-static-yellow-300-rgb:250,224,23;--spectrum-global-color-static-yellow-300:rgb(var(--spectrum-global-color-static-yellow-300-rgb));--spectrum-global-color-static-yellow-400-rgb:238,205,0;--spectrum-global-color-static-yellow-400:rgb(var(--spectrum-global-color-static-yellow-400-rgb));--spectrum-global-color-static-yellow-500-rgb:221,185,0;--spectrum-global-color-static-yellow-500:rgb(var(--spectrum-global-color-static-yellow-500-rgb));--spectrum-global-color-static-yellow-600-rgb:201,164,0;--spectrum-global-color-static-yellow-600:rgb(var(--spectrum-global-color-static-yellow-600-rgb));--spectrum-global-color-static-yellow-700-rgb:181,144,0;--spectrum-global-color-static-yellow-700:rgb(var(--spectrum-global-color-static-yellow-700-rgb));--spectrum-global-color-static-yellow-800-rgb:160,125,0;--spectrum-global-color-static-yellow-800:rgb(var(--spectrum-global-color-static-yellow-800-rgb));--spectrum-global-color-static-chartreuse-300-rgb:176,222,27;--spectrum-global-color-static-chartreuse-300:rgb(var(--spectrum-global-color-static-chartreuse-300-rgb));--spectrum-global-color-static-chartreuse-400-rgb:157,203,13;--spectrum-global-color-static-chartreuse-400:rgb(var(--spectrum-global-color-static-chartreuse-400-rgb));--spectrum-global-color-static-chartreuse-500-rgb:139,182,4;--spectrum-global-color-static-chartreuse-500:rgb(var(--spectrum-global-color-static-chartreuse-500-rgb));--spectrum-global-color-static-chartreuse-600-rgb:122,162,0;--spectrum-global-color-static-chartreuse-600:rgb(var(--spectrum-global-color-static-chartreuse-600-rgb));--spectrum-global-color-static-chartreuse-700-rgb:106,141,0;--spectrum-global-color-static-chartreuse-700:rgb(var(--spectrum-global-color-static-chartreuse-700-rgb));--spectrum-global-color-static-chartreuse-800-rgb:90,120,0;--spectrum-global-color-static-chartreuse-800:rgb(var(--spectrum-global-color-static-chartreuse-800-rgb));--spectrum-global-color-static-celery-200-rgb:126,229,114;--spectrum-global-color-static-celery-200:rgb(var(--spectrum-global-color-static-celery-200-rgb));--spectrum-global-color-static-celery-300-rgb:87,212,86;--spectrum-global-color-static-celery-300:rgb(var(--spectrum-global-color-static-celery-300-rgb));--spectrum-global-color-static-celery-400-rgb:48,193,61;--spectrum-global-color-static-celery-400:rgb(var(--spectrum-global-color-static-celery-400-rgb));--spectrum-global-color-static-celery-500-rgb:15,172,38;--spectrum-global-color-static-celery-500:rgb(var(--spectrum-global-color-static-celery-500-rgb));--spectrum-global-color-static-celery-600-rgb:0,150,20;--spectrum-global-color-static-celery-600:rgb(var(--spectrum-global-color-static-celery-600-rgb));--spectrum-global-color-static-celery-700-rgb:0,128,15;--spectrum-global-color-static-celery-700:rgb(var(--spectrum-global-color-static-celery-700-rgb));--spectrum-global-color-static-celery-800-rgb:0,107,15;--spectrum-global-color-static-celery-800:rgb(var(--spectrum-global-color-static-celery-800-rgb));--spectrum-global-color-static-green-400-rgb:29,169,115;--spectrum-global-color-static-green-400:rgb(var(--spectrum-global-color-static-green-400-rgb));--spectrum-global-color-static-green-500-rgb:0,148,97;--spectrum-global-color-static-green-500:rgb(var(--spectrum-global-color-static-green-500-rgb));--spectrum-global-color-static-green-600-rgb:0,126,80;--spectrum-global-color-static-green-600:rgb(var(--spectrum-global-color-static-green-600-rgb));--spectrum-global-color-static-green-700-rgb:0,105,65;--spectrum-global-color-static-green-700:rgb(var(--spectrum-global-color-static-green-700-rgb));--spectrum-global-color-static-green-800-rgb:0,86,53;--spectrum-global-color-static-green-800:rgb(var(--spectrum-global-color-static-green-800-rgb));--spectrum-global-color-static-seafoam-200-rgb:75,206,199;--spectrum-global-color-static-seafoam-200:rgb(var(--spectrum-global-color-static-seafoam-200-rgb));--spectrum-global-color-static-seafoam-300-rgb:32,187,180;--spectrum-global-color-static-seafoam-300:rgb(var(--spectrum-global-color-static-seafoam-300-rgb));--spectrum-global-color-static-seafoam-400-rgb:0,166,160;--spectrum-global-color-static-seafoam-400:rgb(var(--spectrum-global-color-static-seafoam-400-rgb));--spectrum-global-color-static-seafoam-500-rgb:0,145,139;--spectrum-global-color-static-seafoam-500:rgb(var(--spectrum-global-color-static-seafoam-500-rgb));--spectrum-global-color-static-seafoam-600-rgb:0,124,118;--spectrum-global-color-static-seafoam-600:rgb(var(--spectrum-global-color-static-seafoam-600-rgb));--spectrum-global-color-static-seafoam-700-rgb:0,103,99;--spectrum-global-color-static-seafoam-700:rgb(var(--spectrum-global-color-static-seafoam-700-rgb));--spectrum-global-color-static-seafoam-800-rgb:10,83,80;--spectrum-global-color-static-seafoam-800:rgb(var(--spectrum-global-color-static-seafoam-800-rgb));--spectrum-global-color-static-blue-200-rgb:130,193,251;--spectrum-global-color-static-blue-200:rgb(var(--spectrum-global-color-static-blue-200-rgb));--spectrum-global-color-static-blue-300-rgb:98,173,247;--spectrum-global-color-static-blue-300:rgb(var(--spectrum-global-color-static-blue-300-rgb));--spectrum-global-color-static-blue-400-rgb:66,151,244;--spectrum-global-color-static-blue-400:rgb(var(--spectrum-global-color-static-blue-400-rgb));--spectrum-global-color-static-blue-500-rgb:27,127,245;--spectrum-global-color-static-blue-500:rgb(var(--spectrum-global-color-static-blue-500-rgb));--spectrum-global-color-static-blue-600-rgb:4,105,227;--spectrum-global-color-static-blue-600:rgb(var(--spectrum-global-color-static-blue-600-rgb));--spectrum-global-color-static-blue-700-rgb:0,87,190;--spectrum-global-color-static-blue-700:rgb(var(--spectrum-global-color-static-blue-700-rgb));--spectrum-global-color-static-blue-800-rgb:0,72,153;--spectrum-global-color-static-blue-800:rgb(var(--spectrum-global-color-static-blue-800-rgb));--spectrum-global-color-static-indigo-200-rgb:178,181,255;--spectrum-global-color-static-indigo-200:rgb(var(--spectrum-global-color-static-indigo-200-rgb));--spectrum-global-color-static-indigo-300-rgb:155,159,255;--spectrum-global-color-static-indigo-300:rgb(var(--spectrum-global-color-static-indigo-300-rgb));--spectrum-global-color-static-indigo-400-rgb:132,137,253;--spectrum-global-color-static-indigo-400:rgb(var(--spectrum-global-color-static-indigo-400-rgb));--spectrum-global-color-static-indigo-500-rgb:109,115,246;--spectrum-global-color-static-indigo-500:rgb(var(--spectrum-global-color-static-indigo-500-rgb));--spectrum-global-color-static-indigo-600-rgb:87,93,232;--spectrum-global-color-static-indigo-600:rgb(var(--spectrum-global-color-static-indigo-600-rgb));--spectrum-global-color-static-indigo-700-rgb:68,74,208;--spectrum-global-color-static-indigo-700:rgb(var(--spectrum-global-color-static-indigo-700-rgb));--spectrum-global-color-static-indigo-800-rgb:68,74,208;--spectrum-global-color-static-indigo-800:rgb(var(--spectrum-global-color-static-indigo-800-rgb));--spectrum-global-color-static-purple-400-rgb:178,121,250;--spectrum-global-color-static-purple-400:rgb(var(--spectrum-global-color-static-purple-400-rgb));--spectrum-global-color-static-purple-500-rgb:161,93,246;--spectrum-global-color-static-purple-500:rgb(var(--spectrum-global-color-static-purple-500-rgb));--spectrum-global-color-static-purple-600-rgb:142,67,234;--spectrum-global-color-static-purple-600:rgb(var(--spectrum-global-color-static-purple-600-rgb));--spectrum-global-color-static-purple-700-rgb:120,43,216;--spectrum-global-color-static-purple-700:rgb(var(--spectrum-global-color-static-purple-700-rgb));--spectrum-global-color-static-purple-800-rgb:98,23,190;--spectrum-global-color-static-purple-800:rgb(var(--spectrum-global-color-static-purple-800-rgb));--spectrum-global-color-static-fuchsia-400-rgb:228,93,230;--spectrum-global-color-static-fuchsia-400:rgb(var(--spectrum-global-color-static-fuchsia-400-rgb));--spectrum-global-color-static-fuchsia-500-rgb:211,63,212;--spectrum-global-color-static-fuchsia-500:rgb(var(--spectrum-global-color-static-fuchsia-500-rgb));--spectrum-global-color-static-fuchsia-600-rgb:188,39,187;--spectrum-global-color-static-fuchsia-600:rgb(var(--spectrum-global-color-static-fuchsia-600-rgb));--spectrum-global-color-static-fuchsia-700-rgb:163,10,163;--spectrum-global-color-static-fuchsia-700:rgb(var(--spectrum-global-color-static-fuchsia-700-rgb));--spectrum-global-color-static-fuchsia-800-rgb:135,0,136;--spectrum-global-color-static-fuchsia-800:rgb(var(--spectrum-global-color-static-fuchsia-800-rgb));--spectrum-global-color-static-magenta-200-rgb:253,127,175;--spectrum-global-color-static-magenta-200:rgb(var(--spectrum-global-color-static-magenta-200-rgb));--spectrum-global-color-static-magenta-300-rgb:242,98,157;--spectrum-global-color-static-magenta-300:rgb(var(--spectrum-global-color-static-magenta-300-rgb));--spectrum-global-color-static-magenta-400-rgb:226,68,135;--spectrum-global-color-static-magenta-400:rgb(var(--spectrum-global-color-static-magenta-400-rgb));--spectrum-global-color-static-magenta-500-rgb:205,40,111;--spectrum-global-color-static-magenta-500:rgb(var(--spectrum-global-color-static-magenta-500-rgb));--spectrum-global-color-static-magenta-600-rgb:179,15,89;--spectrum-global-color-static-magenta-600:rgb(var(--spectrum-global-color-static-magenta-600-rgb));--spectrum-global-color-static-magenta-700-rgb:149,0,72;--spectrum-global-color-static-magenta-700:rgb(var(--spectrum-global-color-static-magenta-700-rgb));--spectrum-global-color-static-magenta-800-rgb:119,0,58;--spectrum-global-color-static-magenta-800:rgb(var(--spectrum-global-color-static-magenta-800-rgb));--spectrum-global-color-static-transparent-white-200:hsla(0,0%,100%,.1);--spectrum-global-color-static-transparent-white-300:hsla(0,0%,100%,.25);--spectrum-global-color-static-transparent-white-400:hsla(0,0%,100%,.4);--spectrum-global-color-static-transparent-white-500:hsla(0,0%,100%,.55);--spectrum-global-color-static-transparent-white-600:hsla(0,0%,100%,.7);--spectrum-global-color-static-transparent-white-700:hsla(0,0%,100%,.8);--spectrum-global-color-static-transparent-white-800:hsla(0,0%,100%,.9);--spectrum-global-color-static-transparent-white-900-rgb:255,255,255;--spectrum-global-color-static-transparent-white-900:rgb(var(--spectrum-global-color-static-transparent-white-900-rgb));--spectrum-global-color-static-transparent-black-200:rgba(0,0,0,.1);--spectrum-global-color-static-transparent-black-300:rgba(0,0,0,.25);--spectrum-global-color-static-transparent-black-400:rgba(0,0,0,.4);--spectrum-global-color-static-transparent-black-500:rgba(0,0,0,.55);--spectrum-global-color-static-transparent-black-600:rgba(0,0,0,.7);--spectrum-global-color-static-transparent-black-700:rgba(0,0,0,.8);--spectrum-global-color-static-transparent-black-800:rgba(0,0,0,.9);--spectrum-global-color-static-transparent-black-900-rgb:0,0,0;--spectrum-global-color-static-transparent-black-900:rgb(var(--spectrum-global-color-static-transparent-black-900-rgb));--spectrum-global-color-sequential-cerulean:#e9fff1,#c8f1e4,#a5e3d7,#82d5ca,#68c5c1,#54b4ba,#3fa2b2,#2991ac,#2280a2,#1f6d98,#1d5c8d,#1a4b83,#1a3979,#1a266f,#191264,#180057;--spectrum-global-color-sequential-forest:#ffffdf,#e2f6ba,#c4eb95,#a4e16d,#8dd366,#77c460,#5fb65a,#48a754,#36984f,#2c894d,#237a4a,#196b47,#105c45,#094d41,#033f3e,#00313a;--spectrum-global-color-sequential-rose:#fff4dd,#ffddd7,#ffc5d2,#feaecb,#fa96c4,#f57ebd,#ef64b5,#e846ad,#d238a1,#bb2e96,#a3248c,#8a1b83,#71167c,#560f74,#370b6e,#000968;--spectrum-global-color-diverging-orange-yellow-seafoam:#580000,#79260b,#9c4511,#bd651a,#dd8629,#f5ad52,#fed693,#ffffe0,#bbe4d1,#76c7be,#3ea8a6,#208288,#076769,#00494b,#002c2d;--spectrum-global-color-diverging-red-yellow-blue:#4a001e,#751232,#a52747,#c65154,#e47961,#f0a882,#fad4ac,#ffffe0,#bce2cf,#89c0c4,#579eb9,#397aa8,#1c5796,#163771,#10194d;--spectrum-global-color-diverging-red-blue:#4a001e,#731331,#9f2945,#cc415a,#e06e85,#ed9ab0,#f8c3d9,#faf0ff,#c6d0f2,#92b2de,#5d94cb,#2f74b3,#265191,#163670,#0b194c;--spectrum-semantic-negative-background-color:var(
--spectrum-global-color-static-red-600
);--spectrum-semantic-negative-color-default:var(
--spectrum-global-color-red-500
);--spectrum-semantic-negative-color-hover:var(
--spectrum-global-color-red-600
);--spectrum-semantic-negative-color-dark:var(
--spectrum-global-color-red-600
);--spectrum-semantic-negative-border-color:var(
--spectrum-global-color-red-400
);--spectrum-semantic-negative-icon-color:var(
--spectrum-global-color-red-600
);--spectrum-semantic-negative-status-color:var(
--spectrum-global-color-red-400
);--spectrum-semantic-negative-text-color-large:var(
--spectrum-global-color-red-500
);--spectrum-semantic-negative-text-color-small:var(
--spectrum-global-color-red-600
);--spectrum-semantic-negative-text-color-small-hover:var(
--spectrum-global-color-red-700
);--spectrum-semantic-negative-text-color-small-down:var(
--spectrum-global-color-red-700
);--spectrum-semantic-negative-text-color-small-key-focus:var(
--spectrum-global-color-red-600
);--spectrum-semantic-negative-color-down:var(
--spectrum-global-color-red-700
);--spectrum-semantic-negative-color-key-focus:var(
--spectrum-global-color-red-400
);--spectrum-semantic-negative-background-color-default:var(
--spectrum-global-color-static-red-600
);--spectrum-semantic-negative-background-color-hover:var(
--spectrum-global-color-static-red-700
);--spectrum-semantic-negative-background-color-down:var(
--spectrum-global-color-static-red-800
);--spectrum-semantic-negative-background-color-key-focus:var(
--spectrum-global-color-static-red-700
);--spectrum-semantic-notice-background-color:var(
--spectrum-global-color-static-orange-600
);--spectrum-semantic-notice-color-default:var(
--spectrum-global-color-orange-500
);--spectrum-semantic-notice-color-dark:var(
--spectrum-global-color-orange-600
);--spectrum-semantic-notice-border-color:var(
--spectrum-global-color-orange-400
);--spectrum-semantic-notice-icon-color:var(
--spectrum-global-color-orange-600
);--spectrum-semantic-notice-status-color:var(
--spectrum-global-color-orange-400
);--spectrum-semantic-notice-text-color-large:var(
--spectrum-global-color-orange-500
);--spectrum-semantic-notice-text-color-small:var(
--spectrum-global-color-orange-600
);--spectrum-semantic-notice-color-down:var(
--spectrum-global-color-orange-700
);--spectrum-semantic-notice-color-key-focus:var(
--spectrum-global-color-orange-400
);--spectrum-semantic-notice-background-color-default:var(
--spectrum-global-color-static-orange-600
);--spectrum-semantic-notice-background-color-hover:var(
--spectrum-global-color-static-orange-700
);--spectrum-semantic-notice-background-color-down:var(
--spectrum-global-color-static-orange-800
);--spectrum-semantic-notice-background-color-key-focus:var(
--spectrum-global-color-static-orange-700
);--spectrum-semantic-positive-background-color:var(
--spectrum-global-color-static-green-600
);--spectrum-semantic-positive-color-default:var(
--spectrum-global-color-green-500
);--spectrum-semantic-positive-color-dark:var(
--spectrum-global-color-green-600
);--spectrum-semantic-positive-border-color:var(
--spectrum-global-color-green-400
);--spectrum-semantic-positive-icon-color:var(
--spectrum-global-color-green-600
);--spectrum-semantic-positive-status-color:var(
--spectrum-global-color-green-400
);--spectrum-semantic-positive-text-color-large:var(
--spectrum-global-color-green-500
);--spectrum-semantic-positive-text-color-small:var(
--spectrum-global-color-green-600
);--spectrum-semantic-positive-color-down:var(
--spectrum-global-color-green-700
);--spectrum-semantic-positive-color-key-focus:var(
--spectrum-global-color-green-400
);--spectrum-semantic-positive-background-color-default:var(
--spectrum-global-color-static-green-600
);--spectrum-semantic-positive-background-color-hover:var(
--spectrum-global-color-static-green-700
);--spectrum-semantic-positive-background-color-down:var(
--spectrum-global-color-static-green-800
);--spectrum-semantic-positive-background-color-key-focus:var(
--spectrum-global-color-static-green-700
);--spectrum-semantic-informative-background-color:var(
--spectrum-global-color-static-blue-600
);--spectrum-semantic-informative-color-default:var(
--spectrum-global-color-blue-500
);--spectrum-semantic-informative-color-dark:var(
--spectrum-global-color-blue-600
);--spectrum-semantic-informative-border-color:var(
--spectrum-global-color-blue-400
);--spectrum-semantic-informative-icon-color:var(
--spectrum-global-color-blue-600
);--spectrum-semantic-informative-status-color:var(
--spectrum-global-color-blue-400
);--spectrum-semantic-informative-text-color-large:var(
--spectrum-global-color-blue-500
);--spectrum-semantic-informative-text-color-small:var(
--spectrum-global-color-blue-600
);--spectrum-semantic-informative-color-down:var(
--spectrum-global-color-blue-700
);--spectrum-semantic-informative-color-key-focus:var(
--spectrum-global-color-blue-400
);--spectrum-semantic-informative-background-color-default:var(
--spectrum-global-color-static-blue-600
);--spectrum-semantic-informative-background-color-hover:var(
--spectrum-global-color-static-blue-700
);--spectrum-semantic-informative-background-color-down:var(
--spectrum-global-color-static-blue-800
);--spectrum-semantic-informative-background-color-key-focus:var(
--spectrum-global-color-static-blue-700
);--spectrum-semantic-cta-background-color-default:var(
--spectrum-global-color-static-blue-600
);--spectrum-semantic-cta-background-color-hover:var(
--spectrum-global-color-static-blue-700
);--spectrum-semantic-cta-background-color-down:var(
--spectrum-global-color-static-blue-800
);--spectrum-semantic-cta-background-color-key-focus:var(
--spectrum-global-color-static-blue-700
);--spectrum-semantic-emphasized-border-color-default:var(
--spectrum-global-color-blue-500
);--spectrum-semantic-emphasized-border-color-hover:var(
--spectrum-global-color-blue-600
);--spectrum-semantic-emphasized-border-color-down:var(
--spectrum-global-color-blue-700
);--spectrum-semantic-emphasized-border-color-key-focus:var(
--spectrum-global-color-blue-600
);--spectrum-semantic-neutral-background-color-default:var(
--spectrum-global-color-static-gray-700
);--spectrum-semantic-neutral-background-color-hover:var(
--spectrum-global-color-static-gray-800
);--spectrum-semantic-neutral-background-color-down:var(
--spectrum-global-color-static-gray-900
);--spectrum-semantic-neutral-background-color-key-focus:var(
--spectrum-global-color-static-gray-800
);--spectrum-semantic-presence-color-1:var(
--spectrum-global-color-static-red-500
);--spectrum-semantic-presence-color-2:var(
--spectrum-global-color-static-orange-400
);--spectrum-semantic-presence-color-3:var(
--spectrum-global-color-static-yellow-400
);--spectrum-semantic-presence-color-4-rgb:75,204,162;--spectrum-semantic-presence-color-4:rgb(var(--spectrum-semantic-presence-color-4-rgb));--spectrum-semantic-presence-color-5-rgb:0,199,255;--spectrum-semantic-presence-color-5:rgb(var(--spectrum-semantic-presence-color-5-rgb));--spectrum-semantic-presence-color-6-rgb:0,140,184;--spectrum-semantic-presence-color-6:rgb(var(--spectrum-semantic-presence-color-6-rgb));--spectrum-semantic-presence-color-7-rgb:126,75,243;--spectrum-semantic-presence-color-7:rgb(var(--spectrum-semantic-presence-color-7-rgb));--spectrum-semantic-presence-color-8:var(
--spectrum-global-color-static-fuchsia-600
);--spectrum-global-dimension-static-percent-50:50%;--spectrum-global-dimension-static-percent-70:70%;--spectrum-global-dimension-static-percent-100:100%;--spectrum-global-dimension-static-breakpoint-xsmall:304px;--spectrum-global-dimension-static-breakpoint-small:768px;--spectrum-global-dimension-static-breakpoint-medium:1280px;--spectrum-global-dimension-static-breakpoint-large:1768px;--spectrum-global-dimension-static-breakpoint-xlarge:2160px;--spectrum-global-dimension-static-grid-columns:12;--spectrum-global-dimension-static-grid-fluid-width:100%;--spectrum-global-dimension-static-grid-fixed-max-width:1280px;--spectrum-global-dimension-static-size-0:0px;--spectrum-global-dimension-static-size-10:1px;--spectrum-global-dimension-static-size-25:2px;--spectrum-global-dimension-static-size-40:3px;--spectrum-global-dimension-static-size-50:4px;--spectrum-global-dimension-static-size-65:5px;--spectrum-global-dimension-static-size-75:6px;--spectrum-global-dimension-static-size-85:7px;--spectrum-global-dimension-static-size-100:8px;--spectrum-global-dimension-static-size-115:9px;--spectrum-global-dimension-static-size-125:10px;--spectrum-global-dimension-static-size-130:11px;--spectrum-global-dimension-static-size-150:12px;--spectrum-global-dimension-static-size-160:13px;--spectrum-global-dimension-static-size-175:14px;--spectrum-global-dimension-static-size-185:15px;--spectrum-global-dimension-static-size-200:16px;--spectrum-global-dimension-static-size-225:18px;--spectrum-global-dimension-static-size-250:20px;--spectrum-global-dimension-static-size-275:22px;--spectrum-global-dimension-static-size-300:24px;--spectrum-global-dimension-static-size-325:26px;--spectrum-global-dimension-static-size-350:28px;--spectrum-global-dimension-static-size-400:32px;--spectrum-global-dimension-static-size-450:36px;--spectrum-global-dimension-static-size-500:40px;--spectrum-global-dimension-static-size-550:44px;--spectrum-global-dimension-static-size-600:48px;--spectrum-global-dimension-static-size-700:56px;--spectrum-global-dimension-static-size-800:64px;--spectrum-global-dimension-static-size-900:72px;--spectrum-global-dimension-static-size-1000:80px;--spectrum-global-dimension-static-size-1200:96px;--spectrum-global-dimension-static-size-1700:136px;--spectrum-global-dimension-static-size-2400:192px;--spectrum-global-dimension-static-size-2500:200px;--spectrum-global-dimension-static-size-2600:208px;--spectrum-global-dimension-static-size-2800:224px;--spectrum-global-dimension-static-size-3200:256px;--spectrum-global-dimension-static-size-3400:272px;--spectrum-global-dimension-static-size-3500:280px;--spectrum-global-dimension-static-size-3600:288px;--spectrum-global-dimension-static-size-3800:304px;--spectrum-global-dimension-static-size-4600:368px;--spectrum-global-dimension-static-size-5000:400px;--spectrum-global-dimension-static-size-6000:480px;--spectrum-global-dimension-static-size-16000:1280px;--spectrum-global-dimension-static-font-size-50:11px;--spectrum-global-dimension-static-font-size-75:12px;--spectrum-global-dimension-static-font-size-100:14px;--spectrum-global-dimension-static-font-size-150:15px;--spectrum-global-dimension-static-font-size-200:16px;--spectrum-global-dimension-static-font-size-300:18px;--spectrum-global-dimension-static-font-size-400:20px;--spectrum-global-dimension-static-font-size-500:22px;--spectrum-global-dimension-static-font-size-600:25px;--spectrum-global-dimension-static-font-size-700:28px;--spectrum-global-dimension-static-font-size-800:32px;--spectrum-global-dimension-static-font-size-900:36px;--spectrum-global-dimension-static-font-size-1000:40px;--spectrum-global-font-family-base:adobe-clean,"Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Trebuchet MS","Lucida Grande",sans-serif;--spectrum-global-font-family-serif:adobe-clean-serif,"Source Serif Pro",Georgia,serif;--spectrum-global-font-family-code:"Source Code Pro",Monaco,monospace;--spectrum-global-font-weight-thin:100;--spectrum-global-font-weight-ultra-light:200;--spectrum-global-font-weight-light:300;--spectrum-global-font-weight-regular:400;--spectrum-global-font-weight-medium:500;--spectrum-global-font-weight-semi-bold:600;--spectrum-global-font-weight-bold:700;--spectrum-global-font-weight-extra-bold:800;--spectrum-global-font-weight-black:900;--spectrum-global-font-style-regular:normal;--spectrum-global-font-style-italic:italic;--spectrum-global-font-letter-spacing-none:0;--spectrum-global-font-letter-spacing-small:0.0125em;--spectrum-global-font-letter-spacing-han:0.05em;--spectrum-global-font-letter-spacing-medium:0.06em;--spectrum-global-font-line-height-large:1.7;--spectrum-global-font-line-height-medium:1.5;--spectrum-global-font-line-height-small:1.3;--spectrum-global-font-multiplier-0:0em;--spectrum-global-font-multiplier-25:0.25em;--spectrum-global-font-multiplier-75:0.75em;--spectrum-global-font-font-family-ar:myriad-arabic,adobe-clean,"Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Trebuchet MS","Lucida Grande",sans-serif;--spectrum-global-font-font-family-he:myriad-hebrew,adobe-clean,"Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Trebuchet MS","Lucida Grande",sans-serif;--spectrum-global-font-font-family-zh:adobe-clean-han-traditional,source-han-traditional,"MingLiu","Heiti TC Light","sans-serif";--spectrum-global-font-font-family-zhhans:adobe-clean-han-simplified-c,source-han-simplified-c,"SimSun","Heiti SC Light","sans-serif";--spectrum-global-font-font-family-ko:adobe-clean-han-korean,source-han-korean,"Malgun Gothic","Apple Gothic","sans-serif";--spectrum-global-font-font-family-ja:adobe-clean-han-japanese,"Hiragino Kaku Gothic ProN","ヒラギノ角ゴ ProN W3","Osaka",YuGothic,"Yu Gothic","メイリオ",Meiryo,"ＭＳ Ｐゴシック","MS PGothic","sans-serif";--spectrum-global-font-font-family-condensed:adobe-clean-han-traditional,source-han-traditional,"MingLiu","Heiti TC Light",adobe-clean,"Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Trebuchet MS","Lucida Grande",sans-serif;--spectrum-alias-loupe-entry-animation-duration:var(
--spectrum-global-animation-duration-300
);--spectrum-alias-loupe-exit-animation-duration:var(
--spectrum-global-animation-duration-300
);--spectrum-alias-heading-text-line-height:var(
--spectrum-global-font-line-height-small
);--spectrum-alias-heading-text-font-weight-regular:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-heading-text-font-weight-regular-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-heading-text-font-weight-light:var(
--spectrum-global-font-weight-light
);--spectrum-alias-heading-text-font-weight-light-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-heading-text-font-weight-heavy:var(
--spectrum-global-font-weight-black
);--spectrum-alias-heading-text-font-weight-heavy-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-heading-text-font-weight-quiet:var(
--spectrum-global-font-weight-light
);--spectrum-alias-heading-text-font-weight-quiet-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-heading-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-heading-text-font-weight-strong-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-heading-margin-bottom:var(
--spectrum-global-font-multiplier-25
);--spectrum-alias-subheading-text-font-weight:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-subheading-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-body-text-font-family:var(
--spectrum-global-font-family-base
);--spectrum-alias-body-text-line-height:var(
--spectrum-global-font-line-height-medium
);--spectrum-alias-body-text-font-weight:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-body-text-font-weight-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-body-margin-bottom:var(
--spectrum-global-font-multiplier-75
);--spectrum-alias-detail-text-font-weight:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-detail-text-font-weight-regular:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-detail-text-font-weight-light:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-detail-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-article-heading-text-font-weight:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-article-heading-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-article-heading-text-font-weight-quiet:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-article-heading-text-font-weight-quiet-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-article-body-text-font-weight:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-article-body-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-article-subheading-text-font-weight:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-article-subheading-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-article-detail-text-font-weight:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-article-detail-text-font-weight-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-code-text-font-family:var(
--spectrum-global-font-family-code
);--spectrum-alias-code-text-font-weight-regular:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-code-text-font-weight-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-code-text-line-height:var(
--spectrum-global-font-line-height-medium
);--spectrum-alias-code-margin-bottom:var(
--spectrum-global-font-multiplier-0
);--spectrum-alias-font-family-ar:var(--spectrum-global-font-font-family-ar);--spectrum-alias-font-family-he:var(--spectrum-global-font-font-family-he);--spectrum-alias-font-family-zh:var(--spectrum-global-font-font-family-zh);--spectrum-alias-font-family-zhhans:var(
--spectrum-global-font-font-family-zhhans
);--spectrum-alias-font-family-ko:var(--spectrum-global-font-font-family-ko);--spectrum-alias-font-family-ja:var(--spectrum-global-font-font-family-ja);--spectrum-alias-font-family-condensed:var(
--spectrum-global-font-font-family-condensed
);--spectrum-alias-component-text-line-height:var(
--spectrum-global-font-line-height-small
);--spectrum-alias-han-component-text-line-height:var(
--spectrum-global-font-line-height-medium
);--spectrum-alias-serif-text-font-family:var(
--spectrum-global-font-family-serif
);--spectrum-alias-han-heading-text-line-height:var(
--spectrum-global-font-line-height-medium
);--spectrum-alias-han-heading-text-font-weight-regular:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-heading-text-font-weight-regular-emphasis:var(
--spectrum-global-font-weight-extra-bold
);--spectrum-alias-han-heading-text-font-weight-regular-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-heading-text-font-weight-quiet-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-heading-text-font-weight-light:var(
--spectrum-global-font-weight-light
);--spectrum-alias-han-heading-text-font-weight-light-emphasis:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-han-heading-text-font-weight-light-strong:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-heading-text-font-weight-heavy:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-heading-text-font-weight-heavy-emphasis:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-heading-text-font-weight-heavy-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-body-text-line-height:var(
--spectrum-global-font-line-height-large
);--spectrum-alias-han-body-text-font-weight-regular:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-han-body-text-font-weight-emphasis:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-body-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-subheading-text-font-weight-regular:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-subheading-text-font-weight-emphasis:var(
--spectrum-global-font-weight-extra-bold
);--spectrum-alias-han-subheading-text-font-weight-strong:var(
--spectrum-global-font-weight-black
);--spectrum-alias-han-detail-text-font-weight:var(
--spectrum-global-font-weight-regular
);--spectrum-alias-han-detail-text-font-weight-emphasis:var(
--spectrum-global-font-weight-bold
);--spectrum-alias-han-detail-text-font-weight-strong:var(
--spectrum-global-font-weight-black
)}:host,:root{--spectrum-alias-item-height-s:var(--spectrum-global-dimension-size-300);--spectrum-alias-item-height-m:var(--spectrum-global-dimension-size-400);--spectrum-alias-item-height-l:var(--spectrum-global-dimension-size-500);--spectrum-alias-item-height-xl:var(--spectrum-global-dimension-size-600);--spectrum-alias-item-rounded-border-radius-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-rounded-border-radius-m:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-item-rounded-border-radius-l:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-item-rounded-border-radius-xl:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-item-text-size-s:var(
--spectrum-global-dimension-font-size-75
);--spectrum-alias-item-text-size-m:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-item-text-size-l:var(
--spectrum-global-dimension-font-size-200
);--spectrum-alias-item-text-size-xl:var(
--spectrum-global-dimension-font-size-300
);--spectrum-alias-item-text-padding-top-s:var(
--spectrum-global-dimension-static-size-50
);--spectrum-alias-item-text-padding-top-m:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-item-text-padding-top-xl:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-text-padding-bottom-m:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-text-padding-bottom-l:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-item-text-padding-bottom-xl:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-item-icon-padding-top-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-item-icon-padding-top-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-icon-padding-top-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-icon-padding-top-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-icon-padding-bottom-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-item-icon-padding-bottom-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-icon-padding-bottom-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-icon-padding-bottom-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-padding-s:var(--spectrum-global-dimension-size-115);--spectrum-alias-item-padding-m:var(--spectrum-global-dimension-size-150);--spectrum-alias-item-padding-l:var(--spectrum-global-dimension-size-185);--spectrum-alias-item-padding-xl:var(--spectrum-global-dimension-size-225);--spectrum-alias-item-rounded-padding-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-rounded-padding-m:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-item-rounded-padding-l:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-item-rounded-padding-xl:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-item-icononly-padding-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-item-icononly-padding-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-icononly-padding-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-icononly-padding-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-control-gap-s:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-control-gap-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-gap-l:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-item-control-gap-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-workflow-icon-gap-s:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-workflow-icon-gap-m:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-item-workflow-icon-gap-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-workflow-icon-gap-xl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-mark-gap-s:var(--spectrum-global-dimension-size-85);--spectrum-alias-item-mark-gap-m:var(--spectrum-global-dimension-size-100);--spectrum-alias-item-mark-gap-l:var(--spectrum-global-dimension-size-115);--spectrum-alias-item-mark-gap-xl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-ui-icon-gap-s:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-ui-icon-gap-m:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-item-ui-icon-gap-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-ui-icon-gap-xl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-clearbutton-gap-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-item-clearbutton-gap-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-clearbutton-gap-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-clearbutton-gap-xl:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-workflow-padding-left-s:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-workflow-padding-left-l:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-workflow-padding-left-xl:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-item-rounded-workflow-padding-left-s:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-rounded-workflow-padding-left-l:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-item-mark-padding-top-s:var(
--spectrum-global-dimension-size-40
);--spectrum-alias-item-mark-padding-top-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-mark-padding-top-xl:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-item-mark-padding-bottom-s:var(
--spectrum-global-dimension-size-40
);--spectrum-alias-item-mark-padding-bottom-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-mark-padding-bottom-xl:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-item-mark-padding-left-s:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-mark-padding-left-l:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-item-mark-padding-left-xl:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-item-control-1-size-s:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-item-control-1-size-m:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-item-control-2-size-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-item-control-2-size-l:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-item-control-2-size-xl:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-item-control-2-size-xxl:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-item-control-2-border-radius-s:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-item-control-2-border-radius-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-control-2-border-radius-l:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-item-control-2-border-radius-xl:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-control-2-border-radius-xxl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-2-padding-s:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-item-control-2-padding-m:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-control-2-padding-l:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-2-padding-xl:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-item-control-3-height-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-item-control-3-height-l:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-item-control-3-height-xl:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-item-control-3-border-radius-s:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-item-control-3-border-radius-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-item-control-3-border-radius-l:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-item-control-3-border-radius-xl:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-control-3-padding-s:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-item-control-3-padding-m:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-control-3-padding-l:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-3-padding-xl:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-item-mark-size-s:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-item-mark-size-l:var(
--spectrum-global-dimension-size-275
);--spectrum-alias-item-mark-size-xl:var(
--spectrum-global-dimension-size-325
);--spectrum-alias-heading-xxxl-text-size:var(
--spectrum-global-dimension-font-size-1300
);--spectrum-alias-heading-xxl-text-size:var(
--spectrum-global-dimension-font-size-1100
);--spectrum-alias-heading-xl-text-size:var(
--spectrum-global-dimension-font-size-900
);--spectrum-alias-heading-l-text-size:var(
--spectrum-global-dimension-font-size-700
);--spectrum-alias-heading-m-text-size:var(
--spectrum-global-dimension-font-size-500
);--spectrum-alias-heading-s-text-size:var(
--spectrum-global-dimension-font-size-300
);--spectrum-alias-heading-xs-text-size:var(
--spectrum-global-dimension-font-size-200
);--spectrum-alias-heading-xxs-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-heading-xxxl-margin-top:var(
--spectrum-global-dimension-font-size-1200
);--spectrum-alias-heading-xxl-margin-top:var(
--spectrum-global-dimension-font-size-900
);--spectrum-alias-heading-xl-margin-top:var(
--spectrum-global-dimension-font-size-800
);--spectrum-alias-heading-l-margin-top:var(
--spectrum-global-dimension-font-size-600
);--spectrum-alias-heading-m-margin-top:var(
--spectrum-global-dimension-font-size-400
);--spectrum-alias-heading-s-margin-top:var(
--spectrum-global-dimension-font-size-200
);--spectrum-alias-heading-xs-margin-top:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-heading-xxs-margin-top:var(
--spectrum-global-dimension-font-size-75
);--spectrum-alias-heading-han-xxxl-text-size:var(
--spectrum-global-dimension-font-size-1300
);--spectrum-alias-heading-han-xxl-text-size:var(
--spectrum-global-dimension-font-size-900
);--spectrum-alias-heading-han-xl-text-size:var(
--spectrum-global-dimension-font-size-800
);--spectrum-alias-heading-han-l-text-size:var(
--spectrum-global-dimension-font-size-600
);--spectrum-alias-heading-han-m-text-size:var(
--spectrum-global-dimension-font-size-400
);--spectrum-alias-heading-han-s-text-size:var(
--spectrum-global-dimension-font-size-300
);--spectrum-alias-heading-han-xs-text-size:var(
--spectrum-global-dimension-font-size-200
);--spectrum-alias-heading-han-xxs-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-heading-han-xxxl-margin-top:var(
--spectrum-global-dimension-font-size-1200
);--spectrum-alias-heading-han-xxl-margin-top:var(
--spectrum-global-dimension-font-size-800
);--spectrum-alias-heading-han-xl-margin-top:var(
--spectrum-global-dimension-font-size-700
);--spectrum-alias-heading-han-l-margin-top:var(
--spectrum-global-dimension-font-size-500
);--spectrum-alias-heading-han-m-margin-top:var(
--spectrum-global-dimension-font-size-300
);--spectrum-alias-heading-han-s-margin-top:var(
--spectrum-global-dimension-font-size-200
);--spectrum-alias-heading-han-xs-margin-top:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-heading-han-xxs-margin-top:var(
--spectrum-global-dimension-font-size-75
);--spectrum-alias-component-border-radius:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-component-border-radius-quiet:var(
--spectrum-global-dimension-static-size-0
);--spectrum-alias-component-focusring-gap:var(
--spectrum-global-dimension-static-size-0
);--spectrum-alias-component-focusring-gap-emphasized:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-component-focusring-size:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-component-focusring-size-emphasized:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-input-border-size:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-input-focusring-gap:var(
--spectrum-global-dimension-static-size-0
);--spectrum-alias-input-quiet-focusline-gap:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-control-two-size-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-control-two-size-l:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-control-two-size-xl:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-control-two-size-xxl:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-control-two-border-radius-s:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-control-two-border-radius-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-control-two-border-radius-l:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-control-two-border-radius-xl:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-control-two-border-radius-xxl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-control-two-focus-ring-border-radius-s:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-control-two-focus-ring-border-radius-m:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-control-two-focus-ring-border-radius-l:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-control-two-focus-ring-border-radius-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-control-two-focus-ring-border-radius-xxl:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-control-three-height-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-control-three-height-l:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-control-three-height-xl:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-infieldbutton-icon-margin-y-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-infieldbutton-icon-margin-y-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-infieldbutton-icon-margin-y-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-infieldbutton-icon-margin-y-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-infieldbutton-border-radius:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-infieldbutton-border-radius-sided:0;--spectrum-alias-infieldbutton-border-size:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-infieldbutton-fill-padding-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-infieldbutton-fill-padding-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-infieldbutton-fill-padding-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-infieldbutton-fill-padding-xl:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-infieldbutton-padding-s:0;--spectrum-alias-infieldbutton-padding-m:0;--spectrum-alias-infieldbutton-padding-l:0;--spectrum-alias-infieldbutton-padding-xl:0;--spectrum-alias-infieldbutton-full-height-s:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-infieldbutton-full-height-m:var(
--spectrum-global-dimension-size-400
);--spectrum-alias-infieldbutton-full-height-l:var(
--spectrum-global-dimension-size-500
);--spectrum-alias-infieldbutton-full-height-xl:var(
--spectrum-global-dimension-size-600
);--spectrum-alias-infieldbutton-half-height-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-infieldbutton-half-height-m:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-infieldbutton-half-height-l:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-infieldbutton-half-height-xl:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-stepperbutton-gap:0;--spectrum-alias-stepperbutton-width-s:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-stepperbutton-width-m:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-stepperbutton-width-l:var(
--spectrum-global-dimension-size-400
);--spectrum-alias-stepperbutton-width-xl:var(
--spectrum-global-dimension-size-450
);--spectrum-alias-stepperbutton-icon-x-offset-s:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-stepperbutton-icon-x-offset-m:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-stepperbutton-icon-x-offset-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-stepperbutton-icon-x-offset-xl:var(
--spectrum-global-dimension-size-130
);--spectrum-alias-stepperbutton-icon-y-offset-top-s:var(
--spectrum-global-dimension-size-25
);--spectrum-alias-stepperbutton-icon-y-offset-top-m:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-stepperbutton-icon-y-offset-top-l:var(
--spectrum-global-dimension-size-65
);--spectrum-alias-stepperbutton-icon-y-offset-top-xl:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-stepperbutton-icon-y-offset-bottom-s:var(
--spectrum-global-dimension-size-10
);--spectrum-alias-stepperbutton-icon-y-offset-bottom-m:var(
--spectrum-global-dimension-size-25
);--spectrum-alias-stepperbutton-icon-y-offset-bottom-l:var(
--spectrum-global-dimension-size-40
);--spectrum-alias-stepperbutton-icon-y-offset-bottom-xl:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-stepperbutton-radius-touching:0;--spectrum-alias-clearbutton-icon-margin-s:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-clearbutton-icon-margin-m:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-clearbutton-icon-margin-l:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-clearbutton-icon-margin-xl:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-clearbutton-border-radius:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-search-border-radius:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-search-border-radius-quiet:0;--spectrum-alias-combobox-quiet-button-offset-x:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-thumbnail-border-radius-small:var(
--spectrum-global-dimension-size-25
);--spectrum-alias-search-padding-left-s:var(
--spectrum-global-dimension-size-85
);--spectrum-alias-search-padding-left-l:var(
--spectrum-global-dimension-size-160
);--spectrum-alias-search-padding-left-xl:var(
--spectrum-global-dimension-size-185
);--spectrum-alias-percent-50:50%;--spectrum-alias-percent-70:70%;--spectrum-alias-percent-100:100%;--spectrum-alias-breakpoint-xsmall:304px;--spectrum-alias-breakpoint-small:768px;--spectrum-alias-breakpoint-medium:1280px;--spectrum-alias-breakpoint-large:1768px;--spectrum-alias-breakpoint-xlarge:2160px;--spectrum-alias-grid-columns:12;--spectrum-alias-grid-fluid-width:100%;--spectrum-alias-grid-fixed-max-width:1280px;--spectrum-alias-border-size-thin:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-border-size-thick:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-border-size-thicker:var(
--spectrum-global-dimension-static-size-50
);--spectrum-alias-border-size-thickest:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-border-offset-thin:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-border-offset-thick:var(
--spectrum-global-dimension-static-size-50
);--spectrum-alias-border-offset-thicker:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-border-offset-thickest:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-grid-baseline:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-grid-gutter-xsmall:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-grid-gutter-small:var(
--spectrum-global-dimension-static-size-300
);--spectrum-alias-grid-gutter-medium:var(
--spectrum-global-dimension-static-size-400
);--spectrum-alias-grid-gutter-large:var(
--spectrum-global-dimension-static-size-500
);--spectrum-alias-grid-gutter-xlarge:var(
--spectrum-global-dimension-static-size-600
);--spectrum-alias-grid-margin-xsmall:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-grid-margin-small:var(
--spectrum-global-dimension-static-size-300
);--spectrum-alias-grid-margin-medium:var(
--spectrum-global-dimension-static-size-400
);--spectrum-alias-grid-margin-large:var(
--spectrum-global-dimension-static-size-500
);--spectrum-alias-grid-margin-xlarge:var(
--spectrum-global-dimension-static-size-600
);--spectrum-alias-grid-layout-region-margin-bottom-xsmall:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-grid-layout-region-margin-bottom-small:var(
--spectrum-global-dimension-static-size-300
);--spectrum-alias-grid-layout-region-margin-bottom-medium:var(
--spectrum-global-dimension-static-size-400
);--spectrum-alias-grid-layout-region-margin-bottom-large:var(
--spectrum-global-dimension-static-size-500
);--spectrum-alias-grid-layout-region-margin-bottom-xlarge:var(
--spectrum-global-dimension-static-size-600
);--spectrum-alias-radial-reaction-size-default:var(
--spectrum-global-dimension-static-size-550
);--spectrum-alias-focus-ring-gap:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-focus-ring-size:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-focus-ring-gap-small:var(
--spectrum-global-dimension-static-size-0
);--spectrum-alias-focus-ring-size-small:var(
--spectrum-global-dimension-static-size-10
);--spectrum-alias-dropshadow-blur:var(--spectrum-global-dimension-size-50);--spectrum-alias-dropshadow-offset-y:var(
--spectrum-global-dimension-size-10
);--spectrum-alias-font-size-default:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-layout-label-gap-size:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-pill-button-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-alias-pill-button-text-baseline:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-border-radius-xsmall:var(
--spectrum-global-dimension-size-10
);--spectrum-alias-border-radius-small:var(
--spectrum-global-dimension-size-25
);--spectrum-alias-border-radius-regular:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-border-radius-medium:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-border-radius-large:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-border-radius-xlarge:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-focus-ring-border-radius-xsmall:var(
--spectrum-global-dimension-size-50
);--spectrum-alias-focus-ring-border-radius-small:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-focus-ring-border-radius-medium:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-focus-ring-border-radius-large:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-focus-ring-border-radius-xlarge:var(
--spectrum-global-dimension-size-350
);--spectrum-alias-single-line-height:var(
--spectrum-global-dimension-size-400
);--spectrum-alias-single-line-width:var(
--spectrum-global-dimension-size-2400
);--spectrum-alias-workflow-icon-size-s:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-workflow-icon-size-m:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-workflow-icon-size-xl:var(
--spectrum-global-dimension-size-275
);--spectrum-alias-ui-icon-alert-size-75:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-ui-icon-alert-size-100:var(
--spectrum-global-dimension-size-225
);--spectrum-alias-ui-icon-alert-size-200:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-ui-icon-alert-size-300:var(
--spectrum-global-dimension-size-275
);--spectrum-alias-ui-icon-triplegripper-size-100-height:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-ui-icon-doublegripper-size-100-width:var(
--spectrum-global-dimension-size-200
);--spectrum-alias-ui-icon-singlegripper-size-100-width:var(
--spectrum-global-dimension-size-300
);--spectrum-alias-ui-icon-cornertriangle-size-75:var(
--spectrum-global-dimension-size-65
);--spectrum-alias-ui-icon-cornertriangle-size-200:var(
--spectrum-global-dimension-size-75
);--spectrum-alias-ui-icon-asterisk-size-75:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-asterisk-size-100:var(
--spectrum-global-dimension-size-100
);--spectrum-alias-colorloupe-width:var(
--spectrum-global-dimension-static-size-600
);--spectrum-alias-colorloupe-height:var(
--spectrum-global-dimension-static-size-800
)}:host,:root{--spectrum-alias-colorhandle-outer-border-color:rgba(0,0,0,.42);--spectrum-alias-transparent-blue-background-color-hover:rgba(0,87,190,.15);--spectrum-alias-transparent-blue-background-color-down:rgba(0,72,153,.3);--spectrum-alias-transparent-blue-background-color-key-focus:var(
--spectrum-alias-transparent-blue-background-color-hover
);--spectrum-alias-transparent-blue-background-color-mouse-focus:var(
--spectrum-alias-transparent-blue-background-color-hover
);--spectrum-alias-transparent-blue-background-color:var(
--spectrum-alias-component-text-color-default
);--spectrum-alias-transparent-red-background-color-hover:rgba(154,0,0,.15);--spectrum-alias-transparent-red-background-color-down:rgba(124,0,0,.3);--spectrum-alias-transparent-red-background-color-key-focus:var(
--spectrum-alias-transparent-red-background-color-hover
);--spectrum-alias-transparent-red-background-color-mouse-focus:var(
--spectrum-alias-transparent-red-background-color-hover
);--spectrum-alias-transparent-red-background-color:var(
--spectrum-alias-component-text-color-default
);--spectrum-alias-component-text-color-disabled:var(
--spectrum-global-color-gray-500
);--spectrum-alias-component-text-color-default:var(
--spectrum-global-color-gray-800
);--spectrum-alias-component-text-color-hover:var(
--spectrum-global-color-gray-900
);--spectrum-alias-component-text-color-down:var(
--spectrum-global-color-gray-900
);--spectrum-alias-component-text-color-key-focus:var(
--spectrum-alias-component-text-color-hover
);--spectrum-alias-component-text-color-mouse-focus:var(
--spectrum-alias-component-text-color-hover
);--spectrum-alias-component-text-color:var(
--spectrum-alias-component-text-color-default
);--spectrum-alias-component-text-color-selected-default:var(
--spectrum-alias-component-text-color-default
);--spectrum-alias-component-text-color-selected-hover:var(
--spectrum-alias-component-text-color-hover
);--spectrum-alias-component-text-color-selected-down:var(
--spectrum-alias-component-text-color-down
);--spectrum-alias-component-text-color-selected-key-focus:var(
--spectrum-alias-component-text-color-key-focus
);--spectrum-alias-component-text-color-selected-mouse-focus:var(
--spectrum-alias-component-text-color-mouse-focus
);--spectrum-alias-component-text-color-selected:var(
--spectrum-alias-component-text-color-selected-default
);--spectrum-alias-component-text-color-emphasized-selected-default:var(
--spectrum-global-color-static-white
);--spectrum-alias-component-text-color-emphasized-selected-hover:var(
--spectrum-alias-component-text-color-emphasized-selected-default
);--spectrum-alias-component-text-color-emphasized-selected-down:var(
--spectrum-alias-component-text-color-emphasized-selected-default
);--spectrum-alias-component-text-color-emphasized-selected-key-focus:var(
--spectrum-alias-component-text-color-emphasized-selected-default
);--spectrum-alias-component-text-color-emphasized-selected-mouse-focus:var(
--spectrum-alias-component-text-color-emphasized-selected-default
);--spectrum-alias-component-text-color-emphasized-selected:var(
--spectrum-alias-component-text-color-emphasized-selected-default
);--spectrum-alias-component-text-color-error-default:var(
--spectrum-semantic-negative-text-color-small
);--spectrum-alias-component-text-color-error-hover:var(
--spectrum-semantic-negative-text-color-small-hover
);--spectrum-alias-component-text-color-error-down:var(
--spectrum-semantic-negative-text-color-small-down
);--spectrum-alias-component-text-color-error-key-focus:var(
--spectrum-semantic-negative-text-color-small-key-focus
);--spectrum-alias-component-text-color-error-mouse-focus:var(
--spectrum-semantic-negative-text-color-small-key-focus
);--spectrum-alias-component-text-color-error:var(
--spectrum-alias-component-text-color-error-default
);--spectrum-alias-component-icon-color-disabled:var(
--spectrum-alias-icon-color-disabled
);--spectrum-alias-component-icon-color-default:var(
--spectrum-alias-icon-color
);--spectrum-alias-component-icon-color-hover:var(
--spectrum-alias-icon-color-hover
);--spectrum-alias-component-icon-color-down:var(
--spectrum-alias-icon-color-down
);--spectrum-alias-component-icon-color-key-focus:var(
--spectrum-alias-icon-color-hover
);--spectrum-alias-component-icon-color-mouse-focus:var(
--spectrum-alias-icon-color-down
);--spectrum-alias-component-icon-color:var(
--spectrum-alias-component-icon-color-default
);--spectrum-alias-component-icon-color-selected:var(
--spectrum-alias-icon-color-selected-neutral-subdued
);--spectrum-alias-component-icon-color-emphasized-selected-default:var(
--spectrum-global-color-static-white
);--spectrum-alias-component-icon-color-emphasized-selected-hover:var(
--spectrum-alias-component-icon-color-emphasized-selected-default
);--spectrum-alias-component-icon-color-emphasized-selected-down:var(
--spectrum-alias-component-icon-color-emphasized-selected-default
);--spectrum-alias-component-icon-color-emphasized-selected-key-focus:var(
--spectrum-alias-component-icon-color-emphasized-selected-default
);--spectrum-alias-component-icon-color-emphasized-selected:var(
--spectrum-alias-component-icon-color-emphasized-selected-default
);--spectrum-alias-component-background-color-disabled:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-quiet-disabled:var(
--spectrum-alias-background-color-transparent
);--spectrum-alias-component-background-color-quiet-selected-disabled:var(
--spectrum-alias-component-background-color-disabled
);--spectrum-alias-component-background-color-default:var(
--spectrum-global-color-gray-75
);--spectrum-alias-component-background-color-hover:var(
--spectrum-global-color-gray-50
);--spectrum-alias-component-background-color-down:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-key-focus:var(
--spectrum-global-color-gray-50
);--spectrum-alias-component-background-color:var(
--spectrum-alias-component-background-color-default
);--spectrum-alias-component-background-color-selected-default:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-selected-hover:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-selected-down:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-selected-key-focus:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-background-color-selected:var(
--spectrum-alias-component-background-color-selected-default
);--spectrum-alias-component-background-color-quiet-default:var(
--spectrum-alias-background-color-transparent
);--spectrum-alias-component-background-color-quiet-hover:var(
--spectrum-alias-background-color-transparent
);--spectrum-alias-component-background-color-quiet-down:var(
--spectrum-global-color-gray-300
);--spectrum-alias-component-background-color-quiet-key-focus:var(
--spectrum-alias-background-color-transparent
);--spectrum-alias-component-background-color-quiet:var(
--spectrum-alias-component-background-color-quiet-default
);--spectrum-alias-component-background-color-quiet-selected-default:var(
--spectrum-alias-component-background-color-selected-default
);--spectrum-alias-component-background-color-quiet-selected-hover:var(
--spectrum-alias-component-background-color-selected-hover
);--spectrum-alias-component-background-color-quiet-selected-down:var(
--spectrum-alias-component-background-color-selected-down
);--spectrum-alias-component-background-color-quiet-selected-key-focus:var(
--spectrum-alias-component-background-color-selected-key-focus
);--spectrum-alias-component-background-color-quiet-selected:var(
--spectrum-alias-component-background-color-selected-default
);--spectrum-alias-component-background-color-emphasized-selected-default:var(
--spectrum-semantic-cta-background-color-default
);--spectrum-alias-component-background-color-emphasized-selected-hover:var(
--spectrum-semantic-cta-background-color-hover
);--spectrum-alias-component-background-color-emphasized-selected-down:var(
--spectrum-semantic-cta-background-color-down
);--spectrum-alias-component-background-color-emphasized-selected-key-focus:var(
--spectrum-semantic-cta-background-color-key-focus
);--spectrum-alias-component-background-color-emphasized-selected:var(
--spectrum-alias-component-background-color-emphasized-selected-default
);--spectrum-alias-component-border-color-disabled:var(
--spectrum-alias-border-color-disabled
);--spectrum-alias-component-border-color-quiet-disabled:var(
--spectrum-alias-border-color-transparent
);--spectrum-alias-component-border-color-default:var(
--spectrum-alias-border-color
);--spectrum-alias-component-border-color-hover:var(
--spectrum-alias-border-color-hover
);--spectrum-alias-component-border-color-down:var(
--spectrum-alias-border-color-down
);--spectrum-alias-component-border-color-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-component-border-color:var(
--spectrum-alias-component-border-color-default
);--spectrum-alias-component-border-color-selected-default:var(
--spectrum-alias-border-color
);--spectrum-alias-component-border-color-selected-hover:var(
--spectrum-alias-border-color-hover
);--spectrum-alias-component-border-color-selected-down:var(
--spectrum-alias-border-color-down
);--spectrum-alias-component-border-color-selected-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-component-border-color-selected:var(
--spectrum-alias-component-border-color-selected-default
);--spectrum-alias-component-border-color-quiet-default:var(
--spectrum-alias-border-color-transparent
);--spectrum-alias-component-border-color-quiet-hover:var(
--spectrum-alias-border-color-transparent
);--spectrum-alias-component-border-color-quiet-down:var(
--spectrum-alias-border-color-transparent
);--spectrum-alias-component-border-color-quiet-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-component-border-color-quiet:var(
--spectrum-alias-component-border-color-quiet-default
);--spectrum-alias-component-border-color-quiet-selected-default:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-border-color-quiet-selected-hover:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-border-color-quiet-selected-down:var(
--spectrum-global-color-gray-200
);--spectrum-alias-component-border-color-quiet-selected-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-component-border-color-quiet-selected:var(
--spectrum-alias-component-border-color-quiet-selected-default
);--spectrum-alias-component-border-color-emphasized-selected-default:var(
--spectrum-semantic-cta-background-color-default
);--spectrum-alias-component-border-color-emphasized-selected-hover:var(
--spectrum-semantic-cta-background-color-hover
);--spectrum-alias-component-border-color-emphasized-selected-down:var(
--spectrum-semantic-cta-background-color-down
);--spectrum-alias-component-border-color-emphasized-selected-key-focus:var(
--spectrum-semantic-cta-background-color-key-focus
);--spectrum-alias-component-border-color-emphasized-selected:var(
--spectrum-alias-component-border-color-emphasized-selected-default
);--spectrum-alias-toggle-background-color-default:var(
--spectrum-global-color-gray-700
);--spectrum-alias-toggle-background-color-hover:var(
--spectrum-global-color-gray-800
);--spectrum-alias-toggle-background-color-down:var(
--spectrum-global-color-gray-900
);--spectrum-alias-toggle-background-color-key-focus:var(
--spectrum-global-color-gray-800
);--spectrum-alias-toggle-background-color:var(
--spectrum-alias-toggle-background-color-default
);--spectrum-alias-toggle-background-color-emphasized-selected-default:var(
--spectrum-global-color-blue-500
);--spectrum-alias-toggle-background-color-emphasized-selected-hover:var(
--spectrum-global-color-blue-600
);--spectrum-alias-toggle-background-color-emphasized-selected-down:var(
--spectrum-global-color-blue-700
);--spectrum-alias-toggle-background-color-emphasized-selected-key-focus:var(
--spectrum-global-color-blue-600
);--spectrum-alias-toggle-background-color-emphasized-selected:var(
--spectrum-alias-toggle-background-color-emphasized-selected-default
);--spectrum-alias-toggle-border-color-default:var(
--spectrum-global-color-gray-700
);--spectrum-alias-toggle-border-color-hover:var(
--spectrum-global-color-gray-800
);--spectrum-alias-toggle-border-color-down:var(
--spectrum-global-color-gray-900
);--spectrum-alias-toggle-border-color-key-focus:var(
--spectrum-global-color-gray-800
);--spectrum-alias-toggle-border-color:var(
--spectrum-alias-toggle-border-color-default
);--spectrum-alias-toggle-icon-color-selected:var(
--spectrum-global-color-gray-75
);--spectrum-alias-toggle-icon-color-emphasized-selected:var(
--spectrum-global-color-gray-75
);--spectrum-alias-input-border-color-disabled:var(
--spectrum-alias-border-color-transparent
);--spectrum-alias-input-border-color-quiet-disabled:var(
--spectrum-alias-border-color-mid
);--spectrum-alias-input-border-color-default:var(
--spectrum-alias-border-color
);--spectrum-alias-input-border-color-hover:var(
--spectrum-alias-border-color-hover
);--spectrum-alias-input-border-color-down:var(
--spectrum-alias-border-color-mouse-focus
);--spectrum-alias-input-border-color-mouse-focus:var(
--spectrum-alias-border-color-mouse-focus
);--spectrum-alias-input-border-color-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-input-border-color:var(
--spectrum-alias-input-border-color-default
);--spectrum-alias-input-border-color-invalid-default:var(
--spectrum-semantic-negative-color-default
);--spectrum-alias-input-border-color-invalid-hover:var(
--spectrum-semantic-negative-color-hover
);--spectrum-alias-input-border-color-invalid-down:var(
--spectrum-semantic-negative-color-down
);--spectrum-alias-input-border-color-invalid-mouse-focus:var(
--spectrum-semantic-negative-color-hover
);--spectrum-alias-input-border-color-invalid-key-focus:var(
--spectrum-alias-border-color-key-focus
);--spectrum-alias-input-border-color-invalid:var(
--spectrum-alias-input-border-color-invalid-default
);--spectrum-alias-background-color-yellow-default:var(
--spectrum-global-color-static-yellow-300
);--spectrum-alias-background-color-yellow-hover:var(
--spectrum-global-color-static-yellow-400
);--spectrum-alias-background-color-yellow-key-focus:var(
--spectrum-global-color-static-yellow-400
);--spectrum-alias-background-color-yellow-down:var(
--spectrum-global-color-static-yellow-500
);--spectrum-alias-background-color-yellow:var(
--spectrum-alias-background-color-yellow-default
);--spectrum-alias-infieldbutton-background-color:var(
--spectrum-global-color-gray-200
);--spectrum-alias-infieldbutton-fill-loudnessLow-border-color-disabled:transparent;--spectrum-alias-infieldbutton-fill-loudnessMedium-border-color-disabled:transparent;--spectrum-alias-infieldbutton-fill-loudnessHigh-border-color-disabled:var(
--spectrum-alias-component-background-color-disabled
);--spectrum-alias-infieldbutton-fill-border-color-default:var(
--spectrum-alias-input-border-color-default
);--spectrum-alias-infieldbutton-fill-border-color-hover:var(
--spectrum-alias-input-border-color-hover
);--spectrum-alias-infieldbutton-fill-border-color-down:var(
--spectrum-alias-input-border-color-down
);--spectrum-alias-infieldbutton-fill-border-color-mouse-focus:var(
--spectrum-alias-input-border-color-mouse-focus
);--spectrum-alias-infieldbutton-fill-border-color-key-focus:var(
--spectrum-alias-input-border-color-key-focus
);--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-default:transparent;--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-hover:transparent;--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-down:transparent;--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-key-focus:transparent;--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-disabled:transparent;--spectrum-alias-infieldbutton-fill-loudnessMedium-background-color-default:var(
--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-default
);--spectrum-alias-infieldbutton-fill-loudnessMedium-background-color-hover:var(
--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-hover
);--spectrum-alias-infieldbutton-fill-loudnessMedium-background-color-down:var(
--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-down
);--spectrum-alias-infieldbutton-fill-loudnessMedium-background-color-key-focus:var(
--spectrum-alias-infieldbutton-fill-loudnessLow-background-color-key-focus
);--spectrum-alias-infieldbutton-fill-loudnessMedium-background-color-disabled:transparent;--spectrum-alias-infieldbutton-fill-loudnessHigh-background-color-default:var(
--spectrum-alias-component-background-color-default
);--spectrum-alias-infieldbutton-fill-loudnessHigh-background-color-hover:var(
--spectrum-alias-component-background-color-hover
);--spectrum-alias-infieldbutton-fill-loudnessHigh-background-color-down:var(
--spectrum-alias-component-background-color-down
);--spectrum-alias-infieldbutton-fill-loudnessHigh-background-color-key-focus:var(
--spectrum-alias-component-background-color-key-focus
);--spectrum-alias-infieldbutton-fill-loudnessHigh-background-color-disabled:var(
--spectrum-alias-component-background-color-disabled
);--spectrum-alias-tabs-divider-background-color-default:var(
--spectrum-global-color-gray-300
);--spectrum-alias-tabs-divider-background-color-quiet:var(
--spectrum-alias-background-color-transparent
);--spectrum-alias-tabitem-text-color-default:var(
--spectrum-alias-label-text-color
);--spectrum-alias-tabitem-text-color-hover:var(
--spectrum-alias-text-color-hover
);--spectrum-alias-tabitem-text-color-down:var(
--spectrum-alias-text-color-down
);--spectrum-alias-tabitem-text-color-key-focus:var(
--spectrum-alias-text-color-hover
);--spectrum-alias-tabitem-text-color-mouse-focus:var(
--spectrum-alias-text-color-hover
);--spectrum-alias-tabitem-text-color:var(
--spectrum-alias-tabitem-text-color-default
);--spectrum-alias-tabitem-text-color-selected-default:var(
--spectrum-global-color-gray-900
);--spectrum-alias-tabitem-text-color-selected-hover:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-text-color-selected-down:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-text-color-selected-key-focus:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-text-color-selected-mouse-focus:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-text-color-selected:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-text-color-emphasized:var(
--spectrum-alias-tabitem-text-color-default
);--spectrum-alias-tabitem-text-color-emphasized-selected-default:var(
--spectrum-global-color-static-blue-500
);--spectrum-alias-tabitem-text-color-emphasized-selected-hover:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-text-color-emphasized-selected-down:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-text-color-emphasized-selected-key-focus:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-text-color-emphasized-selected-mouse-focus:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-text-color-emphasized-selected:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-selection-indicator-color-default:var(
--spectrum-alias-tabitem-text-color-selected-default
);--spectrum-alias-tabitem-selection-indicator-color-emphasized:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-tabitem-icon-color-disabled:var(
--spectrum-alias-text-color-disabled
);--spectrum-alias-tabitem-icon-color-default:var(
--spectrum-alias-icon-color
);--spectrum-alias-tabitem-icon-color-hover:var(
--spectrum-alias-icon-color-hover
);--spectrum-alias-tabitem-icon-color-down:var(
--spectrum-alias-icon-color-down
);--spectrum-alias-tabitem-icon-color-key-focus:var(
--spectrum-alias-icon-color-hover
);--spectrum-alias-tabitem-icon-color-mouse-focus:var(
--spectrum-alias-icon-color-down
);--spectrum-alias-tabitem-icon-color:var(
--spectrum-alias-tabitem-icon-color-default
);--spectrum-alias-tabitem-icon-color-selected:var(
--spectrum-alias-icon-color-selected-neutral
);--spectrum-alias-tabitem-icon-color-emphasized:var(
--spectrum-alias-tabitem-text-color-default
);--spectrum-alias-tabitem-icon-color-emphasized-selected:var(
--spectrum-alias-tabitem-text-color-emphasized-selected-default
);--spectrum-alias-assetcard-selectionindicator-background-color-ordered:var(
--spectrum-global-color-blue-500
);--spectrum-alias-assetcard-overlay-background-color:rgba(27,127,245,.1);--spectrum-alias-assetcard-border-color-selected:var(
--spectrum-global-color-blue-500
);--spectrum-alias-assetcard-border-color-selected-hover:var(
--spectrum-global-color-blue-500
);--spectrum-alias-assetcard-border-color-selected-down:var(
--spectrum-global-color-blue-600
);--spectrum-alias-background-color-default:var(
--spectrum-global-color-gray-100
);--spectrum-alias-background-color-disabled:var(
--spectrum-global-color-gray-200
);--spectrum-alias-background-color-transparent:transparent;--spectrum-alias-background-color-overbackground-down:hsla(0,0%,100%,.2);--spectrum-alias-background-color-quiet-overbackground-hover:hsla(0,0%,100%,.1);--spectrum-alias-background-color-quiet-overbackground-down:hsla(0,0%,100%,.2);--spectrum-alias-background-color-overbackground-disabled:hsla(0,0%,100%,.1);--spectrum-alias-background-color-quickactions-overlay:rgba(0,0,0,.2);--spectrum-alias-placeholder-text-color:var(
--spectrum-global-color-gray-800
);--spectrum-alias-placeholder-text-color-hover:var(
--spectrum-global-color-gray-900
);--spectrum-alias-placeholder-text-color-down:var(
--spectrum-global-color-gray-900
);--spectrum-alias-placeholder-text-color-selected:var(
--spectrum-global-color-gray-800
);--spectrum-alias-label-text-color:var(--spectrum-global-color-gray-700);--spectrum-alias-text-color:var(--spectrum-global-color-gray-800);--spectrum-alias-text-color-hover:var(--spectrum-global-color-gray-900);--spectrum-alias-text-color-down:var(--spectrum-global-color-gray-900);--spectrum-alias-text-color-key-focus:var(
--spectrum-global-color-blue-600
);--spectrum-alias-text-color-mouse-focus:var(
--spectrum-global-color-blue-600
);--spectrum-alias-text-color-disabled:var(--spectrum-global-color-gray-500);--spectrum-alias-text-color-invalid:var(--spectrum-global-color-red-500);--spectrum-alias-text-color-selected:var(--spectrum-global-color-blue-600);--spectrum-alias-text-color-selected-neutral:var(
--spectrum-global-color-gray-900
);--spectrum-alias-text-color-overbackground:var(
--spectrum-global-color-static-white
);--spectrum-alias-text-color-overbackground-disabled:hsla(0,0%,100%,.2);--spectrum-alias-text-color-quiet-overbackground-disabled:hsla(0,0%,100%,.2);--spectrum-alias-heading-text-color:var(--spectrum-global-color-gray-900);--spectrum-alias-border-color:var(--spectrum-global-color-gray-400);--spectrum-alias-border-color-hover:var(--spectrum-global-color-gray-500);--spectrum-alias-border-color-down:var(--spectrum-global-color-gray-500);--spectrum-alias-border-color-key-focus:var(
--spectrum-global-color-blue-400
);--spectrum-alias-border-color-mouse-focus:var(
--spectrum-global-color-blue-500
);--spectrum-alias-border-color-disabled:var(
--spectrum-global-color-gray-200
);--spectrum-alias-border-color-extralight:var(
--spectrum-global-color-gray-100
);--spectrum-alias-border-color-light:var(--spectrum-global-color-gray-200);--spectrum-alias-border-color-mid:var(--spectrum-global-color-gray-300);--spectrum-alias-border-color-dark:var(--spectrum-global-color-gray-400);--spectrum-alias-border-color-darker-default:var(
--spectrum-global-color-gray-600
);--spectrum-alias-border-color-darker-hover:var(
--spectrum-global-color-gray-900
);--spectrum-alias-border-color-darker-down:var(
--spectrum-global-color-gray-900
);--spectrum-alias-border-color-transparent:transparent;--spectrum-alias-border-color-translucent-dark:rgba(0,0,0,.05);--spectrum-alias-border-color-translucent-darker:rgba(0,0,0,.1);--spectrum-alias-focus-color:var(--spectrum-global-color-blue-400);--spectrum-alias-focus-ring-color:var(--spectrum-alias-focus-color);--spectrum-alias-track-color-default:var(--spectrum-global-color-gray-300);--spectrum-alias-track-fill-color-overbackground:var(
--spectrum-global-color-static-white
);--spectrum-alias-track-color-disabled:var(
--spectrum-global-color-gray-300
);--spectrum-alias-thumbnail-darksquare-background-color:var(
--spectrum-global-color-gray-300
);--spectrum-alias-thumbnail-lightsquare-background-color:var(
--spectrum-global-color-static-white
);--spectrum-alias-track-color-overbackground:hsla(0,0%,100%,.2);--spectrum-alias-icon-color:var(--spectrum-global-color-gray-700);--spectrum-alias-icon-color-overbackground:var(
--spectrum-global-color-static-white
);--spectrum-alias-icon-color-hover:var(--spectrum-global-color-gray-900);--spectrum-alias-icon-color-down:var(--spectrum-global-color-gray-900);--spectrum-alias-icon-color-key-focus:var(
--spectrum-global-color-gray-900
);--spectrum-alias-icon-color-disabled:var(--spectrum-global-color-gray-400);--spectrum-alias-icon-color-overbackground-disabled:hsla(0,0%,100%,.2);--spectrum-alias-icon-color-quiet-overbackground-disabled:hsla(0,0%,100%,.15);--spectrum-alias-icon-color-selected-neutral:var(
--spectrum-global-color-gray-900
);--spectrum-alias-icon-color-selected-neutral-subdued:var(
--spectrum-global-color-gray-800
);--spectrum-alias-icon-color-selected:var(--spectrum-global-color-blue-500);--spectrum-alias-icon-color-selected-hover:var(
--spectrum-global-color-blue-600
);--spectrum-alias-icon-color-selected-down:var(
--spectrum-global-color-blue-700
);--spectrum-alias-icon-color-selected-focus:var(
--spectrum-global-color-blue-600
);--spectrum-alias-image-opacity-disabled:var(
--spectrum-global-color-opacity-30
);--spectrum-alias-toolbar-background-color:var(
--spectrum-global-color-gray-100
);--spectrum-alias-code-highlight-color-default:var(
--spectrum-global-color-gray-800
);--spectrum-alias-code-highlight-background-color:var(
--spectrum-global-color-gray-75
);--spectrum-alias-code-highlight-color-keyword:var(
--spectrum-global-color-fuchsia-600
);--spectrum-alias-code-highlight-color-section:var(
--spectrum-global-color-red-600
);--spectrum-alias-code-highlight-color-literal:var(
--spectrum-global-color-blue-600
);--spectrum-alias-code-highlight-color-attribute:var(
--spectrum-global-color-seafoam-600
);--spectrum-alias-code-highlight-color-class:var(
--spectrum-global-color-magenta-600
);--spectrum-alias-code-highlight-color-variable:var(
--spectrum-global-color-purple-600
);--spectrum-alias-code-highlight-color-title:var(
--spectrum-global-color-indigo-600
);--spectrum-alias-code-highlight-color-string:var(
--spectrum-global-color-fuchsia-600
);--spectrum-alias-code-highlight-color-function:var(
--spectrum-global-color-blue-600
);--spectrum-alias-code-highlight-color-comment:var(
--spectrum-global-color-gray-700
);--spectrum-alias-categorical-color-1:var(
--spectrum-global-color-static-seafoam-200
);--spectrum-alias-categorical-color-2:var(
--spectrum-global-color-static-indigo-700
);--spectrum-alias-categorical-color-3:var(
--spectrum-global-color-static-orange-500
);--spectrum-alias-categorical-color-4:var(
--spectrum-global-color-static-magenta-500
);--spectrum-alias-categorical-color-5:var(
--spectrum-global-color-static-indigo-200
);--spectrum-alias-categorical-color-6:var(
--spectrum-global-color-static-celery-200
);--spectrum-alias-categorical-color-7:var(
--spectrum-global-color-static-blue-500
);--spectrum-alias-categorical-color-8:var(
--spectrum-global-color-static-purple-800
);--spectrum-alias-categorical-color-9:var(
--spectrum-global-color-static-yellow-500
);--spectrum-alias-categorical-color-10:var(
--spectrum-global-color-static-orange-700
);--spectrum-alias-categorical-color-11:var(
--spectrum-global-color-static-green-600
);--spectrum-alias-categorical-color-12:var(
--spectrum-global-color-static-chartreuse-300
);--spectrum-alias-categorical-color-13:var(
--spectrum-global-color-static-blue-200
);--spectrum-alias-categorical-color-14:var(
--spectrum-global-color-static-fuchsia-500
);--spectrum-alias-categorical-color-15:var(
--spectrum-global-color-static-magenta-200
);--spectrum-alias-categorical-color-16:var(
--spectrum-global-color-static-yellow-200
)}:host,:root{--spectrum-colorloupe-express-visibility:none;--spectrum-colorloupe-spectrum-visibility:block;--spectrum-colorloupe-outer-border-color:transparent;--spectrum-colorloupe-outer-border-size:0;--spectrum-colorloupe-outer-stroke-color:var(
--spectrum-global-color-static-transparent-black-200
);--spectrum-colorloupe-outer-stroke-width:var(
--spectrum-alias-border-size-thick
);--spectrum-colorhandle-background-offset:calc(var(--spectrum-global-dimension-static-size-25)*-1);--spectrum-colorhandle-inner-shadow-color:var(
--spectrum-colorhandle-outer-shadow-color
);--spectrum-colorhandle-outer-shadow-color:rgba(0,0,0,.42);--spectrum-colorhandle-outer-shadow-blur:0;--spectrum-colorhandle-outer-shadow-spread:var(
--spectrum-alias-border-size-thin
);--spectrum-colorcontrol-checkerboard-light-color:var(
--spectrum-global-color-static-white
);--spectrum-colorcontrol-checkerboard-dark-color:var(
--spectrum-global-color-static-gray-300
);--spectrum-slider-m-track-inside-border-radius:var(
--spectrum-slider-m-track-border-radius
);--spectrum-slider-label-text-size:var(
--spectrum-global-dimension-font-size-75
)}:host,:root{-webkit-tap-highlight-color:rgba(0,0,0,0)}:host,:root{--spectrum-focus-indicator-color:var(--spectrum-blue-800);--spectrum-static-white-focus-indicator-color:var(--spectrum-white);--spectrum-static-black-focus-indicator-color:var(--spectrum-black);--spectrum-overlay-color:var(--spectrum-black);--spectrum-opacity-disabled:0.3;--spectrum-disabled-background-color:var(--spectrum-gray-200);--spectrum-disabled-static-white-background-color:var(
--spectrum-transparent-white-200
);--spectrum-disabled-static-black-background-color:var(
--spectrum-transparent-black-200
);--spectrum-background-opacity-default:0;--spectrum-background-opacity-hover:0.1;--spectrum-background-opacity-down:0.1;--spectrum-background-opacity-key-focus:0.1;--spectrum-neutral-content-color-default:var(--spectrum-gray-800);--spectrum-neutral-content-color-hover:var(--spectrum-gray-900);--spectrum-neutral-content-color-down:var(--spectrum-gray-900);--spectrum-neutral-content-color-focus-hover:var(
--spectrum-neutral-content-color-down
);--spectrum-neutral-content-color-focus:var(
--spectrum-neutral-content-color-down
);--spectrum-neutral-content-color-key-focus:var(--spectrum-gray-900);--spectrum-neutral-subdued-content-color-default:var(--spectrum-gray-700);--spectrum-neutral-subdued-content-color-hover:var(--spectrum-gray-800);--spectrum-neutral-subdued-content-color-down:var(--spectrum-gray-900);--spectrum-neutral-subdued-content-color-key-focus:var(
--spectrum-gray-800
);--spectrum-accent-content-color-default:var(--spectrum-accent-color-900);--spectrum-accent-content-color-hover:var(--spectrum-accent-color-1000);--spectrum-accent-content-color-down:var(--spectrum-accent-color-1100);--spectrum-accent-content-color-key-focus:var(
--spectrum-accent-color-1000
);--spectrum-negative-content-color-default:var(
--spectrum-negative-color-900
);--spectrum-negative-content-color-hover:var(
--spectrum-negative-color-1000
);--spectrum-negative-content-color-down:var(--spectrum-negative-color-1100);--spectrum-negative-content-color-key-focus:var(
--spectrum-negative-color-1000
);--spectrum-disabled-content-color:var(--spectrum-gray-400);--spectrum-disabled-static-white-content-color:var(
--spectrum-transparent-white-500
);--spectrum-disabled-static-black-content-color:var(
--spectrum-transparent-black-500
);--spectrum-disabled-border-color:var(--spectrum-gray-300);--spectrum-disabled-static-white-border-color:var(
--spectrum-transparent-white-300
);--spectrum-disabled-static-black-border-color:var(
--spectrum-transparent-black-300
);--spectrum-negative-border-color-default:var(
--spectrum-negative-color-900
);--spectrum-negative-border-color-hover:var(--spectrum-negative-color-1000);--spectrum-negative-border-color-down:var(--spectrum-negative-color-1100);--spectrum-negative-border-color-focus-hover:var(
--spectrum-negative-border-color-down
);--spectrum-negative-border-color-focus:var(--spectrum-negative-color-1000);--spectrum-negative-border-color-key-focus:var(
--spectrum-negative-color-1000
);--spectrum-swatch-border-color:var(--spectrum-gray-900);--spectrum-swatch-border-opacity:0.51;--spectrum-swatch-disabled-icon-border-color:var(--spectrum-black);--spectrum-swatch-disabled-icon-border-opacity:0.51;--spectrum-thumbnail-border-color:var(--spectrum-gray-800);--spectrum-thumbnail-border-opacity:0.1;--spectrum-thumbnail-opacity-disabled:var(--spectrum-opacity-disabled);--spectrum-opacity-checkerboard-square-light:var(--spectrum-white);--spectrum-avatar-opacity-disabled:var(--spectrum-opacity-disabled);--spectrum-color-area-border-color:var(--spectrum-gray-900);--spectrum-color-area-border-opacity:0.1;--spectrum-color-slider-border-color:var(--spectrum-gray-900);--spectrum-color-slider-border-opacity:0.1;--spectrum-color-loupe-drop-shadow-color:var(
--spectrum-transparent-black-300
);--spectrum-color-loupe-drop-shadow-y:2px;--spectrum-color-loupe-drop-shadow-blur:8px;--spectrum-color-loupe-inner-border:var(--spectrum-transparent-black-200);--spectrum-color-loupe-outer-border:var(--spectrum-white);--spectrum-card-selection-background-color:var(--spectrum-gray-100);--spectrum-card-selection-background-color-opacity:0.95;--spectrum-drop-zone-background-color:var(--spectrum-accent-visual-color);--spectrum-drop-zone-background-color-opacity:0.1;--spectrum-drop-zone-background-color-opacity-filled:0.3;--spectrum-coach-mark-pagination-color:var(--spectrum-gray-600);--spectrum-color-handle-inner-border-color:var(--spectrum-black);--spectrum-white:#fff;--spectrum-transparent-white-100:hsla(0,0%,100%,0);--spectrum-transparent-white-200:hsla(0,0%,100%,.1);--spectrum-transparent-white-300:hsla(0,0%,100%,.25);--spectrum-transparent-white-400:hsla(0,0%,100%,.4);--spectrum-transparent-white-500:hsla(0,0%,100%,.55);--spectrum-transparent-white-600:hsla(0,0%,100%,.7);--spectrum-transparent-white-700:hsla(0,0%,100%,.8);--spectrum-transparent-white-800:hsla(0,0%,100%,.9);--spectrum-transparent-white-900:#fff;--spectrum-black:#000;--spectrum-transparent-black-100:transparent;--spectrum-transparent-black-200:rgba(0,0,0,.1);--spectrum-transparent-black-300:rgba(0,0,0,.25);--spectrum-transparent-black-400:rgba(0,0,0,.4);--spectrum-transparent-black-500:rgba(0,0,0,.55);--spectrum-transparent-black-600:rgba(0,0,0,.7);--spectrum-transparent-black-700:rgba(0,0,0,.8);--spectrum-transparent-black-800:rgba(0,0,0,.9);--spectrum-transparent-black-900:#000;--spectrum-radio-button-selection-indicator:4px;--spectrum-field-label-to-component:0px;--spectrum-help-text-to-component:0px;--spectrum-button-minimum-width-multiplier:2.25;--spectrum-divider-thickness-small:1px;--spectrum-divider-thickness-medium:2px;--spectrum-divider-thickness-large:4px;--spectrum-swatch-rectangle-width-multiplier:2;--spectrum-swatch-slash-thickness-extra-small:2px;--spectrum-swatch-slash-thickness-small:3px;--spectrum-swatch-slash-thickness-medium:4px;--spectrum-swatch-slash-thickness-large:5px;--spectrum-progress-bar-minimum-width:48px;--spectrum-progress-bar-maximum-width:768px;--spectrum-meter-minimum-width:48px;--spectrum-meter-maximum-width:768px;--spectrum-in-line-alert-minimum-width:240px;--spectrum-popover-tip-width:16px;--spectrum-popover-tip-height:8px;--spectrum-menu-item-label-to-description:1px;--spectrum-picker-minimum-width-multiplier:2;--spectrum-text-field-minimum-width-multiplier:1.5;--spectrum-combo-box-minimum-width-multiplier:2.5;--spectrum-combo-box-quiet-minimum-width-multiplier:2;--spectrum-combo-box-visual-to-field-button-quiet:0px;--spectrum-alert-dialog-minimum-width:288px;--spectrum-alert-dialog-maximum-width:480px;--spectrum-contextual-help-minimum-width:268px;--spectrum-breadcrumbs-height:var(--spectrum-component-height-300);--spectrum-breadcrumbs-height-compact:var(--spectrum-component-height-200);--spectrum-breadcrumbs-end-edge-to-text:0px;--spectrum-breadcrumbs-truncated-menu-to-separator-icon:0px;--spectrum-breadcrumbs-start-edge-to-truncated-menu:0px;--spectrum-breadcrumbs-truncated-menu-to-bottom-text:0px;--spectrum-color-area-border-width:var(--spectrum-border-width-100);--spectrum-color-area-border-rounding:var(--spectrum-corner-radius-100);--spectrum-color-wheel-color-area-margin:12px;--spectrum-color-slider-border-width:1px;--spectrum-color-slider-border-rounding:4px;--spectrum-floating-action-button-drop-shadow-blur:12px;--spectrum-illustrated-message-maximum-width:380px;--spectrum-search-field-minimum-width-multiplier:3;--spectrum-color-loupe-outer-border-width:var(--spectrum-border-width-200);--spectrum-card-minimum-width:100px;--spectrum-card-preview-minimum-height:130px;--spectrum-card-selection-background-size:40px;--spectrum-drop-zone-width:428px;--spectrum-drop-zone-content-maximum-width:var(
--spectrum-illustrated-message-maximum-width
);--spectrum-drop-zone-border-dash-length:8px;--spectrum-drop-zone-border-dash-gap:4px;--spectrum-drop-zone-title-size:var(
--spectrum-illustrated-message-title-size
);--spectrum-drop-zone-cjk-title-size:var(
--spectrum-illustrated-message-cjk-title-size
);--spectrum-drop-zone-body-size:var(
--spectrum-illustrated-message-body-size
);--spectrum-color-handle-border-width:var(--spectrum-border-width-200);--spectrum-color-handle-inner-border-width:1px;--spectrum-android-elevation:2dp;--spectrum-spacing-50:2px;--spectrum-spacing-75:4px;--spectrum-spacing-100:8px;--spectrum-spacing-200:12px;--spectrum-spacing-300:16px;--spectrum-spacing-400:24px;--spectrum-spacing-500:32px;--spectrum-spacing-600:40px;--spectrum-spacing-700:48px;--spectrum-spacing-800:64px;--spectrum-spacing-900:80px;--spectrum-spacing-1000:96px;--spectrum-focus-indicator-thickness:2px;--spectrum-focus-indicator-gap:2px;--spectrum-border-width-200:2px;--spectrum-border-width-400:4px;--spectrum-field-edge-to-text-quiet:0px;--spectrum-field-edge-to-visual-quiet:0px;--spectrum-field-edge-to-border-quiet:0px;--spectrum-field-edge-to-alert-icon-quiet:0px;--spectrum-field-edge-to-validation-icon-quiet:0px;--spectrum-text-underline-thickness:1px;--spectrum-text-underline-gap:1px;--spectrum-informative-color-100:var(--spectrum-blue-100);--spectrum-informative-color-200:var(--spectrum-blue-200);--spectrum-informative-color-300:var(--spectrum-blue-300);--spectrum-informative-color-400:var(--spectrum-blue-400);--spectrum-informative-color-500:var(--spectrum-blue-500);--spectrum-informative-color-600:var(--spectrum-blue-600);--spectrum-informative-color-700:var(--spectrum-blue-700);--spectrum-informative-color-800:var(--spectrum-blue-800);--spectrum-informative-color-900:var(--spectrum-blue-900);--spectrum-informative-color-1000:var(--spectrum-blue-1000);--spectrum-informative-color-1100:var(--spectrum-blue-1100);--spectrum-informative-color-1200:var(--spectrum-blue-1200);--spectrum-informative-color-1300:var(--spectrum-blue-1300);--spectrum-informative-color-1400:var(--spectrum-blue-1400);--spectrum-negative-color-100:var(--spectrum-red-100);--spectrum-negative-color-200:var(--spectrum-red-200);--spectrum-negative-color-300:var(--spectrum-red-300);--spectrum-negative-color-400:var(--spectrum-red-400);--spectrum-negative-color-500:var(--spectrum-red-500);--spectrum-negative-color-600:var(--spectrum-red-600);--spectrum-negative-color-700:var(--spectrum-red-700);--spectrum-negative-color-800:var(--spectrum-red-800);--spectrum-negative-color-900:var(--spectrum-red-900);--spectrum-negative-color-1000:var(--spectrum-red-1000);--spectrum-negative-color-1100:var(--spectrum-red-1100);--spectrum-negative-color-1200:var(--spectrum-red-1200);--spectrum-negative-color-1300:var(--spectrum-red-1300);--spectrum-negative-color-1400:var(--spectrum-red-1400);--spectrum-notice-color-100:var(--spectrum-orange-100);--spectrum-notice-color-200:var(--spectrum-orange-200);--spectrum-notice-color-300:var(--spectrum-orange-300);--spectrum-notice-color-400:var(--spectrum-orange-400);--spectrum-notice-color-500:var(--spectrum-orange-500);--spectrum-notice-color-600:var(--spectrum-orange-600);--spectrum-notice-color-700:var(--spectrum-orange-700);--spectrum-notice-color-800:var(--spectrum-orange-800);--spectrum-notice-color-900:var(--spectrum-orange-900);--spectrum-notice-color-1000:var(--spectrum-orange-1000);--spectrum-notice-color-1100:var(--spectrum-orange-1100);--spectrum-notice-color-1200:var(--spectrum-orange-1200);--spectrum-notice-color-1300:var(--spectrum-orange-1300);--spectrum-notice-color-1400:var(--spectrum-orange-1400);--spectrum-positive-color-100:var(--spectrum-green-100);--spectrum-positive-color-200:var(--spectrum-green-200);--spectrum-positive-color-300:var(--spectrum-green-300);--spectrum-positive-color-400:var(--spectrum-green-400);--spectrum-positive-color-500:var(--spectrum-green-500);--spectrum-positive-color-600:var(--spectrum-green-600);--spectrum-positive-color-700:var(--spectrum-green-700);--spectrum-positive-color-800:var(--spectrum-green-800);--spectrum-positive-color-900:var(--spectrum-green-900);--spectrum-positive-color-1000:var(--spectrum-green-1000);--spectrum-positive-color-1100:var(--spectrum-green-1100);--spectrum-positive-color-1200:var(--spectrum-green-1200);--spectrum-positive-color-1300:var(--spectrum-green-1300);--spectrum-positive-color-1400:var(--spectrum-green-1400);--spectrum-default-font-family:var(--spectrum-sans-serif-font-family);--spectrum-sans-serif-font-family:Adobe Clean;--spectrum-serif-font-family:Adobe Clean Serif;--spectrum-cjk-font-family:Adobe Clean Han;--spectrum-light-font-weight:light;--spectrum-regular-font-weight:regular;--spectrum-medium-font-weight:medium;--spectrum-bold-font-weight:bold;--spectrum-extra-bold-font-weight:extra-bold;--spectrum-black-font-weight:#000;--spectrum-italic-font-style:italic;--spectrum-default-font-style:normal;--spectrum-line-height-100:1.3;--spectrum-line-height-200:1.5;--spectrum-cjk-line-height-100:1.5;--spectrum-cjk-line-height-200:1.7;--spectrum-cjk-letter-spacing:0.05em;--spectrum-heading-sans-serif-font-family:var(
--spectrum-sans-serif-font-family
);--spectrum-heading-serif-font-family:var(--spectrum-serif-font-family);--spectrum-heading-cjk-font-family:var(--spectrum-cjk-font-family);--spectrum-heading-sans-serif-light-font-weight:var(
--spectrum-light-font-weight
);--spectrum-heading-sans-serif-light-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-light-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-heading-serif-light-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-cjk-light-font-weight:var(--spectrum-light-font-weight);--spectrum-heading-cjk-light-font-style:var(--spectrum-default-font-style);--spectrum-heading-sans-serif-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-font-style:var(--spectrum-default-font-style);--spectrum-heading-cjk-font-style:var(--spectrum-default-font-style);--spectrum-heading-sans-serif-heavy-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-heavy-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-heavy-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-heavy-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-cjk-heavy-font-weight:var(--spectrum-black-font-weight);--spectrum-heading-cjk-heavy-font-style:var(--spectrum-default-font-style);--spectrum-heading-sans-serif-light-strong-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-heading-sans-serif-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-light-strong-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-heading-serif-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-cjk-light-strong-font-weight:var(
--spectrum-extra-bold-font-weight
);--spectrum-heading-cjk-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-cjk-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-heavy-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-heavy-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-serif-heavy-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-heavy-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-cjk-heavy-strong-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-heavy-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-light-emphasized-font-weight:var(
--spectrum-light-font-weight
);--spectrum-heading-sans-serif-light-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-light-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-heading-serif-light-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-light-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-heading-cjk-light-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-heavy-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-heavy-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-heavy-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-heavy-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-heavy-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-heavy-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-light-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-heading-sans-serif-light-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-light-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-heading-serif-light-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-light-strong-emphasized-font-weight:var(
--spectrum-extra-bold-font-weight
);--spectrum-heading-cjk-light-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-sans-serif-heavy-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-sans-serif-heavy-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-serif-heavy-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-serif-heavy-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-heading-cjk-heavy-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-heading-cjk-heavy-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-heading-size-xxxl:var(--spectrum-font-size-1300);--spectrum-heading-size-xxl:var(--spectrum-font-size-1100);--spectrum-heading-size-xl:var(--spectrum-font-size-900);--spectrum-heading-size-l:var(--spectrum-font-size-700);--spectrum-heading-size-m:var(--spectrum-font-size-500);--spectrum-heading-size-s:var(--spectrum-font-size-300);--spectrum-heading-size-xs:var(--spectrum-font-size-200);--spectrum-heading-size-xxs:var(--spectrum-font-size-100);--spectrum-heading-cjk-size-xxxl:var(--spectrum-font-size-1300);--spectrum-heading-cjk-size-xxl:var(--spectrum-font-size-900);--spectrum-heading-cjk-size-xl:var(--spectrum-font-size-800);--spectrum-heading-cjk-size-l:var(--spectrum-font-size-600);--spectrum-heading-cjk-size-m:var(--spectrum-font-size-400);--spectrum-heading-cjk-size-s:var(--spectrum-font-size-300);--spectrum-heading-cjk-size-xs:var(--spectrum-font-size-200);--spectrum-heading-cjk-size-xxs:var(--spectrum-font-size-100);--spectrum-heading-line-height:var(--spectrum-line-height-100);--spectrum-heading-cjk-line-height:var(--spectrum-cjk-line-height-100);--spectrum-heading-margin-top-multiplier:0.88888889;--spectrum-heading-margin-bottom-multiplier:0.25;--spectrum-heading-color:var(--spectrum-gray-900);--spectrum-body-sans-serif-font-family:var(
--spectrum-sans-serif-font-family
);--spectrum-body-serif-font-family:var(--spectrum-serif-font-family);--spectrum-body-cjk-font-family:var(--spectrum-cjk-font-family);--spectrum-body-sans-serif-font-weight:var(--spectrum-regular-font-weight);--spectrum-body-sans-serif-font-style:var(--spectrum-default-font-style);--spectrum-body-serif-font-weight:var(--spectrum-regular-font-weight);--spectrum-body-serif-font-style:var(--spectrum-default-font-style);--spectrum-body-cjk-font-weight:var(--spectrum-regular-font-weight);--spectrum-body-cjk-font-style:var(--spectrum-default-font-style);--spectrum-body-sans-serif-strong-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-body-sans-serif-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-body-serif-strong-font-weight:var(--spectrum-bold-font-weight);--spectrum-body-serif-strong-font-style:var(--spectrum-default-font-style);--spectrum-body-cjk-strong-font-weight:var(--spectrum-black-font-weight);--spectrum-body-cjk-strong-font-style:var(--spectrum-default-font-style);--spectrum-body-sans-serif-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-body-sans-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-body-serif-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-body-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-body-cjk-emphasized-font-weight:var(
--spectrum-extra-bold-font-weight
);--spectrum-body-cjk-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-body-sans-serif-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-body-sans-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-body-serif-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-body-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-body-cjk-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-body-cjk-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-body-size-xxxl:var(--spectrum-font-size-600);--spectrum-body-size-xxl:var(--spectrum-font-size-500);--spectrum-body-size-xl:var(--spectrum-font-size-400);--spectrum-body-size-l:var(--spectrum-font-size-300);--spectrum-body-size-m:var(--spectrum-font-size-200);--spectrum-body-size-s:var(--spectrum-font-size-100);--spectrum-body-size-xs:var(--spectrum-font-size-75);--spectrum-body-line-height:var(--spectrum-line-height-200);--spectrum-body-cjk-line-height:var(--spectrum-cjk-line-height-200);--spectrum-body-margin-multiplier:0.75;--spectrum-body-color:var(--spectrum-gray-800);--spectrum-detail-sans-serif-font-family:var(
--spectrum-sans-serif-font-family
);--spectrum-detail-serif-font-family:var(--spectrum-serif-font-family);--spectrum-detail-cjk-font-family:var(--spectrum-cjk-font-family);--spectrum-detail-sans-serif-font-weight:var(--spectrum-bold-font-weight);--spectrum-detail-sans-serif-font-style:var(--spectrum-default-font-style);--spectrum-detail-serif-font-weight:var(--spectrum-bold-font-weight);--spectrum-detail-serif-font-style:var(--spectrum-default-font-style);--spectrum-detail-cjk-font-weight:var(--spectrum-extra-bold-font-weight);--spectrum-detail-cjk-font-style:var(--spectrum-default-font-style);--spectrum-detail-sans-serif-light-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-sans-serif-light-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-serif-light-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-serif-light-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-cjk-light-font-weight:var(--spectrum-light-font-weight);--spectrum-detail-cjk-light-font-style:var(--spectrum-default-font-style);--spectrum-detail-sans-serif-strong-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-sans-serif-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-serif-strong-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-serif-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-cjk-strong-font-weight:var(--spectrum-black-font-weight);--spectrum-detail-cjk-strong-font-style:var(--spectrum-default-font-style);--spectrum-detail-sans-serif-light-strong-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-sans-serif-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-serif-light-strong-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-serif-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-cjk-light-strong-font-weight:var(
--spectrum-extra-bold-font-weight
);--spectrum-detail-cjk-light-strong-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-sans-serif-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-sans-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-serif-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-serif-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-cjk-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-detail-cjk-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-sans-serif-light-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-sans-serif-light-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-serif-light-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-serif-light-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-cjk-light-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-cjk-light-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-sans-serif-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-sans-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-serif-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-detail-serif-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-cjk-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-detail-cjk-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-sans-serif-light-strong-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-sans-serif-light-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-serif-light-strong-emphasized-font-weight:var(
--spectrum-regular-font-weight
);--spectrum-detail-serif-light-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-detail-cjk-light-strong-emphasized-font-weight:var(
--spectrum-extra-bold-font-weight
);--spectrum-detail-cjk-light-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-detail-size-xl:var(--spectrum-font-size-200);--spectrum-detail-size-l:var(--spectrum-font-size-100);--spectrum-detail-size-m:var(--spectrum-font-size-75);--spectrum-detail-size-s:var(--spectrum-font-size-50);--spectrum-detail-line-height:var(--spectrum-line-height-100);--spectrum-detail-cjk-line-height:var(--spectrum-cjk-line-height-100);--spectrum-detail-margin-top-multiplier:0.88888889;--spectrum-detail-margin-bottom-multiplier:0.25;--spectrum-detail-letter-spacing:0.06em;--spectrum-detail-sans-serif-text-transform:uppercase;--spectrum-detail-serif-text-transform:uppercase;--spectrum-detail-color:var(--spectrum-gray-900);--spectrum-code-font-family:Source Code Pro;--spectrum-code-cjk-font-family:var(--spectrum-code-font-family);--spectrum-code-font-weight:var(--spectrum-regular-font-weight);--spectrum-code-font-style:var(--spectrum-default-font-style);--spectrum-code-cjk-font-weight:var(--spectrum-regular-font-weight);--spectrum-code-cjk-font-style:var(--spectrum-default-font-style);--spectrum-code-strong-font-weight:var(--spectrum-bold-font-weight);--spectrum-code-strong-font-style:var(--spectrum-default-font-style);--spectrum-code-cjk-strong-font-weight:var(--spectrum-black-font-weight);--spectrum-code-cjk-strong-font-style:var(--spectrum-default-font-style);--spectrum-code-emphasized-font-weight:var(--spectrum-regular-font-weight);--spectrum-code-emphasized-font-style:var(--spectrum-italic-font-style);--spectrum-code-cjk-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-code-cjk-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-code-strong-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-code-strong-emphasized-font-style:var(
--spectrum-italic-font-style
);--spectrum-code-cjk-strong-emphasized-font-weight:var(
--spectrum-black-font-weight
);--spectrum-code-cjk-strong-emphasized-font-style:var(
--spectrum-default-font-style
);--spectrum-code-size-xl:var(--spectrum-font-size-400);--spectrum-code-size-l:var(--spectrum-font-size-300);--spectrum-code-size-m:var(--spectrum-font-size-200);--spectrum-code-size-s:var(--spectrum-font-size-100);--spectrum-code-size-xs:var(--spectrum-font-size-75);--spectrum-code-line-height:var(--spectrum-line-height-200);--spectrum-code-cjk-line-height:var(--spectrum-cjk-line-height-200);--spectrum-code-color:var(--spectrum-gray-800)}:host,:root{--spectrum-neutral-background-color-selected-default:var(
--spectrum-gray-700
);--spectrum-neutral-background-color-selected-hover:var(
--spectrum-gray-800
);--spectrum-neutral-background-color-selected-down:var(--spectrum-gray-900);--spectrum-neutral-background-color-selected-key-focus:var(
--spectrum-gray-800
);--spectrum-color-handle-inner-border-opacity:0.42;--spectrum-color-handle-outer-border-color:var(--spectrum-black);--spectrum-color-handle-outer-border-opacity:var(
--spectrum-color-handle-inner-border-opacity
);--spectrum-slider-track-thickness:2px;--spectrum-slider-handle-gap:4px;--spectrum-picker-border-width:var(--spectrum-border-width-100);--spectrum-color-loupe-height:64px;--spectrum-color-loupe-width:48px;--spectrum-color-loupe-bottom-to-color-handle:12px;--spectrum-color-loupe-inner-border-width:var(--spectrum-border-width-200);--spectrum-color-handle-outer-border-width:1px;--spectrum-color-handle-drop-shadow-x:0;--spectrum-color-handle-drop-shadow-y:0;--spectrum-color-handle-drop-shadow-blur:0;--spectrum-border-width-100:1px;--spectrum-accent-color-100:var(--spectrum-blue-100);--spectrum-accent-color-200:var(--spectrum-blue-200);--spectrum-accent-color-300:var(--spectrum-blue-300);--spectrum-accent-color-400:var(--spectrum-blue-400);--spectrum-accent-color-500:var(--spectrum-blue-500);--spectrum-accent-color-600:var(--spectrum-blue-600);--spectrum-accent-color-700:var(--spectrum-blue-700);--spectrum-accent-color-800:var(--spectrum-blue-800);--spectrum-accent-color-900:var(--spectrum-blue-900);--spectrum-accent-color-1000:var(--spectrum-blue-1000);--spectrum-accent-color-1100:var(--spectrum-blue-1100);--spectrum-accent-color-1200:var(--spectrum-blue-1200);--spectrum-accent-color-1300:var(--spectrum-blue-1300);--spectrum-accent-color-1400:var(--spectrum-blue-1400);--spectrum-heading-sans-serif-font-weight:var(--spectrum-bold-font-weight);--spectrum-heading-serif-font-weight:var(--spectrum-bold-font-weight);--spectrum-heading-cjk-font-weight:var(--spectrum-extra-bold-font-weight);--spectrum-heading-sans-serif-emphasized-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-heading-serif-emphasized-font-weight:var(
--spectrum-bold-font-weight
)}:host,:root{--system-spectrum-actionbutton-background-color-default:var(
--spectrum-gray-75
);--system-spectrum-actionbutton-background-color-hover:var(
--spectrum-gray-200
);--system-spectrum-actionbutton-background-color-down:var(
--spectrum-gray-300
);--system-spectrum-actionbutton-background-color-focus:var(
--spectrum-gray-200
);--system-spectrum-actionbutton-border-color-default:var(
--spectrum-gray-400
);--system-spectrum-actionbutton-border-color-hover:var(--spectrum-gray-500);--system-spectrum-actionbutton-border-color-down:var(--spectrum-gray-600);--system-spectrum-actionbutton-border-color-focus:var(--spectrum-gray-500);--system-spectrum-actionbutton-content-color-default:var(
--spectrum-neutral-content-color-default
);--system-spectrum-actionbutton-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--system-spectrum-actionbutton-content-color-down:var(
--spectrum-neutral-content-color-down
);--system-spectrum-actionbutton-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--system-spectrum-actionbutton-background-color-disabled:transparent;--system-spectrum-actionbutton-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-actionbutton-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-actionbutton-quiet-background-color-default:transparent;--system-spectrum-actionbutton-quiet-background-color-hover:var(
--spectrum-gray-200
);--system-spectrum-actionbutton-quiet-background-color-down:var(
--spectrum-gray-300
);--system-spectrum-actionbutton-quiet-background-color-focus:var(
--spectrum-gray-200
);--system-spectrum-actionbutton-quiet-border-color-default:transparent;--system-spectrum-actionbutton-quiet-border-color-hover:transparent;--system-spectrum-actionbutton-quiet-border-color-down:transparent;--system-spectrum-actionbutton-quiet-border-color-focus:transparent;--system-spectrum-actionbutton-quiet-background-color-disabled:transparent;--system-spectrum-actionbutton-quiet-border-color-disabled:transparent;--system-spectrum-actionbutton-selected-background-color-default:var(
--spectrum-neutral-subdued-background-color-default
);--system-spectrum-actionbutton-selected-background-color-hover:var(
--spectrum-neutral-subdued-background-color-hover
);--system-spectrum-actionbutton-selected-background-color-down:var(
--spectrum-neutral-subdued-background-color-down
);--system-spectrum-actionbutton-selected-background-color-focus:var(
--spectrum-neutral-subdued-background-color-key-focus
);--system-spectrum-actionbutton-selected-border-color-default:transparent;--system-spectrum-actionbutton-selected-border-color-hover:transparent;--system-spectrum-actionbutton-selected-border-color-down:transparent;--system-spectrum-actionbutton-selected-border-color-focus:transparent;--system-spectrum-actionbutton-selected-content-color-default:var(
--spectrum-white
);--system-spectrum-actionbutton-selected-content-color-hover:var(
--spectrum-white
);--system-spectrum-actionbutton-selected-content-color-down:var(
--spectrum-white
);--system-spectrum-actionbutton-selected-content-color-focus:var(
--spectrum-white
);--system-spectrum-actionbutton-selected-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-actionbutton-selected-border-color-disabled:transparent;--system-spectrum-actionbutton-selected-emphasized-background-color-default:var(
--spectrum-accent-background-color-default
);--system-spectrum-actionbutton-selected-emphasized-background-color-hover:var(
--spectrum-accent-background-color-hover
);--system-spectrum-actionbutton-selected-emphasized-background-color-down:var(
--spectrum-accent-background-color-down
);--system-spectrum-actionbutton-selected-emphasized-background-color-focus:var(
--spectrum-accent-background-color-key-focus
);--system-spectrum-actionbutton-staticblack-quiet-border-color-default:transparent;--system-spectrum-actionbutton-staticwhite-quiet-border-color-default:transparent;--system-spectrum-actionbutton-staticblack-quiet-border-color-hover:transparent;--system-spectrum-actionbutton-staticwhite-quiet-border-color-hover:transparent;--system-spectrum-actionbutton-staticblack-quiet-border-color-down:transparent;--system-spectrum-actionbutton-staticwhite-quiet-border-color-down:transparent;--system-spectrum-actionbutton-staticblack-quiet-border-color-focus:transparent;--system-spectrum-actionbutton-staticwhite-quiet-border-color-focus:transparent;--system-spectrum-actionbutton-staticblack-quiet-border-color-disabled:transparent;--system-spectrum-actionbutton-staticwhite-quiet-border-color-disabled:transparent;--system-spectrum-actionbutton-staticblack-background-color-default:transparent;--system-spectrum-actionbutton-staticblack-background-color-hover:var(
--spectrum-transparent-black-300
);--system-spectrum-actionbutton-staticblack-background-color-down:var(
--spectrum-transparent-black-400
);--system-spectrum-actionbutton-staticblack-background-color-focus:var(
--spectrum-transparent-black-300
);--system-spectrum-actionbutton-staticblack-border-color-default:var(
--spectrum-transparent-black-400
);--system-spectrum-actionbutton-staticblack-border-color-hover:var(
--spectrum-transparent-black-500
);--system-spectrum-actionbutton-staticblack-border-color-down:var(
--spectrum-transparent-black-600
);--system-spectrum-actionbutton-staticblack-border-color-focus:var(
--spectrum-transparent-black-500
);--system-spectrum-actionbutton-staticblack-content-color-default:var(
--spectrum-black
);--system-spectrum-actionbutton-staticblack-content-color-hover:var(
--spectrum-black
);--system-spectrum-actionbutton-staticblack-content-color-down:var(
--spectrum-black
);--system-spectrum-actionbutton-staticblack-content-color-focus:var(
--spectrum-black
);--system-spectrum-actionbutton-staticblack-focus-indicator-color:var(
--spectrum-static-black-focus-indicator-color
);--system-spectrum-actionbutton-staticblack-background-color-disabled:transparent;--system-spectrum-actionbutton-staticblack-border-color-disabled:var(
--spectrum-disabled-static-black-border-color
);--system-spectrum-actionbutton-staticblack-content-color-disabled:var(
--spectrum-disabled-static-black-content-color
);--system-spectrum-actionbutton-staticblack-selected-background-color-default:var(
--spectrum-transparent-black-800
);--system-spectrum-actionbutton-staticblack-selected-background-color-hover:var(
--spectrum-transparent-black-900
);--system-spectrum-actionbutton-staticblack-selected-background-color-down:var(
--spectrum-transparent-black-900
);--system-spectrum-actionbutton-staticblack-selected-background-color-focus:var(
--spectrum-transparent-black-900
);--system-spectrum-actionbutton-staticblack-selected-border-color-disabled:transparent;--system-spectrum-actionbutton-staticblack-selected-content-color-default:var(
--spectrum-white
);--system-spectrum-actionbutton-staticblack-selected-content-color-hover:var(
--spectrum-white
);--system-spectrum-actionbutton-staticblack-selected-content-color-down:var(
--spectrum-white
);--system-spectrum-actionbutton-staticblack-selected-content-color-focus:var(
--spectrum-white
);--system-spectrum-actionbutton-staticblack-selected-background-color-disabled:var(
--spectrum-disabled-static-black-background-color
);--system-spectrum-actionbutton-staticwhite-background-color-default:transparent;--system-spectrum-actionbutton-staticwhite-background-color-hover:var(
--spectrum-transparent-white-300
);--system-spectrum-actionbutton-staticwhite-background-color-down:var(
--spectrum-transparent-white-400
);--system-spectrum-actionbutton-staticwhite-background-color-focus:var(
--spectrum-transparent-white-300
);--system-spectrum-actionbutton-staticwhite-border-color-default:var(
--spectrum-transparent-white-400
);--system-spectrum-actionbutton-staticwhite-border-color-hover:var(
--spectrum-transparent-white-500
);--system-spectrum-actionbutton-staticwhite-border-color-down:var(
--spectrum-transparent-white-600
);--system-spectrum-actionbutton-staticwhite-border-color-focus:var(
--spectrum-transparent-white-500
);--system-spectrum-actionbutton-staticwhite-content-color-default:var(
--spectrum-white
);--system-spectrum-actionbutton-staticwhite-content-color-hover:var(
--spectrum-white
);--system-spectrum-actionbutton-staticwhite-content-color-down:var(
--spectrum-white
);--system-spectrum-actionbutton-staticwhite-content-color-focus:var(
--spectrum-white
);--system-spectrum-actionbutton-staticwhite-focus-indicator-color:var(
--spectrum-static-white-focus-indicator-color
);--system-spectrum-actionbutton-staticwhite-background-color-disabled:transparent;--system-spectrum-actionbutton-staticwhite-border-color-disabled:var(
--spectrum-disabled-static-white-border-color
);--system-spectrum-actionbutton-staticwhite-content-color-disabled:var(
--spectrum-disabled-static-white-content-color
);--system-spectrum-actionbutton-staticwhite-selected-background-color-default:var(
--spectrum-transparent-white-800
);--system-spectrum-actionbutton-staticwhite-selected-background-color-hover:var(
--spectrum-transparent-white-900
);--system-spectrum-actionbutton-staticwhite-selected-background-color-down:var(
--spectrum-transparent-white-900
);--system-spectrum-actionbutton-staticwhite-selected-background-color-focus:var(
--spectrum-transparent-white-900
);--system-spectrum-actionbutton-staticwhite-selected-content-color-default:var(
--spectrum-black
);--system-spectrum-actionbutton-staticwhite-selected-content-color-hover:var(
--spectrum-black
);--system-spectrum-actionbutton-staticwhite-selected-content-color-down:var(
--spectrum-black
);--system-spectrum-actionbutton-staticwhite-selected-content-color-focus:var(
--spectrum-black
);--system-spectrum-actionbutton-staticwhite-selected-background-color-disabled:var(
--spectrum-disabled-static-white-background-color
);--system-spectrum-actionbutton-staticwhite-selected-border-color-disabled:transparent}:host,:root{--system-spectrum-checkbox-control-color-default:var(--spectrum-gray-600);--system-spectrum-checkbox-control-color-hover:var(--spectrum-gray-700);--system-spectrum-checkbox-control-color-down:var(--spectrum-gray-800);--system-spectrum-checkbox-control-color-focus:var(--spectrum-gray-700);--system-spectrum-checkbox-control-selected-color-default:var(
--spectrum-gray-700
);--system-spectrum-checkbox-control-selected-color-hover:var(
--spectrum-gray-800
);--system-spectrum-checkbox-control-selected-color-down:var(
--spectrum-gray-900
)}:host,:root{--system-spectrum-button-background-color-default:var(--spectrum-gray-75);--system-spectrum-button-background-color-hover:var(--spectrum-gray-200);--system-spectrum-button-background-color-down:var(--spectrum-gray-300);--system-spectrum-button-background-color-focus:var(--spectrum-gray-200);--system-spectrum-button-border-color-default:var(--spectrum-gray-400);--system-spectrum-button-border-color-hover:var(--spectrum-gray-500);--system-spectrum-button-border-color-down:var(--spectrum-gray-600);--system-spectrum-button-border-color-focus:var(--spectrum-gray-500);--system-spectrum-button-content-color-default:var(
--spectrum-neutral-content-color-default
);--system-spectrum-button-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--system-spectrum-button-content-color-down:var(
--spectrum-neutral-content-color-down
);--system-spectrum-button-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--system-spectrum-button-background-color-disabled:transparent;--system-spectrum-button-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-button-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-accent-background-color-default:var(
--spectrum-accent-background-color-default
);--system-spectrum-button-accent-background-color-hover:var(
--spectrum-accent-background-color-hover
);--system-spectrum-button-accent-background-color-down:var(
--spectrum-accent-background-color-down
);--system-spectrum-button-accent-background-color-focus:var(
--spectrum-accent-background-color-key-focus
);--system-spectrum-button-accent-border-color-default:transparent;--system-spectrum-button-accent-border-color-hover:transparent;--system-spectrum-button-accent-border-color-down:transparent;--system-spectrum-button-accent-border-color-focus:transparent;--system-spectrum-button-accent-content-color-default:var(
--spectrum-white
);--system-spectrum-button-accent-content-color-hover:var(--spectrum-white);--system-spectrum-button-accent-content-color-down:var(--spectrum-white);--system-spectrum-button-accent-content-color-focus:var(--spectrum-white);--system-spectrum-button-accent-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-button-accent-border-color-disabled:transparent;--system-spectrum-button-accent-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-accent-outline-background-color-default:transparent;--system-spectrum-button-accent-outline-background-color-hover:var(
--spectrum-accent-color-200
);--system-spectrum-button-accent-outline-background-color-down:var(
--spectrum-accent-color-300
);--system-spectrum-button-accent-outline-background-color-focus:var(
--spectrum-accent-color-200
);--system-spectrum-button-accent-outline-border-color-default:var(
--spectrum-accent-color-900
);--system-spectrum-button-accent-outline-border-color-hover:var(
--spectrum-accent-color-1000
);--system-spectrum-button-accent-outline-border-color-down:var(
--spectrum-accent-color-1100
);--system-spectrum-button-accent-outline-border-color-focus:var(
--spectrum-accent-color-1000
);--system-spectrum-button-accent-outline-content-color-default:var(
--spectrum-accent-content-color-default
);--system-spectrum-button-accent-outline-content-color-hover:var(
--spectrum-accent-content-color-hover
);--system-spectrum-button-accent-outline-content-color-down:var(
--spectrum-accent-content-color-down
);--system-spectrum-button-accent-outline-content-color-focus:var(
--spectrum-accent-content-color-key-focus
);--system-spectrum-button-accent-outline-background-color-disabled:transparent;--system-spectrum-button-accent-outline-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-button-accent-outline-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-negative-background-color-default:var(
--spectrum-negative-background-color-default
);--system-spectrum-button-negative-background-color-hover:var(
--spectrum-negative-background-color-hover
);--system-spectrum-button-negative-background-color-down:var(
--spectrum-negative-background-color-down
);--system-spectrum-button-negative-background-color-focus:var(
--spectrum-negative-background-color-key-focus
);--system-spectrum-button-negative-border-color-default:transparent;--system-spectrum-button-negative-border-color-hover:transparent;--system-spectrum-button-negative-border-color-down:transparent;--system-spectrum-button-negative-border-color-focus:transparent;--system-spectrum-button-negative-content-color-default:var(
--spectrum-white
);--system-spectrum-button-negative-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-negative-content-color-down:var(--spectrum-white);--system-spectrum-button-negative-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-negative-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-button-negative-border-color-disabled:transparent;--system-spectrum-button-negative-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-negative-outline-background-color-default:transparent;--system-spectrum-button-negative-outline-background-color-hover:var(
--spectrum-negative-color-200
);--system-spectrum-button-negative-outline-background-color-down:var(
--spectrum-negative-color-300
);--system-spectrum-button-negative-outline-background-color-focus:var(
--spectrum-negative-color-200
);--system-spectrum-button-negative-outline-border-color-default:var(
--spectrum-negative-color-900
);--system-spectrum-button-negative-outline-border-color-hover:var(
--spectrum-negative-color-1000
);--system-spectrum-button-negative-outline-border-color-down:var(
--spectrum-negative-color-1100
);--system-spectrum-button-negative-outline-border-color-focus:var(
--spectrum-negative-color-1000
);--system-spectrum-button-negative-outline-content-color-default:var(
--spectrum-negative-content-color-default
);--system-spectrum-button-negative-outline-content-color-hover:var(
--spectrum-negative-content-color-hover
);--system-spectrum-button-negative-outline-content-color-down:var(
--spectrum-negative-content-color-down
);--system-spectrum-button-negative-outline-content-color-focus:var(
--spectrum-negative-content-color-key-focus
);--system-spectrum-button-negative-outline-background-color-disabled:transparent;--system-spectrum-button-negative-outline-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-button-negative-outline-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-primary-background-color-default:var(
--spectrum-neutral-background-color-default
);--system-spectrum-button-primary-background-color-hover:var(
--spectrum-neutral-background-color-hover
);--system-spectrum-button-primary-background-color-down:var(
--spectrum-neutral-background-color-down
);--system-spectrum-button-primary-background-color-focus:var(
--spectrum-neutral-background-color-key-focus
);--system-spectrum-button-primary-border-color-default:transparent;--system-spectrum-button-primary-border-color-hover:transparent;--system-spectrum-button-primary-border-color-down:transparent;--system-spectrum-button-primary-border-color-focus:transparent;--system-spectrum-button-primary-content-color-default:var(
--spectrum-white
);--system-spectrum-button-primary-content-color-hover:var(--spectrum-white);--system-spectrum-button-primary-content-color-down:var(--spectrum-white);--system-spectrum-button-primary-content-color-focus:var(--spectrum-white);--system-spectrum-button-primary-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-button-primary-border-color-disabled:transparent;--system-spectrum-button-primary-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-primary-outline-background-color-default:transparent;--system-spectrum-button-primary-outline-background-color-hover:var(
--spectrum-gray-300
);--system-spectrum-button-primary-outline-background-color-down:var(
--spectrum-gray-400
);--system-spectrum-button-primary-outline-background-color-focus:var(
--spectrum-gray-300
);--system-spectrum-button-primary-outline-border-color-default:var(
--spectrum-gray-800
);--system-spectrum-button-primary-outline-border-color-hover:var(
--spectrum-gray-900
);--system-spectrum-button-primary-outline-border-color-down:var(
--spectrum-gray-900
);--system-spectrum-button-primary-outline-border-color-focus:var(
--spectrum-gray-900
);--system-spectrum-button-primary-outline-content-color-default:var(
--spectrum-neutral-content-color-default
);--system-spectrum-button-primary-outline-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--system-spectrum-button-primary-outline-content-color-down:var(
--spectrum-neutral-content-color-down
);--system-spectrum-button-primary-outline-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--system-spectrum-button-primary-outline-background-color-disabled:transparent;--system-spectrum-button-primary-outline-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-button-primary-outline-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-secondary-background-color-default:var(
--spectrum-gray-200
);--system-spectrum-button-secondary-background-color-hover:var(
--spectrum-gray-300
);--system-spectrum-button-secondary-background-color-down:var(
--spectrum-gray-400
);--system-spectrum-button-secondary-background-color-focus:var(
--spectrum-gray-300
);--system-spectrum-button-secondary-border-color-default:transparent;--system-spectrum-button-secondary-border-color-hover:transparent;--system-spectrum-button-secondary-border-color-down:transparent;--system-spectrum-button-secondary-border-color-focus:transparent;--system-spectrum-button-secondary-content-color-default:var(
--spectrum-neutral-content-color-default
);--system-spectrum-button-secondary-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--system-spectrum-button-secondary-content-color-down:var(
--spectrum-neutral-content-color-down
);--system-spectrum-button-secondary-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--system-spectrum-button-secondary-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-button-secondary-border-color-disabled:transparent;--system-spectrum-button-secondary-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-secondary-outline-background-color-default:transparent;--system-spectrum-button-secondary-outline-background-color-hover:var(
--spectrum-gray-300
);--system-spectrum-button-secondary-outline-background-color-down:var(
--spectrum-gray-400
);--system-spectrum-button-secondary-outline-background-color-focus:var(
--spectrum-gray-300
);--system-spectrum-button-secondary-outline-border-color-default:var(
--spectrum-gray-300
);--system-spectrum-button-secondary-outline-border-color-hover:var(
--spectrum-gray-400
);--system-spectrum-button-secondary-outline-border-color-down:var(
--spectrum-gray-500
);--system-spectrum-button-secondary-outline-border-color-focus:var(
--spectrum-gray-400
);--system-spectrum-button-secondary-outline-content-color-default:var(
--spectrum-neutral-content-color-default
);--system-spectrum-button-secondary-outline-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--system-spectrum-button-secondary-outline-content-color-down:var(
--spectrum-neutral-content-color-down
);--system-spectrum-button-secondary-outline-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--system-spectrum-button-secondary-outline-background-color-disabled:transparent;--system-spectrum-button-secondary-outline-border-color-disabled:var(
--spectrum-disabled-border-color
);--system-spectrum-button-secondary-outline-content-color-disabled:var(
--spectrum-disabled-content-color
);--system-spectrum-button-quiet-background-color-default:transparent;--system-spectrum-button-quiet-background-color-hover:var(
--spectrum-gray-200
);--system-spectrum-button-quiet-background-color-down:var(
--spectrum-gray-300
);--system-spectrum-button-quiet-background-color-focus:var(
--spectrum-gray-200
);--system-spectrum-button-quiet-border-color-default:transparent;--system-spectrum-button-quiet-border-color-hover:transparent;--system-spectrum-button-quiet-border-color-down:transparent;--system-spectrum-button-quiet-border-color-focus:transparent;--system-spectrum-button-quiet-background-color-disabled:transparent;--system-spectrum-button-quiet-border-color-disabled:transparent;--system-spectrum-button-selected-background-color-default:var(
--spectrum-neutral-subdued-background-color-default
);--system-spectrum-button-selected-background-color-hover:var(
--spectrum-neutral-subdued-background-color-hover
);--system-spectrum-button-selected-background-color-down:var(
--spectrum-neutral-subdued-background-color-down
);--system-spectrum-button-selected-background-color-focus:var(
--spectrum-neutral-subdued-background-color-key-focus
);--system-spectrum-button-selected-border-color-default:transparent;--system-spectrum-button-selected-border-color-hover:transparent;--system-spectrum-button-selected-border-color-down:transparent;--system-spectrum-button-selected-border-color-focus:transparent;--system-spectrum-button-selected-content-color-default:var(
--spectrum-white
);--system-spectrum-button-selected-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-selected-content-color-down:var(--spectrum-white);--system-spectrum-button-selected-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-selected-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-button-selected-border-color-disabled:transparent;--system-spectrum-button-selected-emphasized-background-color-default:var(
--spectrum-accent-background-color-default
);--system-spectrum-button-selected-emphasized-background-color-hover:var(
--spectrum-accent-background-color-hover
);--system-spectrum-button-selected-emphasized-background-color-down:var(
--spectrum-accent-background-color-down
);--system-spectrum-button-selected-emphasized-background-color-focus:var(
--spectrum-accent-background-color-key-focus
);--system-spectrum-button-staticblack-quiet-border-color-default:transparent;--system-spectrum-button-staticwhite-quiet-border-color-default:transparent;--system-spectrum-button-staticblack-quiet-border-color-hover:transparent;--system-spectrum-button-staticwhite-quiet-border-color-hover:transparent;--system-spectrum-button-staticblack-quiet-border-color-down:transparent;--system-spectrum-button-staticwhite-quiet-border-color-down:transparent;--system-spectrum-button-staticblack-quiet-border-color-focus:transparent;--system-spectrum-button-staticwhite-quiet-border-color-focus:transparent;--system-spectrum-button-staticblack-quiet-border-color-disabled:transparent;--system-spectrum-button-staticwhite-quiet-border-color-disabled:transparent;--system-spectrum-button-staticwhite-background-color-default:var(
--spectrum-transparent-white-800
);--system-spectrum-button-staticwhite-background-color-hover:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-background-color-down:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-background-color-focus:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-border-color-default:transparent;--system-spectrum-button-staticwhite-border-color-hover:transparent;--system-spectrum-button-staticwhite-border-color-down:transparent;--system-spectrum-button-staticwhite-border-color-focus:transparent;--system-spectrum-button-staticwhite-content-color-default:var(
--spectrum-black
);--system-spectrum-button-staticwhite-content-color-hover:var(
--spectrum-black
);--system-spectrum-button-staticwhite-content-color-down:var(
--spectrum-black
);--system-spectrum-button-staticwhite-content-color-focus:var(
--spectrum-black
);--system-spectrum-button-staticwhite-focus-indicator-color:var(
--spectrum-static-white-focus-indicator-color
);--system-spectrum-button-staticwhite-background-color-disabled:var(
--spectrum-disabled-static-white-background-color
);--system-spectrum-button-staticwhite-border-color-disabled:transparent;--system-spectrum-button-staticwhite-content-color-disabled:var(
--spectrum-disabled-static-white-content-color
);--system-spectrum-button-staticwhite-outline-background-color-default:transparent;--system-spectrum-button-staticwhite-outline-background-color-hover:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-outline-background-color-down:var(
--spectrum-transparent-white-400
);--system-spectrum-button-staticwhite-outline-background-color-focus:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-outline-border-color-default:var(
--spectrum-transparent-white-800
);--system-spectrum-button-staticwhite-outline-border-color-hover:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-outline-border-color-down:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-outline-border-color-focus:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-outline-content-color-default:var(
--spectrum-white
);--system-spectrum-button-staticwhite-outline-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-staticwhite-outline-content-color-down:var(
--spectrum-white
);--system-spectrum-button-staticwhite-outline-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-staticwhite-outline-focus-indicator-color:var(
--spectrum-static-white-focus-indicator-color
);--system-spectrum-button-staticwhite-outline-background-color-disabled:transparent;--system-spectrum-button-staticwhite-outline-border-color-disabled:var(
--spectrum-disabled-static-white-border-color
);--system-spectrum-button-staticwhite-outline-content-color-disabled:var(
--spectrum-disabled-static-white-content-color
);--system-spectrum-button-staticwhite-selected-background-color-default:var(
--spectrum-transparent-white-800
);--system-spectrum-button-staticwhite-selected-background-color-hover:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-selected-background-color-down:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-selected-background-color-focus:var(
--spectrum-transparent-white-900
);--system-spectrum-button-staticwhite-selected-content-color-default:var(
--spectrum-black
);--system-spectrum-button-staticwhite-selected-content-color-hover:var(
--spectrum-black
);--system-spectrum-button-staticwhite-selected-content-color-down:var(
--spectrum-black
);--system-spectrum-button-staticwhite-selected-content-color-focus:var(
--spectrum-black
);--system-spectrum-button-staticwhite-selected-background-color-disabled:var(
--spectrum-disabled-static-white-background-color
);--system-spectrum-button-staticwhite-selected-border-color-disabled:transparent;--system-spectrum-button-staticwhite-secondary-background-color-default:var(
--spectrum-transparent-white-200
);--system-spectrum-button-staticwhite-secondary-background-color-hover:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-secondary-background-color-down:var(
--spectrum-transparent-white-400
);--system-spectrum-button-staticwhite-secondary-background-color-focus:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-secondary-border-color-default:transparent;--system-spectrum-button-staticwhite-secondary-border-color-hover:transparent;--system-spectrum-button-staticwhite-secondary-border-color-down:transparent;--system-spectrum-button-staticwhite-secondary-border-color-focus:transparent;--system-spectrum-button-staticwhite-secondary-content-color-default:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-content-color-down:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-focus-indicator-color:var(
--spectrum-static-white-focus-indicator-color
);--system-spectrum-button-staticwhite-secondary-background-color-disabled:var(
--spectrum-disabled-static-white-background-color
);--system-spectrum-button-staticwhite-secondary-border-color-disabled:transparent;--system-spectrum-button-staticwhite-secondary-content-color-disabled:var(
--spectrum-disabled-static-white-content-color
);--system-spectrum-button-staticwhite-secondary-outline-background-color-default:transparent;--system-spectrum-button-staticwhite-secondary-outline-background-color-hover:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-secondary-outline-background-color-down:var(
--spectrum-transparent-white-400
);--system-spectrum-button-staticwhite-secondary-outline-background-color-focus:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-secondary-outline-border-color-default:var(
--spectrum-transparent-white-300
);--system-spectrum-button-staticwhite-secondary-outline-border-color-hover:var(
--spectrum-transparent-white-400
);--system-spectrum-button-staticwhite-secondary-outline-border-color-down:var(
--spectrum-transparent-white-500
);--system-spectrum-button-staticwhite-secondary-outline-border-color-focus:var(
--spectrum-transparent-white-400
);--system-spectrum-button-staticwhite-secondary-outline-content-color-default:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-outline-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-outline-content-color-down:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-outline-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-staticwhite-secondary-outline-focus-indicator-color:var(
--spectrum-static-white-focus-indicator-color
);--system-spectrum-button-staticwhite-secondary-outline-background-color-disabled:transparent;--system-spectrum-button-staticwhite-secondary-outline-border-color-disabled:var(
--spectrum-disabled-static-white-border-color
);--system-spectrum-button-staticwhite-secondary-outline-content-color-disabled:var(
--spectrum-disabled-static-white-content-color
);--system-spectrum-button-staticblack-background-color-default:var(
--spectrum-transparent-black-800
);--system-spectrum-button-staticblack-background-color-hover:var(
--spectrum-transparent-black-900
);--system-spectrum-button-staticblack-background-color-down:var(
--spectrum-transparent-black-900
);--system-spectrum-button-staticblack-background-color-focus:var(
--spectrum-transparent-black-900
);--system-spectrum-button-staticblack-border-color-default:transparent;--system-spectrum-button-staticblack-border-color-hover:transparent;--system-spectrum-button-staticblack-border-color-down:transparent;--system-spectrum-button-staticblack-border-color-focus:transparent;--system-spectrum-button-staticblack-content-color-default:var(
--spectrum-white
);--system-spectrum-button-staticblack-content-color-hover:var(
--spectrum-white
);--system-spectrum-button-staticblack-content-color-down:var(
--spectrum-white
);--system-spectrum-button-staticblack-content-color-focus:var(
--spectrum-white
);--system-spectrum-button-staticblack-focus-indicator-color:var(
--spectrum-static-black-focus-indicator-color
);--system-spectrum-button-staticblack-background-color-disabled:var(
--spectrum-disabled-static-black-background-color
);--system-spectrum-button-staticblack-border-color-disabled:transparent;--system-spectrum-button-staticblack-content-color-disabled:var(
--spectrum-disabled-static-black-content-color
);--system-spectrum-button-staticblack-outline-background-color-default:transparent;--system-spectrum-button-staticblack-outline-background-color-hover:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-outline-background-color-down:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-outline-background-color-focus:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-outline-border-color-default:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-outline-border-color-hover:var(
--spectrum-transparent-black-500
);--system-spectrum-button-staticblack-outline-border-color-down:var(
--spectrum-transparent-black-600
);--system-spectrum-button-staticblack-outline-border-color-focus:var(
--spectrum-transparent-black-500
);--system-spectrum-button-staticblack-outline-content-color-default:var(
--spectrum-black
);--system-spectrum-button-staticblack-outline-content-color-hover:var(
--spectrum-black
);--system-spectrum-button-staticblack-outline-content-color-down:var(
--spectrum-black
);--system-spectrum-button-staticblack-outline-content-color-focus:var(
--spectrum-black
);--system-spectrum-button-staticblack-outline-focus-indicator-color:var(
--spectrum-static-black-focus-indicator-color
);--system-spectrum-button-staticblack-outline-background-color-disabled:transparent;--system-spectrum-button-staticblack-outline-border-color-disabled:var(
--spectrum-disabled-static-black-border-color
);--system-spectrum-button-staticblack-outline-content-color-disabled:var(
--spectrum-disabled-static-black-content-color
);--system-spectrum-button-staticblack-secondary-background-color-default:var(
--spectrum-transparent-black-200
);--system-spectrum-button-staticblack-secondary-background-color-hover:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-secondary-background-color-down:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-secondary-background-color-focus:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-secondary-border-color-default:transparent;--system-spectrum-button-staticblack-secondary-border-color-hover:transparent;--system-spectrum-button-staticblack-secondary-border-color-down:transparent;--system-spectrum-button-staticblack-secondary-border-color-focus:transparent;--system-spectrum-button-staticblack-secondary-content-color-default:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-content-color-hover:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-content-color-down:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-content-color-focus:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-focus-indicator-color:var(
--spectrum-static-black-focus-indicator-color
);--system-spectrum-button-staticblack-secondary-background-color-disabled:var(
--spectrum-disabled-static-black-background-color
);--system-spectrum-button-staticblack-secondary-border-color-disabled:transparent;--system-spectrum-button-staticblack-secondary-content-color-disabled:var(
--spectrum-disabled-static-black-content-color
);--system-spectrum-button-staticblack-secondary-outline-background-color-default:transparent;--system-spectrum-button-staticblack-secondary-outline-background-color-hover:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-secondary-outline-background-color-down:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-secondary-outline-background-color-focus:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-secondary-outline-border-color-default:var(
--spectrum-transparent-black-300
);--system-spectrum-button-staticblack-secondary-outline-border-color-hover:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-secondary-outline-border-color-down:var(
--spectrum-transparent-black-500
);--system-spectrum-button-staticblack-secondary-outline-border-color-focus:var(
--spectrum-transparent-black-400
);--system-spectrum-button-staticblack-secondary-outline-content-color-default:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-outline-content-color-hover:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-outline-content-color-down:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-outline-content-color-focus:var(
--spectrum-black
);--system-spectrum-button-staticblack-secondary-outline-focus-indicator-color:var(
--spectrum-static-black-focus-indicator-color
);--system-spectrum-button-staticblack-secondary-outline-background-color-disabled:transparent;--system-spectrum-button-staticblack-secondary-outline-border-color-disabled:var(
--spectrum-disabled-static-black-border-color
);--system-spectrum-button-staticblack-secondary-outline-content-color-disabled:var(
--spectrum-disabled-static-black-content-color
)}:host,:root{--system-spectrum-closebutton-background-color-default:transparent;--system-spectrum-closebutton-background-color-hover:var(
--spectrum-gray-200
);--system-spectrum-closebutton-background-color-down:var(
--spectrum-gray-300
);--system-spectrum-closebutton-background-color-focus:var(
--spectrum-gray-200
)}:host,:root{--system-spectrum-radio-button-border-color-default:var(
--spectrum-gray-600
);--system-spectrum-radio-button-border-color-hover:var(--spectrum-gray-700);--system-spectrum-radio-button-border-color-down:var(--spectrum-gray-800);--system-spectrum-radio-button-border-color-focus:var(--spectrum-gray-700);--system-spectrum-radio-button-checked-border-color-default:var(
--spectrum-gray-700
);--system-spectrum-radio-button-checked-border-color-hover:var(
--spectrum-gray-800
);--system-spectrum-radio-button-checked-border-color-down:var(
--spectrum-gray-900
);--system-spectrum-radio-button-checked-border-color-focus:var(
--spectrum-gray-800
);--system-spectrum-radio-emphasized-button-checked-border-color-default:var(
--spectrum-accent-color-900
);--system-spectrum-radio-emphasized-button-checked-border-color-hover:var(
--spectrum-accent-color-1000
);--system-spectrum-radio-emphasized-button-checked-border-color-down:var(
--spectrum-accent-color-1100
);--system-spectrum-radio-emphasized-button-checked-border-color-focus:var(
--spectrum-accent-color-1000
)}:host,:root{--system-spectrum-switch-background-color-selected-default:var(
--spectrum-gray-700
);--system-spectrum-switch-background-color-selected-hover:var(
--spectrum-gray-800
);--system-spectrum-switch-background-color-selected-down:var(
--spectrum-gray-900
);--system-spectrum-switch-background-color-selected-focus:var(
--spectrum-gray-800
);--system-spectrum-switch-handle-border-color-default:var(
--spectrum-gray-600
);--system-spectrum-switch-handle-border-color-hover:var(
--spectrum-gray-700
);--system-spectrum-switch-handle-border-color-down:var(--spectrum-gray-800);--system-spectrum-switch-handle-border-color-focus:var(
--spectrum-gray-700
);--system-spectrum-switch-handle-border-color-selected-default:var(
--spectrum-gray-700
);--system-spectrum-switch-handle-border-color-selected-hover:var(
--spectrum-gray-800
);--system-spectrum-switch-handle-border-color-selected-down:var(
--spectrum-gray-900
);--system-spectrum-switch-handle-border-color-selected-focus:var(
--spectrum-gray-800
)}:host,:root{--system-spectrum-toast-background-color-default:var(
--spectrum-neutral-subdued-background-color-default
)}:host,:root{--system-spectrum-actiongroup-gap-size-compact:0;--system-spectrum-actiongroup-horizontal-spacing-compact:-1px;--system-spectrum-actiongroup-vertical-spacing-compact:-1px}:host,:root{--system-spectrum-tag-border-color:var(--spectrum-gray-700);--system-spectrum-tag-border-color-hover:var(--spectrum-gray-800);--system-spectrum-tag-border-color-active:var(--spectrum-gray-900);--system-spectrum-tag-border-color-focus:var(--spectrum-gray-800);--system-spectrum-tag-size-small-corner-radius:var(
--spectrum-corner-radius-100
);--system-spectrum-tag-size-medium-corner-radius:var(
--spectrum-corner-radius-100
);--system-spectrum-tag-size-large-corner-radius:var(
--spectrum-corner-radius-100
);--system-spectrum-tag-background-color:var(--spectrum-gray-75);--system-spectrum-tag-background-color-hover:var(--spectrum-gray-75);--system-spectrum-tag-background-color-active:var(--spectrum-gray-200);--system-spectrum-tag-background-color-focus:var(--spectrum-gray-75);--system-spectrum-tag-content-color:var(
--spectrum-neutral-subdued-content-color-default
);--system-spectrum-tag-content-color-hover:var(
--spectrum-neutral-subdued-content-color-hover
);--system-spectrum-tag-content-color-active:var(
--spectrum-neutral-subdued-content-color-down
);--system-spectrum-tag-content-color-focus:var(
--spectrum-neutral-subdued-content-color-key-focus
);--system-spectrum-tag-border-color-selected:var(
--spectrum-neutral-subdued-background-color-default
);--system-spectrum-tag-border-color-selected-hover:var(
--spectrum-neutral-subdued-background-color-hover
);--system-spectrum-tag-border-color-selected-active:var(
--spectrum-neutral-subdued-background-color-down
);--system-spectrum-tag-border-color-selected-focus:var(
--spectrum-neutral-subdued-background-color-key-focus
);--system-spectrum-tag-background-color-selected:var(
--spectrum-neutral-subdued-background-color-default
);--system-spectrum-tag-background-color-selected-hover:var(
--spectrum-neutral-subdued-background-color-hover
);--system-spectrum-tag-background-color-selected-active:var(
--spectrum-neutral-subdued-background-color-down
);--system-spectrum-tag-background-color-selected-focus:var(
--spectrum-neutral-subdued-background-color-key-focus
);--system-spectrum-tag-border-color-disabled:transparent;--system-spectrum-tag-background-color-disabled:var(
--spectrum-disabled-background-color
);--system-spectrum-tag-size-small-spacing-inline-start:var(
--spectrum-component-edge-to-visual-75
);--system-spectrum-tag-size-small-label-spacing-inline-end:var(
--spectrum-component-edge-to-text-75
);--system-spectrum-tag-size-small-clear-button-spacing-inline-end:var(
--spectrum-component-edge-to-visual-75
);--system-spectrum-tag-size-medium-spacing-inline-start:var(
--spectrum-component-edge-to-visual-100
);--system-spectrum-tag-size-medium-label-spacing-inline-end:var(
--spectrum-component-edge-to-text-100
);--system-spectrum-tag-size-medium-clear-button-spacing-inline-end:var(
--spectrum-component-edge-to-visual-100
);--system-spectrum-tag-size-large-spacing-inline-start:var(
--spectrum-component-edge-to-visual-200
);--system-spectrum-tag-size-large-label-spacing-inline-end:var(
--spectrum-component-edge-to-text-200
);--system-spectrum-tag-size-large-clear-button-spacing-inline-end:var(
--spectrum-component-edge-to-visual-200
)}:host,:root{--system-spectrum-tooltip-backgound-color-default-neutral:var(
--spectrum-neutral-subdued-background-color-default
)}:host,:root{--system-spectrum-picker-background-color-default:var(--spectrum-gray-75);--system-spectrum-picker-background-color-default-open:var(
--spectrum-gray-200
);--system-spectrum-picker-background-color-active:var(--spectrum-gray-300);--system-spectrum-picker-background-color-hover:var(--spectrum-gray-200);--system-spectrum-picker-background-color-hover-open:var(
--spectrum-gray-200
);--system-spectrum-picker-background-color-key-focus:var(
--spectrum-gray-200
);--system-spectrum-picker-border-color-default:var(--spectrum-gray-400);--system-spectrum-picker-border-color-default-open:var(
--spectrum-gray-400
);--system-spectrum-picker-border-color-hover:var(--spectrum-gray-500);--system-spectrum-picker-border-color-hover-open:var(--spectrum-gray-500);--system-spectrum-picker-border-color-active:var(--spectrum-gray-600);--system-spectrum-picker-border-color-key-focus:var(--spectrum-gray-500)}:host,:root{--system:spectrum}:host,:root{--spectrum-animation-linear:cubic-bezier(0,0,1,1);--spectrum-animation-duration-0:0ms;--spectrum-animation-duration-100:130ms;--spectrum-animation-duration-200:160ms;--spectrum-animation-duration-300:190ms;--spectrum-animation-duration-400:220ms;--spectrum-animation-duration-500:250ms;--spectrum-animation-duration-600:300ms;--spectrum-animation-duration-700:350ms;--spectrum-animation-duration-800:400ms;--spectrum-animation-duration-900:450ms;--spectrum-animation-duration-1000:500ms;--spectrum-animation-duration-2000:1000ms;--spectrum-animation-duration-4000:2000ms;--spectrum-animation-ease-in-out:cubic-bezier(0.45,0,0.4,1);--spectrum-animation-ease-in:cubic-bezier(0.5,0,1,1);--spectrum-animation-ease-out:cubic-bezier(0,0,0.4,1);--spectrum-animation-ease-linear:cubic-bezier(0,0,1,1);--spectrum-sans-serif-font:var(--spectrum-sans-serif-font-family);--spectrum-sans-font-family-stack:var(--spectrum-sans-serif-font),adobe-clean,"Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Trebuchet MS","Lucida Grande",sans-serif;--spectrum-serif-font:var(--spectrum-serif-font-family);--spectrum-serif-font-family-stack:var(--spectrum-serif-font),adobe-clean-serif,"Source Serif Pro",Georgia,serif;--spectrum-code-font-family-stack:"Source Code Pro",Monaco,monospace;--spectrum-cjk-font:var(--spectrum-cjk-font-family);--spectrum-cjk-font-family-stack:var(--spectrum-cjk-font),adobe-clean-han-japanese,sans-serif;--spectrum-docs-static-white-background-color:#0f797d;--spectrum-docs-static-black-background-color:#cef7f3}:host,:root{font-family:var(--spectrum-alias-body-text-font-family);font-size:var(--spectrum-alias-font-size-default)}:host:lang(ar),:root:lang(ar){font-family:var(--spectrum-alias-font-family-ar)}:host:lang(he),:root:lang(he){font-family:var(--spectrum-alias-font-family-he)}:host:lang(zh-Hans),:root:lang(zh-Hans){font-family:var(--spectrum-alias-font-family-zhhans)}:host:lang(zh-Hant),:root:lang(zh-Hant){font-family:var(--spectrum-alias-font-family-zh)}:host:lang(zh),:root:lang(zh){font-family:var(--spectrum-alias-font-family-zh)}:host:lang(ko),:root:lang(ko){font-family:var(--spectrum-alias-font-family-ko)}:host:lang(ja),:root:lang(ja){font-family:var(--spectrum-alias-font-family-ja)}:host{display:block}#scale,#theme{height:100%;width:100%}
`;
var $0c01a02246f1e6ee$export$2e2bcd8739ae039 = $0c01a02246f1e6ee$var$e;


"use strict";
(0, $e89f5cc053bf9b21$export$14faa19a0f3bbeb2).registerThemeFragment("spectrum", "theme", (0, $0c01a02246f1e6ee$export$2e2bcd8739ae039));


"use strict";
(0, $e89f5cc053bf9b21$export$14faa19a0f3bbeb2).registerThemeFragment("medium", "scale", (0, $5184aaf250a298a2$export$2e2bcd8739ae039));



"use strict";
customElements.define("sp-theme", (0, $e89f5cc053bf9b21$export$14faa19a0f3bbeb2));



var $8L18p = parcelRequire("8L18p");

var $5va4w = parcelRequire("5va4w");

var $8L18p = parcelRequire("8L18p");
const $6745620d6d526b9a$var$FLOW_SCHEMA = (0, $8L18p.z).object({});
const $6745620d6d526b9a$export$d60d861b873ae55e = $6745620d6d526b9a$var$FLOW_SCHEMA// Pages
.merge((0, $5va4w.Schema));
const $6745620d6d526b9a$export$19342e026b58ebb7 = (0, $8L18p.z).object({
    variant: (0, $8L18p.z).literal("unified-mobile")
}).merge($6745620d6d526b9a$export$d60d861b873ae55e);



var $d48Mi = parcelRequire("d48Mi");

var $8Mzka = parcelRequire("8Mzka");

var $8Mzka = parcelRequire("8Mzka");
/**
 * SECURITY (VULN-36931) — credential-emit-time origin validation.
 *
 * The legacy `<susi-sentry>` (packages/wrapper) embeds this app in an iframe and
 * passes `asserted_origin` (the host it wants the credential delivered to). That
 * value is attacker-controllable, so before the app emits a token/auth-code back
 * to the host we must confirm `asserted_origin` is a registered redirect URI for
 * the client.
 *
 * This runs at emit time — when a token exists — so it can use
 * `/ims/validate_client/v2`, which requires a bearer and is CORS-enabled for the
 * auth-light origin (the app-elm iframe uses the same endpoint the same way).
 * The old pre-connection check used `/ims/clients/validate/v1`, which is
 * bearer-gated + not CORS-enabled and therefore fails closed in the browser
 * (see VULN-36931 analysis); it could never work at connection-setup time
 * because no credential exists yet.
 *
 * Kept self-contained (only `@sentry/shared`) to avoid an import cycle with
 * `configurations-api` (which reaches back into the store via `getImsEndpoint`).
 */ const { getApiUrl: $aa1322372e60e2a9$var$getApiUrl } = (0, $8Mzka.urls).create((0, $8Mzka.envs).getAppEnv);
const { default: $aa1322372e60e2a9$var$getEnvironment, ENVIRONMENTS: $aa1322372e60e2a9$var$ENVIRONMENTS } = (0, $8Mzka.environments);
async function $aa1322372e60e2a9$export$f85e89ba3366cfe9({ client_id: client_id, relay: relay, asserted_origin: asserted_origin }, tokenType, token) {
    // Local dev has no real registered redirect URI to validate against, so the
    // real network call can only fail (CORS). Mirror the IS_LOCAL short-circuit
    // used by wrapper-popup-helper/index.ts and app-elm/wrapper/iframe/index.html.
    if ($aa1322372e60e2a9$var$getEnvironment((0, $8Mzka.envs).getAppEnv).isEnvironment($aa1322372e60e2a9$var$ENVIRONMENTS.local)) return true;
    // Everything below can only fail closed: any error — v2 unreachable, a
    // malformed response, or an unexpected throw while building the request — is
    // logged as `validate-origin-error` and returns false. The gate never throws,
    // so every outcome is observable in Splunk (released / rejected / error) and
    // fire-and-forget callers can't produce an unhandled rejection.
    // Captured for the error log below: undefined if the fetch never got a
    // response (network / CORS / abort -> "Failed to fetch"), the HTTP status if
    // IMS responded but we couldn't use it -- the split that says whether the
    // call even reached IMS.
    let responseStatus;
    try {
        // No credential means nothing to authenticate the v2 call with (and nothing
        // to release) — fail closed rather than issue an unauthenticated request.
        if (!token) {
            (0, $8Mzka.createLogger)((0, $8Mzka.envs).getAppEnv, client_id, relay, "validate-origin-error")({
                error: {
                    name: "no credential",
                    message: "empty bearer; failing closed"
                }
            });
            return false;
        }
        const endpoint = new URL("/ims/validate_client/v2", $aa1322372e60e2a9$var$getApiUrl());
        endpoint.searchParams.append("client_id", client_id);
        endpoint.searchParams.append("redirect_uri", asserted_origin);
        endpoint.searchParams.append("relay", relay);
        endpoint.searchParams.append("token_type", tokenType);
        const response = await fetch(endpoint.toString(), {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        responseStatus = response.status;
        const body = await response.json();
        const valid = (body === null || body === void 0 ? void 0 : body.valid) === true;
        // Rollout observability: log EVERY gate decision as a distinct per-client
        // signal so success vs failure is timechartable, not just failures:
        //   f.name="validate-origin-released" → valid   (credential released)
        //   f.name="validate-origin-rejected" → invalid (withheld → on-auth-failed)
        // asserted_origin/client_id are not secrets; never log `token`.
        (0, $8Mzka.createLogger)((0, $8Mzka.envs).getAppEnv, client_id, relay, valid ? "validate-origin-released" : "validate-origin-rejected")({
            info: valid ? "origin validated; releasing credential" : "origin rejected by validate_client/v2",
            asserted_origin: asserted_origin,
            token_type: tokenType,
            status: response.status
        });
        return valid;
    } catch (e) {
        // Fail closed: if we cannot confirm the origin, do not release the
        // credential. Logged so an IMS outage (spikes of on-auth-failed
        // { reason: 'origin-invalid' }) stays diagnosable — the other callers of
        // this endpoint (wrapper-popup-helper, react popup) log on failure too.
        (0, $8Mzka.createLogger)((0, $8Mzka.envs).getAppEnv, client_id, relay, "validate-origin-error")({
            error: {
                name: "validateOriginWithCredential failed",
                message: e === null || e === void 0 ? void 0 : e.message
            },
            // status: undefined => the fetch never got a response (network / CORS /
            // abort => "Failed to fetch"); a number => IMS responded but we couldn't
            // use it. That split says whether the call even reached IMS. token_type
            // mirrors the released/rejected logs to aid correlation to the IMS
            // audit/access logs. relay already ships as this log's `c` field (from
            // createLogger above), so it is not repeated in the payload. Never log `token`.
            status: responseStatus,
            token_type: tokenType
        });
        return false;
    }
}


const $baee8b1a370b4d0b$export$605aa02e0f6195d5 = (0, $8Mzka.Event).create({
    name: "redirect",
    side: "proxy"
});
const $baee8b1a370b4d0b$export$76edcc301cb7aad8 = (0, $8Mzka.Event).create({
    name: "deeplink",
    side: "proxy"
});
const $baee8b1a370b4d0b$export$b692a850fe57f13f = (0, $8Mzka.Event).create({
    name: "on-error",
    side: "proxy",
    data: (0, $8Mzka.SentryError).critical("Unknown error.")
});
const $baee8b1a370b4d0b$export$84e3e0626b89f730 = (0, $8Mzka.Event).create({
    name: "on-auth-failed",
    side: "proxy",
    data: {
        reason: (0, $d48Mi.AUTH_FAILED_REASON).unknown
    }
});
const $baee8b1a370b4d0b$export$704c8fd64d804903 = (0, $8Mzka.Event).create({
    name: "hello",
    side: "proxy",
    data: {
        name: "hello"
    }
});
const $baee8b1a370b4d0b$export$30c6ebcdfef74587 = (0, $8Mzka.Event).create({
    name: "on-load",
    side: "proxy"
});
const $baee8b1a370b4d0b$export$7306fcd8e0d45fae = (0, $8Mzka.Event).create({
    name: "on-token",
    side: "proxy"
});
const $baee8b1a370b4d0b$export$a403478478b3eb0 = (0, $8Mzka.Event).create({
    name: "on-auth-code",
    side: "proxy"
});
const $baee8b1a370b4d0b$export$1c755610a1bed4c4 = (0, $8Mzka.Event).create({
    name: "on-provider-clicked",
    side: "proxy"
});
function $baee8b1a370b4d0b$export$4952404cd49f50b4(port, originValidation) {
    const emitToken = (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$7306fcd8e0d45fae);
    const emitAuthCode = (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$a403478478b3eb0);
    const sendAuthFailed = (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$84e3e0626b89f730);
    // SECURITY (VULN-36931): never release a credential to the host
    // (asserted_origin) until that origin is validated against the client's
    // registered redirect URIs. The check runs here, at emit time, because only
    // now does a token exist to satisfy /ims/validate_client/v2. Fails closed —
    // an unvalidated origin gets on-auth-failed, not the credential.
    const releaseCredential = async (tokenType, credential, emit, fallbackUrl)=>{
        // Non-wrapper callers (no asserted_origin) keep prior behavior; only the
        // wrapper path carries an attacker-suppliable origin to validate.
        if (!originValidation) {
            emit(credential);
            return;
        }
        // Fail closed on ANY error, and never reject. The trait handlers
        // (handlers.ts) invoke sendToken/sendAuthCode fire-and-forget, so a
        // rejection here would surface as an unhandled promise rejection AND skip
        // the intended on-auth-failed. Any failure -> withhold + on-auth-failed.
        try {
            const isValid = await (0, $aa1322372e60e2a9$export$f85e89ba3366cfe9)(originValidation, tokenType, credential);
            if (isValid) emit(credential);
            else {
                // VALIDATION (SUSILT-453): distinct signal to confirm a withheld
                // credential carries a recovery URL. All four popup flows (social,
                // adobe-sign-in, adobe-create-account, passkey) now thread a fallbackUrl,
                // so post-release has_fallback should read ~100% true — a material `false`
                // flags a flow that still dead-ends (regression), the only benign source
                // being the dead federated-social branch. token_type keeps the
                // access_token/code split. asserted_origin/token are never logged here.
                (0, $8Mzka.createLogger)((0, $8Mzka.envs).getAppEnv, originValidation.client_id, originValidation.relay, "credential-withheld")({
                    info: "origin gate withheld credential",
                    token_type: tokenType,
                    has_fallback: Boolean(fallbackUrl)
                });
                sendAuthFailed({
                    reason: (0, $d48Mi.AUTH_FAILED_REASON).originInvalid,
                    fallbackUrl: fallbackUrl
                });
            }
        } catch (e) {
            // Unreachable in practice — validateOriginWithCredential never throws and
            // the emitters are plain postMessage — but if the release wiring itself
            // throws we still fail closed AND surface it. Distinct f.name so a wiring
            // misfire is separable in Splunk from v2/gate failures.
            (0, $8Mzka.createLogger)((0, $8Mzka.envs).getAppEnv, originValidation.client_id, originValidation.relay, "credential-release-error")({
                error: {
                    name: "credential release wiring threw",
                    message: e === null || e === void 0 ? void 0 : e.message
                }
            });
            sendAuthFailed({
                reason: (0, $d48Mi.AUTH_FAILED_REASON).originInvalid,
                fallbackUrl: fallbackUrl
            });
        }
    };
    return {
        redirect: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$605aa02e0f6195d5),
        openPopup: (0, $8Mzka.eventFactory)(port)((0, $8Mzka.OpenPopupEvent)),
        openModal: (0, $8Mzka.eventFactory)(port)((0, $8Mzka.OpenModalEvent)),
        closeModal: (0, $8Mzka.eventFactory)(port)((0, $8Mzka.CloseModalEvent)),
        sendProvider: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$1c755610a1bed4c4),
        sendToken: (token, fallbackUrl)=>releaseCredential("access_token", token, emitToken, fallbackUrl),
        sendAuthCode: (code, fallbackUrl)=>releaseCredential("authorization_code", code, emitAuthCode, fallbackUrl),
        sendAuthFailed: sendAuthFailed,
        sendError: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$b692a850fe57f13f),
        sendLoad: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$30c6ebcdfef74587)
    };
}
function $baee8b1a370b4d0b$export$d7abda40386d477(messenger) {
    const port = {
        postMessage: (event)=>messenger.postMessage(event)
    };
    return {
        redirect: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$605aa02e0f6195d5),
        deeplink: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$76edcc301cb7aad8),
        sendError: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$b692a850fe57f13f),
        sendHello: (0, $8Mzka.eventFactory)(port)($baee8b1a370b4d0b$export$704c8fd64d804903)
    };
}
function $baee8b1a370b4d0b$export$3f41ece7d7128238(messenger, originValidation) {
    if (messenger instanceof MessagePort) return $baee8b1a370b4d0b$export$4952404cd49f50b4(messenger, originValidation);
    else return $baee8b1a370b4d0b$export$d7abda40386d477(messenger);
}
async function $baee8b1a370b4d0b$export$f08a7b1176f2bc95(event, actions) {
    return console.log(event);
}



var $ermYl = parcelRequire("ermYl");

var $4AFyb = parcelRequire("4AFyb");

var $dQqBy = parcelRequire("dQqBy");

var $eKTtn = parcelRequire("eKTtn");

var $jsjcF = parcelRequire("jsjcF");

var $8L18p = parcelRequire("8L18p");

var $8L18p = parcelRequire("8L18p");

var $48dd2 = parcelRequire("48dd2");

var $8L18p = parcelRequire("8L18p");
const $27f0646703ef4562$export$19342e026b58ebb7 = (0, $8L18p.default).object({
    consentProfile: (0, $48dd2.ConsentProfileSchema),
    enableCompleteAccount: (0, $8L18p.default).boolean().optional().default(false)
});


const $43a020e83b0b46c5$var$FLOW_SCHEMA = (0, $8L18p.z).object({});
const $43a020e83b0b46c5$export$a4f236a17d37b499 = $43a020e83b0b46c5$var$FLOW_SCHEMA// Pages
.merge((0, $27f0646703ef4562$export$19342e026b58ebb7));
const $43a020e83b0b46c5$export$19342e026b58ebb7 = (0, $8L18p.z).object({
    variant: (0, $8L18p.z).literal("complete-account")
}).merge($43a020e83b0b46c5$export$a4f236a17d37b499);





var $2iWIC = parcelRequire("2iWIC");

var $8L18p = parcelRequire("8L18p");
const $499d2c51655ae0ee$var$FeatureFlags = (0, $8L18p.z).object({
    hasPasskeys: (0, $8L18p.z).boolean().default(false)
}).default({
    hasPasskeys: false
});
// Features
const $499d2c51655ae0ee$var$FLOW_SCHEMA = (0, $8L18p.z).object({
    features: $499d2c51655ae0ee$var$FeatureFlags
});
const $499d2c51655ae0ee$export$a57c67591439123d = $499d2c51655ae0ee$var$FLOW_SCHEMA// Pages
.merge((0, $2iWIC.Schema))// Sub Flows
.merge((0, $43a020e83b0b46c5$export$a4f236a17d37b499));
const $499d2c51655ae0ee$export$19342e026b58ebb7 = (0, $8L18p.z).object({
    variant: (0, $8L18p.z).literal("large-buttons")
}).merge($499d2c51655ae0ee$export$a57c67591439123d);




var $4ewU9 = parcelRequire("4ewU9");

var $8L18p = parcelRequire("8L18p");
const $5af5bf616b130ca9$var$FLOW_SCHEMA = (0, $8L18p.z).object({});
const $5af5bf616b130ca9$export$a57c67591439123d = $5af5bf616b130ca9$var$FLOW_SCHEMA// Pages
.merge((0, $4ewU9.Schema))// Sub Flows
.merge((0, $43a020e83b0b46c5$export$a4f236a17d37b499));
const $5af5bf616b130ca9$export$19342e026b58ebb7 = (0, $8L18p.z).object({
    variant: (0, $8L18p.z).literal("express-theme")
}).merge($5af5bf616b130ca9$export$a57c67591439123d);


const $a5ae78f5c11ac7a6$export$9b42836cb3c1f082 = (0, $8L18p.z).discriminatedUnion("variant", [
    (0, $499d2c51655ae0ee$export$19342e026b58ebb7),
    (0, $5af5bf616b130ca9$export$19342e026b58ebb7),
    (0, $6745620d6d526b9a$export$19342e026b58ebb7),
    (0, $43a020e83b0b46c5$export$19342e026b58ebb7)
]);



var $8L18p = parcelRequire("8L18p");
const $71d62a8f878f365f$export$9b6cb726c61166a6 = (0, $8L18p.default).object({
    version: (0, $8L18p.default).string().default("1.0.0"),
    build: (0, $8L18p.default).string().default(""),
    buildTime: (0, $8L18p.default).number().default(0),
    popup: (0, $8L18p.default).boolean().default(false),
    modal: (0, $8L18p.default).boolean().default(false),
    /** When true, GuestSource is emitted once per session when the initial load handshake is sent. */ isGuest: (0, $8L18p.default).boolean().optional()
});
const $71d62a8f878f365f$export$19342e026b58ebb7 = (0, $a5ae78f5c11ac7a6$export$9b42836cb3c1f082).and($71d62a8f878f365f$export$9b6cb726c61166a6);



var $iqkw9 = parcelRequire("iqkw9");
function $7863be4040c6fabe$var$getStateQS(queryState, config) {
    return {
        authParams: queryState,
        config: JSON.parse(config !== null && config !== void 0 ? config : "")
    };
}
/**
 * === HACK ===
 * To support weird SWC behavior.
 * Re-define CustomElements definition to not crash if component already is registered.
 * This should be brought up with the SWC team.
 */ /** @ts-ignore */ window.customElements.defineClone = Object.assign(Object.create(Object.getPrototypeOf(customElements)).define, customElements);
window.customElements.define = (name, element)=>/** @ts-ignore */ customElements.get(name) || customElements.defineClone(name, element);
/**
 * Main entry point
 */ (async function main() {
    const { logInfo: logInfo } = (0, $eKTtn.getLoggers)();
    const qs = (0, $4AFyb.queryState).fromQueryString(document.location.search.substring(1));
    logInfo({
        wrapper: {
            version: qs.sl_version,
            build: qs.sl_build,
            buildTime: qs.sl_buildtime
        }
    });
    // SECURITY (VULN-36931): origin validation is NOT done here (pre-connection).
    // The asserted_origin can't be meaningfully validated before authentication —
    // there's no credential yet — and the pre-auth endpoint isn't browser-callable.
    // Instead the credential is validated at emit time, in getAppEvents' gated
    // sendToken/sendAuthCode (see scripts/events/validate-origin.ts).
    const { port: port, state: state } = qs.wrapper ? await (0, $8Mzka.createConnection)(qs.asserted_origin) : {
        port: (0, $dQqBy.getPostMessagePort)(qs.platform),
        state: $7863be4040c6fabe$var$getStateQS(qs, qs.config)
    };
    const events = (0, $baee8b1a370b4d0b$export$3f41ece7d7128238)(port, qs.wrapper ? {
        client_id: qs.client_id,
        relay: qs.relay,
        asserted_origin: qs.asserted_origin
    } : undefined);
    try {
        const authParams = (0, $4AFyb.queryState).fromObject(state.authParams);
        const config = qs.wrapper ? (0, $71d62a8f878f365f$export$19342e026b58ebb7).safeParse(state.config) : (0, $6745620d6d526b9a$export$19342e026b58ebb7).safeParse(state.config);
        if (!config.success) throw (0, $8Mzka.SentryError).unrecoverable("Failed to parse config.", new (0, $8L18p.default).ZodError(config.error.issues));
        (0, $iqkw9.initializeApplication)({
            queryState: authParams,
            config: config.data,
            events: events,
            eventListener: port instanceof MessagePort ? (0, $8Mzka.startListening)(port) : ()=>{},
            port: port,
            locale: qs.locale
        });
    } catch (e) {
        return (0, $jsjcF.unrecoverableErrorFlow)(events, new (0, $ermYl.CriticalOutcome)((0, $8Mzka.SentryError).unrecoverable("Application initialization error.", (0, $8Mzka.convertError)(e))));
    }
})().catch((e)=>{
    try {
        (0, $jsjcF.unrecoverableErrorFlow)(null, new (0, $ermYl.CriticalOutcome)((0, $8Mzka.SentryError).unrecoverable("Application initialization error.", (0, $8Mzka.convertError)(e))));
    } catch (e) {
        (0, $dQqBy.broadcastLastResortError)(e);
    }
});


//# sourceMappingURL=index.691a7b53.js.map
